import { orderLogicRules } from "./agent/logicExecution";
import { evaluateExpression } from './agent/expressionRuntime';
import React, { useState, useEffect, useCallback, useMemo, useRef } from "react";
import { useParams, useNavigate, json } from "react-router-dom";
// ... other imports
import "./styles/style.css";
import "./styles/reference-design.css";
import "./styles/kaleyra-reference.css";
import "./styles/generated-calculator.css";
import "./styles/insta-cc.css";
// import Config from './Config';
import Svg from "../../../common/Svg";
import { Link } from "react-router-dom";
import { FieldLabel, DropZone } from "@measured/puck";
import ReactEcharts from "echarts-for-react";
import Range from "./Range";
import { Render } from "@measured/puck";
import { ToastContainer, toast } from "react-toastify";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import { initializeApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import {
  patchVisitByEmail,
  searchContactByEmail,
  getVisitByContactId,
  patchVisitProperty,
} from "../../../api/hubspotClient";
import logo_fallback from "../../../assets/images/logo-fallback.svg";
import {
  normalizePuckStructure,
  puckContentItems,
  walkPuckNodes,
  resolveRadioGroupValue,
} from "./puckStructure";

const INLINE_SPAN_UUID_RE = /uuid\s*=\s*["']([0-9a-f-]{36})["']/gi;

function collectInlineSpanUuidsFromValue(value, out) {
  if (value == null) return;
  if (typeof value === "string") {
    let match;
    INLINE_SPAN_UUID_RE.lastIndex = 0;
    while ((match = INLINE_SPAN_UUID_RE.exec(value)) !== null) {
      out.add(match[1]);
    }
    return;
  }
  if (Array.isArray(value)) {
    value.forEach((v) => collectInlineSpanUuidsFromValue(v, out));
    return;
  }
  if (typeof value === "object") {
    Object.values(value).forEach((v) => collectInlineSpanUuidsFromValue(v, out));
  }
}

/** Hint popover for form fields (InstaCC: question text is often a separate Text block with showLabel false). */
function renderRoiFieldHint(hint, hintStyle, { underLabel = false } = {}) {
  if (!hint || !String(hint).trim()) return null;
  const hintEl = (
    <div className={`hint ${hintStyle || "white"}`}>
      <button type="button" className="info" tabIndex={0} aria-label="More information">
        <Svg name="hint-button" />
      </button>
      <div className="popover" dangerouslySetInnerHTML={{ __html: hint }} />
    </div>
  );
  if (underLabel) {
    return <div className="insta-cc-field-hint-row">{hintEl}</div>;
  }
  return hintEl;
}

function registerDisplaySpanVariables(roiGlobalArr, pageStructuresById) {
  const spanIds = new Set();
  Object.values(pageStructuresById || {}).forEach((raw) => {
    try {
      const structure =
        typeof raw === "string" ? JSON.parse(raw) : raw;
      collectInlineSpanUuidsFromValue(structure, spanIds);
    } catch {
      /* ignore malformed page JSON */
    }
  });
  spanIds.forEach((spanUuid) => {
    if (roiGlobalArr[spanUuid]) return;
    roiGlobalArr[spanUuid] = {
      currency: "1",
      count: 0,
      required: false,
      type: "DisplaySpan",
      actions: "",
      action_id: "",
      link: "",
      value: "0",
      default_value: "0",
      hide: "false",
      errorMessage: "",
      variable_data_type: "number",
      roi_page_id: "",
    };
  });
}

function puckButtonTargetId(props) {
  if (!props) return "";
  return String(props.buttonValue || props.PageList || "").trim();
}

/** Register nested Puck fields missed by the shallow zone scan (Columns / Wrapper trees). */
function registerNestedPuckFields(pageStructure, roiGlobalArr, pageId) {
  const zones = pageStructure?.zones || {};
  walkPuckNodes(pageStructure?.content, zones, (node) => {
    const props = node?.props;
    if (!props?.uuid) return;
    const uuid = props.uuid;
    if (roiGlobalArr[uuid]) return;

    const base = {
      count: 0,
      actions: "",
      action_id: "",
      link: "",
      hide: props.hide ?? "false",
      errorMessage: props.errorMessage ?? "",
      roi_page_id: pageId,
      required: props.required ?? false,
    };

    if (node.type === "InputNumberField" || node.type === "InputTextField") {
      roiGlobalArr[uuid] = {
        ...base,
        currency:
          props.Prefix === "currency" || props.prefix === "currency" ? "1" : "0",
        type: node.type,
        value: props.value ?? "",
        default_value: props.default_value ?? "",
      };
      return;
    }
    if (node.type === "Range") {
      roiGlobalArr[uuid] = {
        ...base,
        currency: "0",
        type: "Range",
        value: props.value ?? props.startValue?.value ?? "",
        default_value: props.default_value ?? "",
      };
      return;
    }
    if (node.type === "Radio") {
      roiGlobalArr[uuid] = {
        ...base,
        currency: "0",
        type: "Radio",
        value: resolveRadioGroupValue(props) || "",
        default_value: props.default_value ?? "",
      };
      return;
    }
    if (node.type === "Button") {
      roiGlobalArr[uuid] = {
        ...base,
        currency: "0",
        type: "Button",
        value: props.value ?? "",
        default_value: props.default_value ?? "",
        actions: props.buttonAction ?? "",
        action_id: puckButtonTargetId(props),
        link: props.buttonLink ?? "",
      };
    }
  });
}

const ROIPage = () => {
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const frntUrl = process.env.REACT_APP_FRONT_LINK;
  const marketoEnabled = (process.env.REACT_APP_MARKETO_ENABLE || "").toLowerCase() === "true";
  const marketoEndpoint = process.env.REACT_APP_MARKETO_WEBHOOK || "";
  const { roiId } = useParams();
  const [isIdPresent, setIsIdPresent] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [renderData, setRenderData] = useState(null);
  const [renderModalData, setRenderModalData] = useState(null);
  const [roiPageData, setRoiPageData] = useState(null);
  const [condtionValues, setCondtionValues] = useState([]);
  const [actionId, setActionId] = useState([]);
  //all condtions and actions data
  // const [allCondtionalLogicData, setAllConditionalLogicData] = useState([]);
  const allCondtionalLogicData = useRef([]);
  const [allActionData, setAllActionData] = useState([]);
  // const [currentPageId, setCurrentPageId] = useState(null);
  const currentPageId = useRef(null);
  const [currentPopupPageId, setCurrentPopupPageId] = useState("");
  const [popupStatus, setPopupStatus] = useState(false);
  // const [roipages, setRoipages] = useState({});
  const roipages = useRef({});
  const [roiVariableData, setRoiVaiableData] = useState({});
  // const [roiActionArr, setRoiActionArr] = useState({});
  const roiActionArr_global = useRef({});
  const [roiFlag, setRoiFlag] = useState(false);
  const [language, setLanguage] = useState("");
  const [currency, setCurrency] = useState([]);
  const [defaultCurrency, setDefaultCurrency] = useState("");
  const [changedCurrency, setChangedCurrency] = useState("");
  const [currencySymbol, setCurrencySymbol] = useState("");
  const [exchangeRate, setExchangeRate] = useState("");
  const [locale, setLocale] = useState("");
  // const [globalRoiArr, setGlobalRoiArr] = useState([]);
  const globalRoiArr = useRef([]);
  const elements_by_page_id = useRef({});
  const [changedDropdown, setChangedDropdown] = useState({});
  const [isLoadingdownload, setIsLoadingdownload] = useState(false);
  const [handleModal, setHandleModal] = useState(false);
  const [acceptDecimals, setAcceptDecimals] = useState(false);
  const acceptDecimalsRef = useRef(false);

  const firebaseConfig = useMemo(
    () => ({
      apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
      authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
      storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
      appId: process.env.REACT_APP_FIREBASE_APP_ID,
    }),
    []
  );

  const firebaseAppRef = useRef(null);
  const firebaseAuthRef = useRef(null);

  const getCustomTokenFromURL = useCallback(() => {
    if (typeof window === "undefined") return null;
    const params = new URLSearchParams(window.location.search);
    return params.get("customToken");
  }, []);

  const clearCustomTokenFromURL = useCallback(() => {
    if (typeof window === "undefined") return;
    const url = new URL(window.location.href);
    url.searchParams.delete("customToken");
    window.history.replaceState(null, "", url.toString());
  }, []);

  const getUserAndSaveData = useCallback(
    async (userEmail) => {
      if (!userEmail) return null;
      try {
        const contact = await searchContactByEmail(userEmail);
        if (!contact) {
          console.warn("No HubSpot contact found for email", userEmail);
          return null;
        }
        const properties = contact.properties || {};
        localStorage.setItem("userid", contact.id || "");
        localStorage.setItem("userdata", JSON.stringify(properties));
        // localStorage.setItem("responsedata", JSON.stringify(contact));
        return contact;
      } catch (error) {
        console.error("Error fetching HubSpot contact", error);
        toast.error("Unable to fetch contact details right now.");
        return null;
      }
    },
    []
  );

  // Helper to format numeric values: whole numbers without decimals, decimals with 2 decimal places
  const formatNumericValue = (value) => {
    if (value === null || value === undefined || value === "") return value;
    const num = Number(value);
    if (isNaN(num)) return value; // Not a number, return as-is
    // Handle zero explicitly (0, 0.00, 0.000, etc.)
    if (num === 0) return "0";
    // Check if it's a whole number
    if (Number.isInteger(num)) {
      return String(num); // No decimals for whole numbers
    }
    // Has decimals - show exactly 2 decimal places
    return num.toFixed(2);
  };

  const setFormValuesByUuid = useCallback(
    async (fieldMap = {}) => {
      const entries = Object.entries(fieldMap || {});
      for (const [uuid, rawValue] of entries) {
        const value = formatNumericValue(rawValue);
        const targetPageId =
          roiActionArr_global.current[uuid]?.roi_page_id || currentPageId.current;
        if (roiActionArr_global.current[uuid]) {
          roiActionArr_global.current[uuid] = {
            ...roiActionArr_global.current[uuid],
            value,
          };
        }
        await updateValueByUuid(targetPageId, uuid, value);
      }
    },
    []
  );

  const customButtonMethods = useMemo(
    () => ({
      // Register named methods here, e.g.:
      // exampleMethod: ({ uuid, formValues }) => { console.log(uuid, formValues); },
      checkhubspotlogin: async ({ formValues, action }) => {
        const candidateEmail =
          formValues?.user_email ||
          formValues?.email ||
          localStorage.getItem("user_email");

        console.log("[checkhubspotlogin] formValues:", formValues);

        // Show login popup if no email/token found
        if (!candidateEmail) {
          const popupEl = document.getElementById("token-missing-wrap");
          if (popupEl) {
            popupEl.style.display = "flex";
          }
          return null;
        }

        const contact = await getUserAndSaveData(candidateEmail);
        if (!contact) {
         // alert("HubSpot contact not found or could not be fetched.");
          return contact;
        }

        // Extract contact properties
        const contactProps = contact?.properties || {};
        const firstName = contactProps.firstname || "";
        const lastName = contactProps.lastname || "";
        const email = contactProps.email || candidateEmail;
        const company = contactProps.company || contactProps.organisation || "";
        const designation = contactProps.designation || "Developer";
        // const phone = contactProps.phone || "";
        // const country = contactProps.country || "";
        // const state = contactProps.state || "";

        // Full name (combine first and last)
        const fullName = [firstName, lastName].filter(Boolean).join(" ");

        // console.log("[checkhubspotlogin] Contact data:", {
        //   firstName,
        //   lastName,
        //   fullName,
        //   email,
        //   company,
        //   designation,
        //   phone,
        //   country,
        //   state,
        // });

        await setFormValuesByUuid({
          "e770267c-a42b-421f-9335-defa032eb75e": fullName,
          "61dc3fb2-fa8a-4c2f-a50f-b0a07ad062d5": email,
          "79a00005-dd0a-4de0-ab4d-ca55da9c950c": designation,
          "90546829-19b4-477c-a371-6684e59b4609": company,
        });

         // Optional: navigate to a target page after completion.
        // Use formValues.target_page first, else action.action_id/link.
        const targetPageId = '66ff02b0-b4a4-11f0-965c-9f24b3bde588';
          //alert("targetPageId: " + targetPageId + " formValues: " + formValues);
        if (targetPageId) {
          const ok = await jumpToPage(targetPageId, formValues);
          //alert("jumpToPage result: " + ok);
        }

       

        //alert(`HubSpot contact loaded for ${candidateEmail}`);
        return contact;
      },
    }),
    [getUserAndSaveData]
  );

  const pushMarketoLead = useCallback(
    async (payload) => {
      //alert("pushMarketoLead called: " + JSON.stringify(payload));
      if (!marketoEnabled) return;
      if (!marketoEndpoint) {
        console.warn("Marketo enabled but REACT_APP_MARKETO_WEBHOOK is missing.");
        return;
      }
      try {
        await axios.post(marketoEndpoint, payload);
      } catch (err) {
        console.error("Marketo lead push failed", err);
      }
    },
    [marketoEnabled, marketoEndpoint]
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const token = getCustomTokenFromURL();
    console.log("Firebase custom token handler invoked", { tokenPresent: !!token });
    localStorage.removeItem("user_email");
    if (!token) return;
    if (!firebaseConfig.apiKey) {
      console.warn("Firebase config missing; aborting custom token login.");
      return;
    }

    if (!firebaseAppRef.current) {
      firebaseAppRef.current = initializeApp(firebaseConfig);
      firebaseAuthRef.current = getAuth(firebaseAppRef.current);
    }

    const authInstance = firebaseAuthRef.current;
    signInWithCustomToken(authInstance, token)
      .then(async (userCredential) => {
        console.log("Firebase login successful", userCredential);
        const email = userCredential?.user?.email;
        if (email) {
          localStorage.setItem("user_email", email);
          await getUserAndSaveData(email);
        }
        clearCustomTokenFromURL();
      })
      .catch((err) => {
        const fallback = document.getElementById("went-wrong-wrap");
        if (fallback) {
          fallback.style.display = "block";
        }
        console.error("Firebase login failed", err);
      });
  }, [clearCustomTokenFromURL, firebaseConfig, getCustomTokenFromURL, getUserAndSaveData]);

  // Focus management for tab index
  const [focusedInputId, setFocusedInputId] = useState(null);
  const [pendingChanges, setPendingChanges] = useState({});
  const [isProcessingChanges, setIsProcessingChanges] = useState(false);
  const lastRenderedPageRef = useRef(null);

  const CurrencyFormatter = ({ amount }) => {
    const formattedAmount = amount.toLocaleString(locale, {
      style: "currency",
      currency: changedCurrency == "" ? defaultCurrency : changedCurrency,
    });
    return formattedAmount;
  };

  /*****Year and VBUC******/
  const [selectedCompany, setSelectedCompany] = useState("vbuc");
  const [selectedYear, setSelectedYear] = useState("year1");

  const handleCompanyChange = (e) => {
    setSelectedCompany(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  // const getDataSection = () => {
  //     if (selectedCompany === 'vbuc' && selectedYear === 'year1') {
  //         return <ReactEcharts style={chartStyle} option={pieChart()} />;
  //     }
  //     if (selectedCompany === 'vbuc' && selectedYear === 'year3') {
  //         return <ReactEcharts style={chartStyle} option={VBUCYear3Options} />;
  //     }
  //     if (selectedCompany === 'microsoft' && selectedYear === 'year1') {
  //         return <ReactEcharts style={chartStyle} option={MicrosoftYear1Options} />;
  //     }
  //     if (selectedCompany === 'microsoft' && selectedYear === 'year3') {
  //         return <ReactEcharts style={chartStyle} option={MicrosoftYear3Options} />;
  //     }
  // };

  const pieChart = (items) => {

    // Transform items to match the required series data format
    const seriesData = items.map((item) => ({
      value: parseFloat(item.value), // Convert value to a number if it's a string
      name: item.Text,
      symbol: currencySymbol,
      formatted: CurrencyFormatter({ amount: parseFloat(item.value) }),
    }));

    // Extract colors from items
    const colors = items.map((item) => item.Color);

    return {
      tooltip: {
        trigger: "item",

        formatter: function (params) {
          return `${params.seriesName}<br />
                        ${params.data.name}:  ${params.data.formatted} `;
        },
      },
      grid: {
        left: "30%",
        right: "4%",
        bottom: "10%",
        containLabel: true,
      },
      series: [
        {
          name: "Cost savings over yearly vs average",
          type: "pie",
          radius: "80%",
          color: colors, // Use the extracted colors
          data: seriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.5)",
            },
          },
        },
      ],
    };
  };

  const pieEChart = (items, title, subtext) => {
    let totalValue = 0;
    for (let i = 0; i < items.length; i++) {
      totalValue += parseFloat(items[i].value);
    }

    // Transform items to match the required series data format
    const seriesData = items.map((item) => ({
      value: parseFloat(item.value), // Convert value to a number if it's a string
      name: item.Text,
      symbol: currencySymbol,
      formatted: CurrencyFormatter({ amount: parseFloat(item.value) }),
    }));

    // Extract colors from items
    const colors = items.map((item) => item.Color);
    const legend = items.map((item) => item.Text);

    return {
      tooltip: {
        trigger: "item",
        formatter: "{b}: {c} ({d}%)", // Shows name, value, and percentage
      },
      legend: {
        orient: "horizontal",
        left: "center",
        bottom: "0", // Adjust as needed for vertical position
        data: legend, // Matches the names in series.data
        itemGap: 50, // Space between legend items
        itemWidth: 15, // <--- ADD THIS: Width of the colored box (e.g., 15 pixels)
        itemHeight: 15, // <--- ADD THIS: Height of the colored box (e.g., 15 pixels)
      },
      // title is used for the text in the center of the donut
      title: {
        text: title, // The main number
        subtext: totalValue, // The text below the number
        left: "center",
        top: "42%", // Position in the middle of the chart

        textStyle: {
          fontSize: 14, // Adjust font size for "Total Licenses"
          fontWeight: "normal",
          color: "#666", // Adjust color as needed
        },
        subtextStyle: {
          fontSize: 36, // Adjust font size for "450"
          fontWeight: "bold",
          color: "#333", // Adjust color as needed
        },
      },
      series: [
        {

          type: "pie",
          // To make it a donut chart, radius is an array: [innerRadius, outerRadius]
          // Adjust these percentages for the desired thickness of the donut
          radius: ["40%", "75%"],
          center: ["50%", "50%"], // Ensure chart is centered if title is also centered
          avoidLabelOverlap: false, // Important for custom label positioning
          color: colors, // Purple, Orange, Teal
          data: seriesData,
          label: {
            show: true,
            position: "outside",
            formatter: "{c}", // Show the value (count) on the label
            color: "#333", // Label text color
            fontSize: 12,
            // distanceToLabelLine: 5, // Optional: adjust space between label and line start
          },
          labelLine: {
            show: true,
            length: 15, // Length of the first part of the line
            length2: 10, // Length of the second part of the line (after the jog)
            smooth: false, // Use straight lines
          },
          emphasis: {
            // Style when hovering over a slice
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.3)",
            },
            label: {
              // Optional: make label more prominent on hover
              show: true,
              fontSize: "14",
              fontWeight: "bold",
            },
          },
          // The `top` property from your original series is removed as `center` and `title` positioning handles it.
        },
      ],
      // The `grid` option is generally not needed for pie charts, but keeping it won't harm.
      // You can remove it if you prefer.
      grid: {
        left: "5%", // Adjusted to give more space if labels are long
        right: "5%",
        bottom: "15%", // Ensure space for the legend
        containLabel: true,
      },
    };
  };


  const barEChart = (items, title, subtext) => {
    // Prepare series
    const series = items.map((item) => ({
      name: item.Text,
      type: "bar",
      barWidth: 40, // Match BarChartOptions
      data: [parseFloat(item.value)], // Single value per series
      itemStyle: {
        color: item.Color,
        borderRadius: [5, 5, 0, 0], // Match BarChartOptions
      },
      emphasis: { focus: "series" },
      label: {
        show: true,
        position: "top",
        formatter: "{c}",
        color: "#333",
        fontSize: 12,
      },
    }));

    const legend = items.map((item) => item.Text);

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        // Optionally, use the same formatter as BarChartOptions
      },
      legend: {
        show: true,
        data: legend,
        bottom: "0",
        left: "center",
        itemGap: 15,
        itemWidth: 12,
        itemHeight: 12,
        icon: "circle",
        textStyle: {
          color: "#595959",
          fontSize: 13,
        },
      },
      grid: {
        left: "3%",
        top: "10%",
        right: "4%",
        bottom: "35%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: [""], // Single group
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false },
        },
      ],
      yAxis: [
        {
          type: "value",
          min: 0,
          // Optionally set max and interval as in BarChartOptions
          axisLabel: {
            color: "#595959",
            fontSize: 14,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#E0E0E0",
            },
          },
        },
      ],
      series,
    };
  };

  // For Download Report

  const OneYearChartOptions = {
    tooltip: {
      trigger: "item",
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    grid: {
      left: "30%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    series: [
      {
        name: "Actual Benefits with Vodafone",
        type: "pie",
        radius: "50%",
        color: ["#9C2AA0", "#EB9700", "#00B0CA"], // Specify colors for the pie slices here
        data: [
          { value: 1048, name: "Lower Costs" },
          { value: 735, name: "Increase Productivity" },
          { value: 580, name: "Enable Business" },
        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    ],
  };

  const ThreeYearChartOptions = {
    tooltip: {
      trigger: "axis",
      axisPointer: {
        type: "shadow",
      },
    },
    legend: {
      orient: "vertical",
      left: "left",
    },
    grid: {
      left: "0%",
      top: "30%",
      right: "4%",
      bottom: "3%",
      containLabel: true,
    },
    xAxis: [
      {
        type: "category",
        data: ["2022", "2023", "2024"],
      },
    ],
    yAxis: [
      {
        type: "value",
      },
    ],
    series: [
      {
        name: "Lower Costs",
        type: "bar",
        stack: "Ad",
        barWidth: "60",
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          color: "#9C2AA0", // Apply purple color here
        },
        data: [120, 132, 101, 134, 90, 230, 210],
      },
      {
        name: "Increase Productivity",
        type: "bar",
        stack: "Ad",
        barWidth: "60",
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          color: "#EB9700", // Apply orange color here
        },
        data: [220, 182, 191, 234, 290, 330, 310],
      },
      {
        name: "Enable Business",
        type: "bar",
        stack: "Ad",
        barWidth: "60",
        emphasis: {
          focus: "series",
        },
        itemStyle: {
          color: "#00B0CA", // Apply cyan color here
        },
        data: [150, 232, 201, 154, 190, 330, 410],
      },
    ],
  };

  const chartStyle = {
    height: "200px",
    width: "100%",
  };

  const PieChartOptions = {
    tooltip: {
      trigger: "item",
      formatter: "{b}: {c} ({d}%)", // Shows name, value, and percentage
    },
    legend: {
      orient: "horizontal",
      left: "center",
      bottom: "0", // Adjust as needed for vertical position
      data: ["Basic", "Standard", "Premium"], // Matches the names in series.data
      itemGap: 50, // Space between legend items
      itemWidth: 15, // <--- ADD THIS: Width of the colored box (e.g., 15 pixels)
      itemHeight: 15, // <--- ADD THIS: Height of the colored box (e.g., 15 pixels)
    },
    // title is used for the text in the center of the donut
    title: {
      text: "Total Licenses", // The main number
      subtext: "450", // The text below the number
      left: "center",
      top: "42%", // Position in the middle of the chart

      textStyle: {
        fontSize: 14, // Adjust font size for "Total Licenses"
        fontWeight: "normal",
        color: "#666", // Adjust color as needed
      },
      subtextStyle: {
        fontSize: 36, // Adjust font size for "450"
        fontWeight: "bold",
        color: "#333", // Adjust color as needed
      },
    },
    series: [
      {
        name: "Licenses", // A name for the series, appears in tooltips
        type: "pie",
        // To make it a donut chart, radius is an array: [innerRadius, outerRadius]
        // Adjust these percentages for the desired thickness of the donut
        radius: ["40%", "75%"],
        center: ["50%", "50%"], // Ensure chart is centered if title is also centered
        avoidLabelOverlap: false, // Important for custom label positioning
        color: ["#9C2AA0", "#EB9700", "#00B0CA"], // Purple, Orange, Teal
        data: [
          { value: 250, name: "Premium" }, // Corresponds to #9C2AA0 (Purple)
          { value: 100, name: "Standard" }, // Corresponds to #EB9700 (Orange)
          { value: 100, name: "Basic" }, // Corresponds to #00B0CA (Teal)
        ],
        label: {
          show: true,
          position: "outside",
          formatter: "{c}", // Show the value (count) on the label
          color: "#333", // Label text color
          fontSize: 12,
          // distanceToLabelLine: 5, // Optional: adjust space between label and line start
        },
        labelLine: {
          show: true,
          length: 15, // Length of the first part of the line
          length2: 10, // Length of the second part of the line (after the jog)
          smooth: false, // Use straight lines
        },
        emphasis: {
          // Style when hovering over a slice
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.3)",
          },
          label: {
            // Optional: make label more prominent on hover
            show: true,
            fontSize: "14",
            fontWeight: "bold",
          },
        },
        // The `top` property from your original series is removed as `center` and `title` positioning handles it.
      },
    ],
    // The `grid` option is generally not needed for pie charts, but keeping it won't harm.
    // You can remove it if you prefer.
    grid: {
      left: "5%", // Adjusted to give more space if labels are long
      right: "5%",
      bottom: "15%", // Ensure space for the legend
      containLabel: true,
    },
  };

  const BarChartOptions = {
    tooltip: {
      axisPointer: {
        type: "shadow",
      },
      // The default tooltip formatter for 'axis' trigger will list all series.
    },
    legend: {
      show: true,
      data: [
        "Remote Workers",
        "Office Workers",
        "On the Road Workers",
        "Hybrid Workers",
      ], // Derived from series names
      bottom: "0", // Or '5%' or adjust as needed
      left: "center",
      itemGap: 15,
      itemWidth: 12,
      itemHeight: 12,
      icon: "circle", // Make all legend icons circles
      textStyle: {
        color: "#595959", // Matching image text color
        fontSize: 13,
      },
    },
    grid: {
      left: "3%", // Adjust if y-axis labels need more or less space
      top: "5%", // Space from the top
      right: "4%", // Space from the right
      bottom: "35%", // Ample space for the legend below the x-axis area
      containLabel: true, // Ensures labels (like y-axis) fit
    },
    xAxis: [
      {
        type: "category",
        // Using an empty string or a non-displaying character for a single grouping point
        // if you don't want any visible x-axis label below the bars.
        // Or, if each bar IS a category, then it should be:
        // data: ['Remote Workers', 'Office Workers', 'On the Road Workers', 'Hybrid Workers'],
        // However, to match the *visual* of a single group of 4 bars,
        // and have the legend define what each bar is:
        data: [""], // A single, empty category to group the bars
        axisTick: { show: false },
        axisLine: { show: false },
        axisLabel: { show: false }, // No visible x-axis labels
      },
    ],
    yAxis: [
      {
        type: "value",
        min: 0,
        max: 100,
        interval: 25,
        axisLabel: {
          margin: 10,
          color: "#595959", // Matching image text color
          fontSize: 14,
        },
        axisLine: { show: false },
        axisTick: { show: false },
        splitLine: {
          show: true,
          lineStyle: {
            type: "dashed",
            color: "#E0E0E0", // Lighter dashed lines
          },
        },
      },
    ],
    series: [
      {
        name: "Remote Workers",
        type: "bar",
        barWidth: 40, // Fixed width for each bar
        // barGap: '30%', // Optional: space between bars of different series (within same category)
        itemStyle: {
          color: "#A5B83C", // Olive Green
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [68], // Value for the single x-axis category ''
      },
      {
        name: "Office Workers",
        type: "bar",
        barWidth: 40,
        itemStyle: {
          color: "#00B0CA", // Teal
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [88],
      },
      {
        name: "On the Road Workers",
        type: "bar",
        barWidth: 40,
        itemStyle: {
          color: "#9C2AA0", // Purple
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [43],
      },
      {
        name: "Hybrid Workers",
        type: "bar",
        barWidth: 40,
        itemStyle: {
          color: "#EB9700", // Orange
          borderRadius: [5, 5, 0, 0],
        },
        emphasis: { focus: "series" },
        data: [76],
      },
    ],
  };

  // FormNav3 Component with scroll and active state logic
  const FormNav3Component = ({ items }) => {
    const [activeIndex, setActiveIndex] = useState(items.length > 0 ? 0 : -1);

    const handleStepClick = (e, item, index) => {
      e.preventDefault();

      // Update active state
      setActiveIndex(index);

      // Scroll to target element with 70px offset
      const targetElement = document.getElementById(item.targetID);
      if (targetElement) {
        const elementPosition = targetElement.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - 70;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }
    };

    return (
      <>
        {/* Wizard Progress Steps */}
        <div className="wizard-progress">
          <div className="wizard-steps">
            {items.map((item, i) => (
              <a
                href={`#${item.targetID}`}
                key={i}
                className={`wizard-step ${i === activeIndex ? '' : ''}`}
                onClick={(e) => handleStepClick(e, item, i)}
              >
                <div className="step-circle">
                  <span>{i + 1}</span>
                </div>
                <div className="step-label">{item.Title}</div>
              </a>
            ))}
          </div>
        </div>
      </>
    );
  };

  // Create Puck component config
  const config = {
    categories: {
      Banner: {
        components: ["BannerLeftTextRightImage", "BannerCenterText"],
      },

      Cards: {
        components: ["CardLayout1", "CardLayout2"],
      },
    },

    components: {
      //Header Components
      PageHeader: {
        render: ({
          logo,
          items,
          hide,
          showCurrencyDropdown,
          showRecalculateButton,
          showLanguageDropdown,
          transparentHeader,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;



          return (
            <div
              className={`roi-header-main ${transparentHeader && "header-transparent"
                }`}
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  {/* <a href="" className="logo">
                                        <img src={logo} alt="" onClick={homeRedirect} />
                                    </a> */}
                  <a
                    href="#"
                    className="logo"
                    data-bs-toggle="modal"
                    data-bs-target="#logoPrompt"
                  >
                    {logo ? (
                      <img src={logo} alt="" />
                    ) : (
                      <img src={logo_fallback} alt="" />
                    )}
                  </a>
                  <div className="nav-menu">
                    <ul>
                      {items?.map((item, i) => (
                        <li
                          key={i}
                          onClick={() => jumpToPage(item.buttonValue)}
                        >
                          <Link
                            to=""
                            className={item.activeStatus == 1 ? "active" : ""}
                          >
                            {item.Text}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                  <div className="space">
                    {showCurrencyDropdown || showLanguageDropdown || showRecalculateButton ? (
                      <div className="d-flex currency-language">
                        {showRecalculateButton && <>
                          <button className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3 px-3"
                            //onClick={handleRecalculateClick}
                            data-bs-toggle="modal"
                            data-bs-target="#logoPrompt">

                            <Svg name="roi-recalculate-icon" /> Start Over

                          </button>
                        </>}
                        {showLanguageDropdown && (
                          <div className="lang-wrap">
                            <Svg name="language-globe" />
                            <select className="language">
                              <option value="1">English</option>
                              <option value="2">Spanish</option>
                            </select>
                          </div>
                        )}
                        {showCurrencyDropdown && (
                          <select
                            className="currency"
                            onChange={(e) => currencyChange(e)}
                          >
                            <option
                              value={defaultCurrency}
                              selected={
                                changedCurrency == "" ||
                                  changedCurrency == defaultCurrency
                                  ? "selected"
                                  : ""
                              }
                            >
                              {defaultCurrency}
                            </option>
                            {currency.map((item, i) => (
                              <option
                                value={item}
                                selected={
                                  changedCurrency == item ? "selected" : ""
                                }
                                key={i}
                              >
                                {item}
                              </option>
                            ))}
                          </select>
                        )}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        },
      },

      PageHeader2: {

        render: ({ logo1, logo2, logo3, absolutePosition, whiteHeader }) => {
          const src1 = logo1 && String(logo1).trim() ? logo1 : logo_fallback;
          const src2 = logo2 && String(logo2).trim() ? logo2 : null;
          const src3 = logo3 && String(logo3).trim() ? logo3 : null;
          return (
            <div className={`tco-header-main ${absolutePosition && 'absolute-position'} ${whiteHeader && 'header-white'}`}>
              <div className="tco-container">
                <div className="header-wrapper-top">
                  <span className="logo">
                    <img src={src1} alt="" />
                  </span>
                  {src2 ? (
                    <span className="logo">
                      <img src={src2} alt="" />
                    </span>
                  ) : null}
                </div>
                {src3 ? (
                  <div className="header-wrapper-bottom">
                    <span className="logo">
                      <img src={src3} alt="" />
                    </span>
                  </div>
                ) : null}
              </div>
            </div>
          )
        },
      },



      PageHeaderTransparent: {
        render: ({ logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <div
              className="roi-header-transparent"
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  <a className="logo">
                    <img src={logo} alt="" />
                  </a>
                </div>
              </div>
            </div>
          );
        },
      },

      // Banner Layouts
      BannerLeftTextRightImage: {
        render: ({
          Heading,
          Description,
          Button,
          Padding,
          Style,
          image,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-banner-section position-relative ${Padding.bottom
                  } ${Padding.top} ${Style} ${Padding.fullHeight && "full-height"
                  }`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="row align-items-center ">
                    <div className="col-lg-6">
                      <div className="banner-text">
                        <h1
                          className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}
                        >
                          {Heading.title}
                        </h1>

                        <div className="text-part">
                          <div
                            className={Description.descriptionFont}
                            dangerouslySetInnerHTML={{
                              __html: Description.text,
                            }}
                          ></div>
                        </div>

                        <div className="button-wrap">
                          {Button.buttonicon === "yes" ? (
                            <button
                              onClick={() => onButtonClick(Button.uuid)}
                              className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              <span className="with-icon">
                                {Button.buttonText}
                              </span>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </button>
                          ) : (
                            <button
                              onClick={() => onButtonClick(Button.uuid)}
                              className={`btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              {Button.buttonText}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="img-wrapper">
                        <img src={image} className="img-fluid" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      BannerCenterText: {
        render: ({
          Heading,
          Description,
          Button,
          Padding,
          image,
          Style,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-banner-section position-relative banner-center-text ${Style} ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{
                  backgroundImage: `url("${image}")`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  opacity: inputOpacity,
                }}
              >
                <div className="overlay"></div>
                <div className="container position-relative">
                  <div className="row align-items-center justify-content-center">
                    <div className="col-lg-8">
                      <div className="banner-text text-center">
                        <h1
                          className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                        >
                          {Heading.title}
                        </h1>

                        <div className="text-part">
                          <div
                            className={Description.descriptionFont}
                            dangerouslySetInnerHTML={{
                              __html: Description.text,
                            }}
                          ></div>
                        </div>

                        <div className="button-wrap">
                          {Button.buttonicon === "yes" ? (
                            <button
                              className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              <span className="with-icon">
                                {Button.buttonText}
                              </span>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </button>
                          ) : (
                            <button
                              className={`btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              {Button.buttonText}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Cards Layouts
      CardLayout1: {
        render: ({
          Heading,
          Description,
          Padding,
          Card1,
          Card2,
          Card3,
          Card4,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-cards-section card-layout-1 position-relative ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="card-nav-outer">
                  <div className="container">
                    <div className="card-nav d-flex align-items-center justify-content-between">
                      {/* <div className="card-prev text-start">
                                                <button className='prev-btn card-btn'>Back</button>
                                            </div> */}

                      <div className="card-next text-end">
                        {/**Only Hide button in case not to be shown**/}
                        {/* <button className='next-btn card-btn'>Next</button> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container position-relative">
                  <div className="section-heading mb-3 mb-md-5 text-center">
                    <h2
                      className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                    >
                      {Heading.title}
                    </h2>
                    <p className={Description.descriptionFont}>
                      {Description.text}
                    </p>
                  </div>

                  <div className="cards-wrapper">
                    <div className="row justify-content-center">
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div
                          className="card-outer"
                          onClick={() => onButtonClick(Card1.uuid)}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4>{Card1.title}</h4>
                              <p>{Card1.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div
                          className="card-outer"
                          onClick={() => onButtonClick(Card2.uuid)}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4>{Card2.title}</h4>
                              <p>{Card2.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Card3 != undefined && Card3 != null && (
                        <div className="col-lg-4 col-md-6 mb-3">
                          <div
                            className="card-outer"
                            onClick={() => onButtonClick(Card3.uuid)}
                          >
                            <div className="card-inner">
                              <div className="text-wrapper">
                                <h4>{Card3.title}</h4>
                                <p>{Card3.text}</p>
                              </div>
                              <div className="button-wrapper">
                                <button className="btn btn-action">
                                  <Svg name="roi-card-button" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {Card4 != undefined && Card4 != null && (
                        <div className="col-lg-4 col-md-6 mb-3">
                          <div
                            className="card-outer"
                            onClick={() => onButtonClick(Card4.uuid)}
                          >
                            <div className="card-inner">
                              <div className="text-wrapper">
                                <h4>{Card4.title}</h4>
                                <p>{Card4.text}</p>
                              </div>
                              <div className="button-wrapper">
                                <button className="btn btn-action">
                                  <Svg name="roi-card-button" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      CardLayout2: {
        render: ({
          Heading,
          Description,
          Padding,
          Card1,
          Card2,
          Card3,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-cards-section card-layout-2 position-relative ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="section-heading mb-3 mb-md-5 text-center">
                    <h2
                      className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                    >
                      {Heading.title}
                    </h2>
                    <p className={Description.descriptionFont}>
                      {Description.text}
                    </p>
                  </div>
                  <div className="cards-wrapper">
                    <div className="row justify-content-center">
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card1.title}</h4>
                              <p>{Card1.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card2.title}</h4>
                              <p>{Card2.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card3.title}</h4>
                              <p>{Card3.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Form Layouts
      SinglePage: {
        render: ({ Heading, Description, Padding, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <DropZone zone="nav-wrapper" allow={["FormNav"]} />
                  <div className="form-wrapper">
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.descriptionFont}>
                        {Description.text}
                      </p>
                    </div>
                    <div className="form-inner">
                      <DropZone
                        zone="form-wrapper"
                        disallow={["SinglePage", "WizardForm"]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      FormNav: {
        render: ({ items, hide }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <ul className="nav nav-tabs nav-tabs-single">
                {items.map((item, i) => (
                  <li className="nav-item" role="presentation" key={i}>
                    {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                    <button
                      onClick={() => onButtonClick(item.uuid)}
                      className={
                        item.isActive == true ? "nav-link active" : "nav-link"
                      }
                    >
                      {item.Title}
                    </button>
                  </li>
                ))}
              </ul>
            </>
          );
        },
      },
      FormNav2: {

        render: ({ items, hide }) => {
          const inputOpacity = hide ? 0.5 : 1;

          // Calculate progress percentage
          const totalSteps = items.length;
          const completedSteps = items.filter(item => item.isDone).length;
          const progressPercentage = totalSteps > 0 ? (completedSteps / totalSteps) * 100 : 0;

          return (
            <>
              {/* Wizard Progress Steps */}
              <div className="wizard-progress" style={{ opacity: inputOpacity }}>
                <div className="wizard-steps">
                  {items.map((item, i) => (
                    <div key={i} className={`wizard-step ${item.isDone ? 'completed' : ''} ${item.isActive ? 'active' : ''}`}>
                      <div className="step-circle">
                        {item.isDone ? (
                          <svg xmlns="http://www.w3.org/2000/svg" width={16} height={12} viewBox="0 0 16 12" fill="none">
                            <path d="M1.37207 4.63043L6.18052 9.43888L14.532 1.08736" stroke="white" strokeWidth={3} />
                          </svg>

                        ) : (
                          <span>{i + 1}</span>
                        )}
                      </div>
                      <div className="step-label">{item.Title}</div>
                      {i < items.length - 1 && (
                        <div className={`step-connector ${item.isDone ? 'completed' : ''}`}></div>
                      )}
                    </div>
                  ))}
                </div>


              </div>


            </>
          )
        },
      },

      FormNav3: {
        render: ({ items }) => {
          return <FormNav3Component items={items} />;
        },
      },


      WizardForm: {
        render: ({ Padding, items, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {items.map((item, i) => (
                      <li className="nav-item" role="presentation" key={i}>
                        {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                        <button
                          className={i === 0 ? "nav-link active" : "nav-link"}
                          id={`tab-${i}`}
                          data-bs-toggle="tab"
                          data-bs-target={`#tab-${i}-pane`}
                          type="button"
                          role="tab"
                          aria-controls={`tab-${i}-pane`}
                          aria-selected="false"
                        >
                          {item.Title}
                        </button>
                      </li>
                    ))}
                  </ul>
                  <div className="form-wrapper">
                    <div className="tab-content" id="myTabContent">
                      {items.map((item, i) => (
                        <div
                          key={i}
                          className={
                            i === 0
                              ? "tab-pane fade show active"
                              : "tab-pane fade"
                          }
                          id={`tab-${i}-pane`}
                          role="tabpanel"
                          aria-labelledby={`tab-${i}`}
                          tabIndex={0}
                        >
                          <div className="section-heading mb-3 mb-md-4">
                            <h2 className={`heading fw-700 fs-40`}>
                              {item.Title}
                            </h2>
                            <p className="fs-22">{item.Description}</p>
                          </div>
                          <div className="form-inner">
                            <DropZone
                              zone={`wizard-form-wrapper-${i}`}
                              disallow={["SinglePage", "WizardForm"]}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Form Elements

      InputTextField: {
        render: ({
          label,
          showLabel,
          disableEditing,
          value,
          placeholder,
          required,
          errorMessage,
          hint,
          hintStyle,
          hide,
          Prefix,
          uuid,
          tabIndex,
          Style,
          Font,
          Border,
          Padding,
          Margin,
        }) => {
          // Render nothing if hide is true
          if (hide == true || hide == 'true') {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label" htmlFor={uuid}>
                    <span dangerouslySetInnerHTML={{ __html: label }} /> {required && <span className="required">*</span>}{" "}
                    {renderRoiFieldHint(hint, hintStyle)}
                  </label>
                )}
                {!showLabel && renderRoiFieldHint(hint, hintStyle, { underLabel: true })}
                <div className="position-relative">
                  {(() => {
                    if (Prefix === "currency") {
                      return (
                        <input
                          autoComplete="off"
                          {...(disableEditing ? { disabled: true } : {})}
                          type={"text"}
                          className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                            } ${errorMessage ? "error" : ""}`}
                          placeholder={placeholder}
                          // value={roiActionArr[uuid] ? ((roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : value) : value}
                          defaultValue={CurrencyFormatter({
                            amount: parseFloat(value),
                          }).normalize()}
                          id={uuid}
                          tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          required={required}
                          onFocus={handleInputFocus}
                          onBlur={(e) => handleInputBlur(uuid, e, required)}
                          style={{
                            backgroundColor: `${Style?.BackgroundColor}`,
                            color: `${Style?.Color}`,

                            padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                            borderStyle: `${Border?.BorderStyle}`,
                            borderColor: `${Border?.BorderColor}`,
                            borderWidth: `${Border?.BorderWidth}px`,
                            borderRadius: `${Border?.BorderRadius}px`,
                            height: `${Style?.Height}px`,
                            textAlign: Font?.Align,
                          }}
                        />
                      );
                    } else {
                      return (
                        <input
                          autoComplete="off"
                          {...(disableEditing ? { disabled: true } : {})}
                          type={"text"}
                          className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                            } ${errorMessage ? "error" : ""}`}
                          placeholder={placeholder}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          defaultValue={value}
                          id={uuid}
                          tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          required={required}
                          onFocus={handleInputFocus}
                          onBlur={(e) => handleInputBlur(uuid, e, required)}
                          style={{
                            backgroundColor: `${Style?.BackgroundColor}`,
                            color: `${Style?.Color}`,

                            padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                            borderStyle: `${Border?.BorderStyle}`,
                            borderColor: `${Border?.BorderColor}`,
                            borderWidth: `${Border?.BorderWidth}px`,
                            borderRadius: `${Border?.BorderRadius}px`,
                            height: `${Style?.Height}px`,
                            textAlign: Font?.Align,
                            display: `${Style?.Display}`,
                          }}
                        />
                      );
                    }
                  })()}
                </div>

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      InputNumberField: {
        render: ({
          label,
          showLabel,
          disableEditing,
          value,
          placeholder,
          required,
          errorMessage,
          hint,
          hintStyle,
          hide,
          Prefix,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid,
          tabIndex,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    <span dangerouslySetInnerHTML={{ __html: label }} /> {required && <span className="required">*</span>}{" "}
                    {renderRoiFieldHint(hint, hintStyle)}
                  </label>
                )}
                {!showLabel && renderRoiFieldHint(hint, hintStyle, { underLabel: true })}
                <div className="position-relative">
                  {Prefix == "none" && (
                    <input
                      autoComplete="off"
                      {...(disableEditing ? { disabled: true } : {})}
                      type="number"
                      min="0"
                      className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                        } ${errorMessage ? "error" : ""}`}
                      placeholder={placeholder}
                      defaultValue={value}
                      id={uuid}
                      tabIndex={tabIndex ?? ""}
                      required={required}
                      onFocus={handleInputFocus}
                      onBlur={(e) => handleInputBlur(uuid, e, required)}
                      onWheel={handleWheelPrevention}
                      onMouseWheel={handleWheelPrevention}
                      onKeyDown={preventScrollAndArrowKeys}
                      style={{
                        backgroundColor: `${Style?.BackgroundColor}`,
                        color: `${Style?.Color}`,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                        borderStyle: `${Border?.BorderStyle}`,
                        borderColor: `${Border?.BorderColor}`,
                        borderWidth: `${Border?.BorderWidth}px`,
                        borderRadius: `${Border?.BorderRadius}px`,
                        height: `${Style?.Height}px`,
                        textAlign: Font?.Align,
                        pointerEvents: 'auto',
                      }}
                    />
                  )}

                  {Prefix == "%" && (
                    <div className="input-group percent">
                      <input
                        autoComplete="off"
                        {...(disableEditing ? { disabled: true } : {})}
                        type="number"
                        min="0"
                        className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                          } ${errorMessage ? "error" : ""}`}
                        placeholder={placeholder}
                        defaultValue={value}
                        tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                        required={required}
                        onFocus={handleInputFocus}
                        onBlur={(e) => handleInputBlur(uuid, e)}
                        onWheel={handleWheelPrevention}
                        onMouseWheel={handleWheelPrevention}
                        onKeyDown={preventScrollAndArrowKeys}
                        style={{
                          backgroundColor: `${Style?.BackgroundColor}`,
                          color: `${Style?.Color}`,
                          padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                          borderStyle: `${Border?.BorderStyle}`,
                          borderColor: `${Border?.BorderColor}`,
                          borderWidth: `${Border?.BorderWidth}px`,
                          borderRadius: `${Border?.BorderRadius}px`,
                          height: `${Style?.Height}px`,
                          textAlign: Font?.Align,
                          pointerEvents: 'auto',
                        }}
                      />
                      <span
                        className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize}`}
                        style={{
                          color: `${Style?.Color}`,
                        }}
                      >
                        %
                      </span>
                    </div>
                  )}

                  {Prefix == "currency" && (
                    <div className="input-group currency">
                      <span
                        className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize}`}
                        style={{
                          color: `${Style?.Color}`,
                        }}
                        dangerouslySetInnerHTML={{ __html: currencySymbol }}
                      ></span>
                      {/**Change this currency depending upon default currency**/}
                      <input
                        {...(disableEditing ? { disabled: true } : {})}
                        type="number"
                        min="0"
                        className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                          } ${errorMessage ? "error" : ""}`}
                        placeholder={placeholder}
                        defaultValue={value}
                        tabIndex={Number.isInteger(tabIndex) ? tabIndex : undefined}
                        required={required}
                        onFocus={handleInputFocus}
                        onBlur={(e) => handleInputBlur(uuid, e)}
                        onWheel={handleWheelPrevention}
                        onMouseWheel={handleWheelPrevention}
                        onKeyDown={preventScrollAndArrowKeys}
                        style={{
                          backgroundColor: `${Style?.BackgroundColor}`,
                          color: `${Style?.Color}`,
                          padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                          borderStyle: `${Border?.BorderStyle}`,
                          borderColor: `${Border?.BorderColor}`,
                          borderWidth: `${Border?.BorderWidth}px`,
                          borderRadius: `${Border?.BorderRadius}px`,
                          height: `${Style?.Height}px`,
                          textAlign: Font?.Align,
                          pointerEvents: 'auto',
                        }}
                      />
                    </div>
                  )}
                </div>

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      TextareaField: {
        render: ({
          label,
          value,
          placeholder,
          required,
          errorMessage,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          showLabel,
          uuid
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <textarea
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                    } ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  required={required}
                  value={value}
                  id={uuid}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    color: `${Style?.Color}`,

                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                    textAlign: Font?.Align,
                  }}
                />

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Dropdown: {
        render: ({
          label,
          showLabel,
          required,
          errorMessage,
          items,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid,
        }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <select
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize
                    } ${errorMessage ? "error" : ""}`}
                  onChange={(e) => handleDropdownChange(uuid, e)}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    backgroundSize: `${Style?.DropdownSize}px`,
                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                  }}
                  defaultValue={changedDropdown[uuid]}
                >
                  <option value>--Select--</option>
                  {items.map((item, i) => (
                    <option key={i} value={item.Option}>
                      {item.Option}
                    </option>
                  ))}
                </select>

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Checkbox: {
        render: ({
          label,
          required,
          errorMessage,
          items,
          ID,
          hide,
          Margin,
          Style,
          uuid
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;
          let main_value = 0;

          items.map((item, i) => {
            if (item.value == 1) {
              main_value = item.value;
            }
          })
          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}

                <div className="roi-check-wrap">
                  {items.map((item, i) => (
                    <div key={i}>
                      <label className="form-check" htmlFor={`${ID}-${i}`} >
                        <input
                          autoComplete="off"
                          id={`${ID}-${i}`}
                          className="form-check-input"
                          name={ID}
                          type="checkbox"
                          checked={item.value == 1 ? true : false}
                          onChange={() => onCheckBoxClick(item.uuid)}
                        />
                        <span className="form-check-label" dangerouslySetInnerHTML={{ __html: item.Option }} />

                      </label>
                      {
                        (items.length == 1 && required && item.value != 1) && (
                          <div className="input-error">{errorMessage}</div>
                        )
                      }

                    </div>
                  ))}
                </div>
                {items.length > 1 && required && main_value != 1 && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      //  Radio component
      Radio: {
        render: ({
          label,
          showLabel,
          required,
          errorMessage,
          items,
          ID,
          hide,
          uuid,
          value,
          hint,
          hintStyle,
          Layout,
          CustomClass,
        }) => {
          if (hide) {
            return null;
          }
          const inputOpacity = hide ? 0.5 : 1;
          const layout = Layout && typeof Layout === "object" ? Layout : {};
          const isCardLayout = layout.version === "card";
          const isUnstacked = layout.direction === "unstacked";
          const showFieldLabel = showLabel !== false && Boolean(label);
          const hintUi = renderRoiFieldHint(hint, hintStyle);
          const hintUnderLabel = renderRoiFieldHint(hint, hintStyle, { underLabel: true });
          const wrapClass = [
            "roi-check-wrap",
            CustomClass || "",
            isCardLayout ? "radio-card-grid radio-layout-card" : "",
            isUnstacked && !isCardLayout ? "radio-layout-unstacked" : "",
          ]
            .filter(Boolean)
            .join(" ");

          // Resolve which option index should be selected:
          // 1. Prefer the runtime value from roiActionArr_global (user choice / logic)
          //    by matching it against the items' values and using the found index.
          // 2. If no runtime match is found, fall back to the configured default index from 'value'.
          let resolvedIndex = null;

          const runtimeField = roiActionArr_global.current[uuid];
          const runtimeVal = runtimeField && runtimeField.value;

          if (
            Array.isArray(items) &&
            items.length > 0 &&
            runtimeVal !== undefined &&
            runtimeVal !== null &&
            runtimeVal !== ""
          ) {
            const foundIdx = items.findIndex(
              (it) => String(it.value) === String(runtimeVal)
            );
            if (foundIdx !== -1) {
              resolvedIndex = foundIdx;
            }
          }

          if (
            resolvedIndex === null &&
            Array.isArray(items) &&
            items.length > 0 &&
            (typeof value === "number" ||
              (typeof value === "string" && value !== "" && !isNaN(value)))
          ) {
            // Use the default index from config for initial selection
            const idx = Number(value);
            if (!isNaN(idx) && idx >= 0 && idx < items.length) {
              resolvedIndex = idx;
            }
          }


          return (
            <>
              <div
                className="roi-form-group position-relative"
                style={{ opacity: inputOpacity }}
              >
                {showFieldLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                    {hintUi}
                  </label>
                )}
                {!showFieldLabel && hintUnderLabel}

                <div className={wrapClass}>
                  {items.map((item, i) => {
                    const radioId = `${ID}-${i}`;
                    const isChecked = resolvedIndex === i;
                    const checkClass = isCardLayout
                      ? "form-check card-radio"
                      : "form-check";

                    return (
                      <label className={checkClass} key={i} htmlFor={radioId}>
                        <input
                          className="form-check-input"
                          type="radio"
                          value={item.value}
                          id={radioId}
                          name={ID}
                          checked={isChecked}
                          onChange={() => onRadioClick(uuid, item.value)}
                        />
                        <span className="form-check-label">{item.RadioOption}</span>
                        {item.subtext ? (
                          <span className="radio-subtext subtext">{item.subtext}</span>
                        ) : null}
                      </label>
                    );
                  })}
                </div>
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      PhoneNumber: {
        render: ({
          label,
          showLabel,
          placeholder,
          required,
          errorMessage,
          value,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <input
                  type="text"
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                    } ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  value={value}
                  id={uuid}
                  required={required}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    color: `${Style?.Color}`,

                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                    textAlign: Font?.Align,
                  }}
                />
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Email: {
        render: ({
          label,
          placeholder,
          required,
          errorMessage,
          value,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <input
                  autoComplete="off"
                  type="text"
                  className={`form-control ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  value={value}
                  required={required}
                />
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Date: {
        render: ({
          label,
          required,
          errorMessage,
          hide,
          onChange,
          placeholder,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <input
                  autoComplete="off"
                  type="text"
                  className={`form-control ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  required={required}
                  onChange={onChange}
                />

                {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                {/* <DateField /> */}
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Range: {
        render: ({
          label,
          showLabel,
          required,
          hide,
          startValue,
          endValue,
          uniqueId,
          uuid,
          hint,
          hintStyle,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;
          const showFieldLabel = showLabel !== false && Boolean(label);
          const hintUi = renderRoiFieldHint(hint, hintStyle);

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {showFieldLabel && (
                  <label className="field-label range-slider-custom-label">
                    {label} {required && <span className="required">*</span>}
                    {hintUi}
                  </label>
                )}
                {!showFieldLabel && renderRoiFieldHint(hint, hintStyle, { underLabel: true })}
                {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                <div className="d-flex align-items-center range-slider-custom gap-2">
                  <div className="range-slider-custom-value">{startValue.value} {startValue.unit}</div>
                  <div className="flex-grow-1">
                    <Range
                      startValue={startValue}
                      endValue={endValue}
                      uniqueId={uniqueId}
                      uuid={uuid}
                      currentValue={roiActionArr_global.current?.[uuid]?.value}
                      onChange={async (u, endVal) => {
                        const num = Number(endVal);
                        const safe = Number.isFinite(num) ? num : 0;
                        if (u && roiActionArr_global.current[u]) {
                          roiActionArr_global.current[u].value = safe;
                          roiActionArr_global.current[u].type = "Range";
                          roiActionArr_global.current[u].errorMessage = "";
                        }
                        await updateValueByUuid(currentPageId.current, u, safe);
                        const calculated = await processLogic();
                        renderChanges({}, {}, calculated || {});
                      }}
                    />
                  </div>
                  <div className="range-slider-custom-value">{endValue.value} {endValue.unit}</div>
                </div>
              </div>
            </>
          );
        },
      },

      Toggle: {
        render: ({ label, required, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <div className="check-switch">
                  <label>No</label>
                  <input id="agree-check" type="checkbox" defaultChecked autoComplete="off" />
                  <label>Yes</label>
                </div>
              </div>
            </>
          );
        },
      },

      Button: {
        render: ({
          buttonText,
          buttonAction,
          conditionalLogic,
          buttonLink,
          buttonStyle,
          buttonicon,
          hide,
          uuid,
          customStyle,
          Style,
          spacing,
          iconPosition,
          popupTargetId,
          buttonAlignment,
        }) => {
          // Hide the button completely when hide is true
          if (hide) {
            return null;
          }

          // Prepare conditional attributes for the Bootstrap modal
          const modalTriggerAttributes = {};
          if (buttonAction === "OpenPopup" && popupTargetId) {
            modalTriggerAttributes["data-bs-toggle"] = "modal";
            // Ensure popupTargetId from Puck field doesn't include '#'
            // Prepend '#' when setting data-bs-target
            modalTriggerAttributes[
              "data-bs-target"
            ] = `#${popupTargetId.replace(/^#/, "")}`;
          }

          return (
            <>
              <div
                className={`button-wrap text-${buttonAlignment}`}
              >
                {(() => {
                  if (buttonAction === "OpenPopup") {
                    return buttonicon === "yes" ? (
                      <button
                        // {...modalTriggerAttributes}
                        onClick={() => {
                          changeModal();
                        }}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        {...modalTriggerAttributes}
                        //data-bs-toggle="modal"
                        //data-bs-target="#reportModal"
                        onClick={() => onButtonClick(uuid)}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  } else if (buttonAction === "ClosePopup") {
                    return buttonicon === "yes" ? (
                      <button
                        data-bs-dismiss="modal"
                        onClick={() => onButtonClick(uuid, "ClosePopup")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        data-bs-dismiss="modal"
                        onClick={() => onButtonClick(uuid, "ClosePopup 2")}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  } else if (buttonAction === "ResetForm") {

                    return buttonicon === "yes" ? (
                      <button
                        // onMouseDown={(e) => {
                        //   // Handle button logic here before blur/render happens
                        //   // e.preventDefault(); // optional: prevent focus loss
                        //   onButtonClick(uuid, "nothing");
                        // }}
                        //onClick={handleRecalculateClick} // Added onClick
                        data-bs-toggle="modal"
                        data-bs-target="#logoPrompt"

                        // onClick={() => onButtonClick(uuid, "nothing")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" /> {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />  {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText} <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button // Added onClick
                        data-bs-toggle="modal"
                        data-bs-target="#logoPrompt"
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );

                  } else if (buttonAction === "JumpToReport") {
                    // Use onButtonClick pipeline so JumpToReport behaves like JumpToPage:
                    // it will first run all logic & validations, then call jumpToReport only if no errors.
                    return buttonicon === "yes" ? (
                      <button
                        onClick={() => onButtonClick(uuid, "JumpToReport")}
                        disabled={isLoadingdownload}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {isLoadingdownload ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" /> {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText} <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={() => onButtonClick(uuid, "JumpToReport")}
                        disabled={isLoadingdownload}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {isLoadingdownload ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          buttonText
                        )}
                      </button>
                    );
                  } else if (buttonAction === "JumpToMethod") {
                    return buttonicon === "yes" ? (
                      <button
                        onClick={() => onButtonClick(uuid, "JumpToMethod")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" /> {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText} <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={() => onButtonClick(uuid, "JumpToMethod")}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  } else {
                    return buttonicon === "yes" ? (
                      <button
                        onMouseDown={(e) => {
                          // Handle button logic here before blur/render happens
                          // e.preventDefault(); // optional: prevent focus loss
                          onButtonClick(uuid, "nothing");
                        }}
                        // onClick={() => onButtonClick(uuid, "nothing")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" /> {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText} <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={() => onButtonClick(uuid, "nothing 2")}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  }
                })()}
              </div>
            </>
          );
        },
      },

      //Bootstrap modal component
      // Inside your config.js, for the BootstrapModal component:
      BootstrapModal: {
        render: ({ modalId, _editorPreviewContent, children, modalSize }) => {
          // This render function is for the Puck admin editor experience.
          return (
            <>
              {handleModalOpen && (
                <>
                  <div
                    class={`modal fade${handleModal ? "" : " show d-block"}`}
                    id={modalId}
                    tabindex="-1"
                    aria-labelledby={`${modalId}Label`}
                    aria-hidden="true"
                    onClick={(e) => {
                      // Close modal when clicking on backdrop (the modal div itself)
                      if (e.target.id === modalId) {
                        setHandleModal(true);
                        setHandleModalOpen(false);
                      }
                    }}
                  >
                    <div
                      class={`modal-dialog modal-dialog-centered tco-modal-dialog p-0 ${modalSize}`}
                    >


                      <div class="modal-content">
                        <button
                          type="button"
                          className="btn-close btn-close-roi"
                          data-bs-dismiss="modal"
                          aria-label="Close"
                          onClick={() => {
                            setHandleModal(true);
                            setHandleModalOpen(false);
                          }}
                        />
                        <div class="modal-body modal-body-roi-landing-form ">
                          <DropZone zone="wrapper" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="modal-backdrop fade show"
                    onClick={() => {
                      setHandleModal(true);
                      setHandleModalOpen(false);
                    }}
                  ></div>
                </>
              )}
            </>
          );
        },
      },
      ProgressBar: {
        render: ({
          value,
          minValue,
          maxValue,
          barColor,
          height,
          ariaLabel,
          puck,
        }) => {
          const percentage = ((value - minValue) / (maxValue - minValue)) * 100;
          const clampedPercentage = Math.min(Math.max(percentage, 0), 100);

          const progressBarStyle = {
            width: `${clampedPercentage}%`,
          };
          if (barColor) {
            progressBarStyle.backgroundColor = barColor;
          }

          const progressContainerStyle = {};
          if (typeof height === "number") {
            // Check if height is a number
            progressContainerStyle.height = `${height}px`; // Append 'px'
          }

          return (
            <div
              className="progress"
              role="progressbar"
              aria-label={ariaLabel || "Progress bar"}
              aria-valuenow={value}
              aria-valuemin={minValue}
              aria-valuemax={maxValue}
              style={progressContainerStyle}
            >
              <div
                className="roi-progress-bar progress-bar"
                style={progressBarStyle}
              >
                {/* Label is removed */}
              </div>
            </div>
          );
        },
      },
      // Button: {
      //     render: ({ Button, hide }) => {
      //         // Render nothing if hide is true
      //         if (hide) {
      //             return null;
      //         }

      //         // Calculate opacity based on hide value
      //         const inputOpacity = hide ? 0.5 : 1;

      //         return (
      //             <>
      //                 <div className="button-wrap" style={{ opacity: inputOpacity }}>
      //                     {Button.buttonicon === "yes" ?

      //                         <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
      //                             <div className="icon">
      //                                 <Svg name="roi-button-icon" />
      //                             </div>
      //                         </button>
      //                         :
      //                         <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
      //                     }

      //                 </div>
      //             </>
      //         )

      //     },
      // },

      //Report
      ReportPage: {
        render: ({ Heading, Description, Padding, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="heading-currency-wrapper d-lg-flex mb-3 mb-lg-4 align-items-center">
                    <div className="curecny-dropdown mb-3 mb-lg-0 order-2">
                      <select
                        className="form-control form-select"
                        onChange={(e) => currencyChange(e)}
                      >
                        <option
                          value={defaultCurrency}
                          selected={
                            changedCurrency == "" ||
                              changedCurrency == defaultCurrency
                              ? "selected"
                              : ""
                          }
                        >
                          {defaultCurrency}
                        </option>
                        {currency.map((item, i) => (
                          <option
                            value={item}
                            selected={changedCurrency == item ? "selected" : ""}
                            key={i}
                          >
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="section-heading flex-grow-1 order-1">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>
                  </div>
                  <div className="stats-section stats-section-custom">
                    <div className="row">
                      <div className="col-lg-8 mb-3 mb-lg-0">
                        <div className="total-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="total-wrapper" />
                        </div>
                        <div className="chart-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="chart-wrapper" />
                        </div>
                        <div className="custom-table-wrapper report-accordion-wrapper report-pg-table mb-3 mb-lg-4">
                          <DropZone zone="table-wrapper" />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="download-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="download-wrapper" />
                        </div>
                        <div className="card-wrapper-custom">
                          <DropZone zone="card-wrapper" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      CardSection: {
        render: ({ items, hide, Text }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="row" style={{ opacity: inputOpacity }}>
                {items.map((item, i) => (
                  <div className="col-lg-4 col-md-4 mb-3" key={i}>
                    <div className="stat-wrap">
                      <div className="stat-heading">
                        <div className="icon">
                          <img src={item.icon} alt="" />
                        </div>
                        <div
                          className={`text ${Text.titleFont} ${Text.fontWeight}`}
                        >
                          {item.Title}
                        </div>
                      </div>
                      <div className="stat-content-wrapper d-flex flex-column">
                        <div className="d-flex flex-column flex-grow-1">
                          <div className="value-section value-section-1 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle1}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {CurrencyFormatter({
                                amount: parseFloat(item.Value1),
                              })}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle2}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {CurrencyFormatter({
                                amount: parseFloat(item.Value2),
                              })}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-none align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle3}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value3}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-none align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle4}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value4}
                            </div>
                          </div>
                        </div>
                        <div className="action">
                          <a
                            data-bs-toggle="modal"
                            data-bs-target="#reportModal"
                            onClick={() => onButtonClick(item.uuid)}
                            className="fs-16 fw-700"
                          >
                            {item.ActionText}{" "}
                            <span className="icon">
                              <svg
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx={10} cy={10} r={10} fill="#E60000" />
                                <path
                                  d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        },
      },

      ResultCard: {
        render: ({ Card1, Card2, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="total-wrapper" style={{ opacity: inputOpacity }}>
                <div className="total-inner bg-1">
                  <h5 className="fs-16 fw-700">{Card1.title}</h5>
                  <p className="fs-36 fw-300">
                    {CurrencyFormatter({ amount: parseFloat(Card1.value) })}
                  </p>
                </div>
                <div className="total-inner bg-2">
                  <h5 className="fs-16 fw-700">{Card2.title}</h5>
                  <p className="fs-36 fw-300">
                    {CurrencyFormatter({ amount: parseFloat(Card2.value) })}
                  </p>
                </div>
              </div>
            </>
          );
        },
      },

      ChartCard: {
        render: ({ Heading, hide, Chart1, Chart2, Chart3, Chart4 }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                <div className="stat-heading">
                  <div className="icon d-none">
                    <img src={Heading.icon} alt="" />
                  </div>
                  <div
                    className={`text ${Heading.fontWeight} ${Heading.titleFont}`}
                  >
                    {Heading.title}
                  </div>

                  <div className="switch-btn">
                    <div className="switch-nav">
                      <input
                        id="microsoft"
                        type="radio"
                        name="company"
                        value="microsoft"
                        checked={selectedCompany === "microsoft"}
                        onChange={handleCompanyChange}
                      />
                      <label htmlFor="microsoft">Microsoft</label>

                      <input
                        id="vbuc"
                        type="radio"
                        name="company"
                        value="vbuc"
                        checked={selectedCompany === "vbuc"}
                        onChange={handleCompanyChange}
                      />
                      <label htmlFor="vbuc">VBUC</label>
                    </div>

                    <div className="switch-nav">
                      <input
                        id="year1"
                        type="radio"
                        name="year"
                        value="year1"
                        checked={selectedYear === "year1"}
                        onChange={handleYearChange}
                      />
                      <label htmlFor="year1"> First Year</label>

                      <input
                        id="year3"
                        type="radio"
                        name="year"
                        value="year3"
                        checked={selectedYear === "year3"}
                        onChange={handleYearChange}
                      />
                      <label htmlFor="year3">Three Years </label>
                    </div>
                  </div>
                </div>

                <div className="stat-content-wrapper pt-4">
                  {selectedCompany === "vbuc" && selectedYear === "year1" && (
                    <ReactEcharts
                      style={chartStyle}
                      option={pieChart(Chart1.items)}
                    />
                  )}
                  {selectedCompany === "vbuc" && selectedYear === "year3" && (
                    <ReactEcharts
                      style={chartStyle}
                      option={pieChart(Chart2.items)}
                    />
                  )}

                  {selectedCompany === "microsoft" &&
                    selectedYear === "year1" && (
                      <ReactEcharts
                        style={chartStyle}
                        option={pieChart(Chart3.items)}
                      />
                    )}

                  {selectedCompany === "microsoft" &&
                    selectedYear === "year3" && (
                      <ReactEcharts
                        style={chartStyle}
                        option={pieChart(Chart4.items)}
                      />
                    )}
                </div>
              </div>
            </>
          );
        },
      },

      DownloadCard: {
        render: ({ Heading, Padding, Button, image, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          // const jumpToReport = async () => {
          //     try {
          //         let newuuid =  uuidv4();
          //         let generateUrl = `/roi/${roiId}/report/${newuuid}`
          //         window.open(generateUrl, '_blank');

          //     } catch (error) {
          //     }
          // }

          // const jumpToReport = async () => {
          //     try{
          //     let data = JSON.stringify({
          //         "roi_submitted_master_data_id": roiId,
          //         "structure": JSON.stringify(roiActionArr), // Assuming roiActionArr contains some structure data
          //         "add_date_time": new Date().toISOString().slice(0, 19).replace('T', ' ')
          //       });

          //       // Axios request configuration
          //       let config = {
          //         method: 'post',
          //         maxBodyLength: Infinity,
          //         url: `${apiUrl}/roi-submit-data/create`,
          //         headers: {
          //           'Content-Type': 'application/json'
          //         },
          //         data: data
          //       };

          //       // Perform the Axios request
          //      axios.request(config)
          //         .then((response) => {
          //           try {
          //             let newuuid = uuidv4();
          //             let generateUrl = `/roi/${roiId}/report/${newuuid}`;

          //             // Call API to download PDF
          //             let data = JSON.stringify({
          //                 "url": `${frntUrl}${generateUrl}`,
          //                 "reportname": "sample_pdf"
          //             });

          //             let config = {
          //                 method: 'post',
          //                 maxBodyLength: Infinity,
          //                 // url: 'http://localhost:3005/frnt/downloadreportpdf',
          //                 url: `${apiUrl}/roi-pages/reportPageDownload`,
          //                 headers: {
          //                     'Content-Type': 'application/json'
          //                 },
          //                 data: data,
          //                 responseType: 'blob' // This ensures that the response is treated as a file (binary data)
          //             };

          //             // Make API request to download PDF
          //             const response = axios.request(config);

          //             // Create a link element, set URL to response, and trigger download
          //             const url = window.URL.createObjectURL(new Blob([response.data]));
          //             const link = document.createElement('a');
          //             link.href = url;
          //             link.setAttribute('download', 'report.pdf');
          //             document.body.appendChild(link);
          //             link.click();
          //             document.body.removeChild(link);

          //         } catch (error) {
          //         }
          //         })
          //         .catch((error) => {
          //           console.error('Error:', error);
          //         });}
          //         catch(error){
          //             console.error('Error with create:', error);
          //         }
          // };

          const jumpToReport = async () => {
            setIsLoadingdownload(true);
            try {
              // Prepare data for the first API calls
              let data = JSON.stringify({
                roi_submitted_master_data_id: roiId,
                structure: JSON.stringify(roiActionArr_global.current),
                currency_symbol: JSON.stringify({
                  currencySymbol: currencySymbol,
                  currency: currency,
                }),
                add_date_time: new Date()
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " "),
              });

              // Configuration for the first API call
              let config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${apiUrl}/roi-submit-data/create`,
                headers: {
                  "Content-Type": "application/json",
                },
                data: data,
              };

              // Perform the first API call
              const response = await axios.request(config);

              // Generate UUID and URL for PDF download
              let newuuid = uuidv4();
              let generateUrl = `/roi/${roiId}/report/${newuuid}`;

              //   // Prepare data for PDF download API call
              data = JSON.stringify({
                url: `${frntUrl}${generateUrl}`,
                reportname: "cx_ai_calculator_report",
              });

              //   // Configuration for PDF download API call
              config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${apiUrl}/roi-pages/reportPageDownload`,
                headers: {
                  "Content-Type": "application/json",
                },
                data: data,
                responseType: "blob",
              };

              // Perform PDF download API call
              const pdfResponse = await axios.request(config);

              // Create a link element, set URL to response, and trigger download
              const url = window.URL.createObjectURL(
                new Blob([pdfResponse.data])
              );
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `cx_ai_calculator_report-${roiId}.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } catch (error) {
              console.error("Error in jumpToReport:", error);
            } finally {
              setIsLoadingdownload(false); // Stop loading when process is complete
            }
          };

          return (
            <>
              <div
                className={`save-report-section h-100 d-flex align-items-end`}
                style={{
                  backgroundImage: `url("${image}")`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  opacity: inputOpacity,
                  padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                }}
              >
                <div className="text-wrapper">
                  <h4
                    className={`${Heading?.fontWeight} ${Heading?.titleFont}`}
                    style={{
                      color: Heading?.Color,
                    }}
                  >
                    {Heading.title}
                  </h4>

                  {/* <div className="button-wrap">

                                        {Button.buttonicon === "yes" ?
                                            <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} onClick={jumpToReport}><span className='with-icon'>{Button.buttonText}</span>
                                                <div className="icon">
                                                    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                        <path d="M8 2.33334V13.5533" stroke="#25282B" strokeWidth="1.5" strokeMiterlimit={10} strokeLinecap="round" strokeLinejoin="round" />
                                                    </svg>
                                                </div>
                                            </button>
                                            :
                                            <button className={`btn roi-btn-${Button.buttonStyle}`} onClick={jumpToReport}>{Button.buttonText}</button>
                                        }
                                    </div> */}
                  <div className="button-wrap">
                    {Button.buttonicon === "yes" ? (
                      <button
                        className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                        onClick={jumpToReport}
                        disabled={isLoadingdownload} // Disable button while loading
                      >
                        {isLoadingdownload ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          <span className="with-icon">{Button.buttonText}</span>
                        )}
                        {!isLoadingdownload && (
                          <div className="icon">
                            <svg
                              width={16}
                              height={16}
                              viewBox="0 0 16 16"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M12.0465 9.62L7.99979 13.6667L3.95312 9.62"
                                stroke="#25282B"
                                strokeWidth="1.5"
                                strokeMiterlimit={10}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                              <path
                                d="M8 2.33334V13.5533"
                                stroke="#25282B"
                                strokeWidth="1.5"
                                strokeMiterlimit={10}
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              />
                            </svg>
                          </div>
                        )}
                      </button>
                    ) : (
                      <button
                        className={`btn roi-btn-${Button.buttonStyle}`}
                        onClick={jumpToReport}
                        disabled={isLoadingdownload} // Disable button while loading
                      >
                        {isLoadingdownload ? (
                          <span
                            className="spinner-border spinner-border-sm"
                            role="status"
                            aria-hidden="true"
                          ></span>
                        ) : (
                          Button.buttonText
                        )}
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Report Single page

      ReportSection: {
        render: ({ Heading, Description, Padding, items, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <DropZone zone={`summary-heading`} />
                  <div className="row">
                    <div className="col-xl-3 col-lg-4">
                      <DropZone zone={`summary-details`} />
                    </div>
                    <div className="col-xl-9 col-lg-8">
                      <div className="report-accordion-wrapper">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                          {items.map((item, i) => (
                            <li
                              className="nav-item"
                              role="presentation"
                              key={i}
                            >
                              {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                              <button
                                className={
                                  item.isActive === true
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                onClick={() => openPopup(item.buttonValue)}
                              >
                                {item.Title}
                              </button>
                            </li>
                          ))}
                        </ul>
                        <div className="form-wrapper">
                          {/* <div className="tab-content" id="myTabContent"> */}
                          {/* {items.map((item, i) => ( */}
                          {/* <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}> */}

                          <div className="form-inner">
                            <DropZone
                              zone={`wizard-form-wrapper`}
                              disallow={["SinglePage", "WizardForm"]}
                            />
                          </div>
                          {/* </div> */}
                          {/* ))} */}
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      ReportTable: {
        render: ({
          Heading,
          Table,
          Headings,
          ColumnSettings,
          items,
          Calculations,
          Test,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="accordion-item" style={{ opacity: inputOpacity }}>
                {Heading?.title && (
                  <h2 className="fs-20 fw-700 accordion-button">
                    {Heading.title}
                  </h2>
                )}

                <div className="accordion-body report-accordion-wrapper">
                  <div className="table-wrapper">
                    <div className="table-responsive">
                      <table className="table">
                        {Table.FirstRow && (
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FirstColSpan}'px'`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {Headings.Cell1}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.SecondColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell2}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.ThirdColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell3}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FourthColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell4}
                              </th>
                            </tr>
                          </thead>
                        )}

                        <tbody>
                          {items.map((item, i) => (
                            <tr
                              key={i}
                              className={`${Table.LastRow && `table-last-row`}`}
                            >
                              <td
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {item.Cell1isEditable ? (
                                  <input
                                    autoComplete="off"
                                    type="text"
                                    className="form-control first-column"
                                    defaultValue={item.Cell1Data}
                                    onFocus={handleInputFocus}
                                    onBlur={(e) =>
                                      handleInputBlur(item.Cell1uuid, e)
                                    }
                                  />
                                ) : (
                                  item.Cell1Data
                                )}
                              </td>

                              <td
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          autoComplete="off"
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleInputBlur(item.Cell2uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell2isEditable &&
                                    item.Cell2EditStyle === "percentage"
                                  ) {
                                    return item.Cell2Data + "%";
                                  } else if (
                                    !item.Cell2isEditable &&
                                    item.Cell2EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell2Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          autoComplete="off"
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleInputBlur(item.Cell2uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        autoComplete="off"
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell2Data}
                                        onFocus={handleInputFocus}
                                        onBlur={(e) =>
                                          handleInputBlur(item.Cell2uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell2Data;
                                  }
                                })()}
                              </td>
                              <td
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell3isEditable &&
                                    item.Cell3EditStyle === "percentage"
                                  ) {
                                    return item.Cell3Data + "%";
                                  } else if (
                                    !item.Cell3isEditable &&
                                    item.Cell3EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell3Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell3Data}
                                        onFocus={handleInputFocus}
                                        onBlur={(e) =>
                                          handleChange(item.Cell3uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell3Data;
                                  }
                                })()}
                              </td>
                              <td
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell4isEditable &&
                                    item.Cell4EditStyle === "percentage"
                                  ) {
                                    return item.Cell4Data + "%";
                                  } else if (
                                    !item.Cell4isEditable &&
                                    item.Cell4EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell4Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell4Data}
                                        onFocus={handleInputFocus}
                                        onBlur={(e) =>
                                          handleChange(item.Cell4uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell4Data;
                                  }
                                })()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        {/* {Table.LastRow && <tfoot>
                                                    <tr>
                                                        <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{Calculations.Cell1}</td>
                                                        <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                        <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{Calculations.Cell2}</td>
                                                    </tr>
                                                </tfoot>} */}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      // Download Report
      DownloadReportBanner: {
        render: ({
          Heading,
          Description,
          Padding,
          logo,
          image,
          backgroundImage,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`style3 dwn-report-section roi-banner-section position-relative ${Padding.bottom
                    } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                  style={{
                    backgroundImage: `url("${backgroundImage}")`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="row align-items-center ">
                      <div className="col-lg-12">
                        <div className="banner-text">
                          <h1
                            className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}
                          >
                            {Heading.title}
                          </h1>

                          <div className="text-part">
                            <div
                              className={Description.descriptionFont}
                              dangerouslySetInnerHTML={{
                                __html: Description.text,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="img-wrapper">
                          <img src={image} className="img-fluid" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },
      DownloadReportPage: {
        render: ({ Heading, Description, Padding, logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>

                    <div className="stats-section">
                      <div className="row">
                        <div className="col-lg-12 mb-2">
                          <DropZone zone="card-wrapper" />
                        </div>

                        <div className="col-lg-12 mb-2">
                          <DropZone zone="total-wrapper" />
                        </div>

                        <div className="col-lg-12">
                          <DropZone zone="chart-wrapper" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadCardSection: {
        render: ({ items, hide, Text }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="row gx-2" style={{ opacity: inputOpacity }}>
                {items.map((item, i) => (
                  <div className="col-lg-4 col-md-4 mb-2" key={i}>
                    <div className="stat-wrap">
                      <div className="stat-heading">
                        <div className="icon">
                          <img src={item.icon} alt="" />
                        </div>
                        <div
                          className={`text ${Text.titleFont} ${Text.fontWeight}`}
                        >
                          {item.Title}
                        </div>
                      </div>
                      <div className="stat-content-wrapper d-flex flex-column">
                        <div className="d-flex flex-column flex-grow-1">
                          <div className="value-section value-section-1 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle1}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value1}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle2}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value2}
                            </div>
                          </div>
                        </div>
                        <div className="action">
                          <a href="" className="fs-16 fw-700">
                            {item.ActionText}{" "}
                            <span className="icon">
                              <svg
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx={10} cy={10} r={10} fill="#E60000" />
                                <path
                                  d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        },
      },

      DownloadResultCard: {
        render: ({ Card1, Card2, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="total-wrapper row gx-0 flex-row"
                style={{ opacity: inputOpacity }}
              >
                <div className="total-inner bg-1 col-6">
                  <h5 className="fs-16 fw-700 text-center">{Card1.title}</h5>
                  <p className="fs-48 fw-300 text-center">
                    {Card1.description}
                  </p>
                </div>
                <div className="total-inner bg-2 col-6">
                  <h5 className="fs-16 fw-700 text-center">{Card2.title}</h5>
                  <p className="fs-48 fw-300 text-center">
                    {Card2.description}
                  </p>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadChartCard: {
        render: ({ Chart1, Chart2, Heading, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                <div className="stat-heading">
                  <div className="icon">
                    <img src={Heading.icon} alt="" />
                  </div>
                  <div
                    className={`text ${Heading.fontWeight} ${Heading.titleFont}`}
                  >
                    {Heading.title}
                  </div>
                </div>

                <div className="stat-content-wrapper">
                  <div className="tab-content" id="myTabContent">
                    <div className="row">
                      <div className="col-sm-6">
                        {Chart1.chooseChart === "pie" ? (
                          <ReactEcharts
                            style={chartStyle}
                            option={OneYearChartOptions}
                          />
                        ) : (
                          <ReactEcharts
                            style={chartStyle}
                            option={ThreeYearChartOptions}
                          />
                        )}
                      </div>
                      <div className="col-sm-6">
                        {Chart2.chooseChart === "bar" ? (
                          <ReactEcharts
                            style={chartStyle}
                            option={ThreeYearChartOptions}
                          />
                        ) : (
                          <ReactEcharts
                            style={chartStyle}
                            option={OneYearChartOptions}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportSection: {
        render: ({ Heading, Description, Padding, items, logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>
                    <div className="report-accordion-wrapper">
                      <div className="form-wrapper">
                        <div className="tab-content" id="myTabContent">
                          {items.map((item, i) => (
                            <div
                              key={i}
                              className={
                                i === 0
                                  ? "tab-pane fade show active"
                                  : "tab-pane fade"
                              }
                              id={`tab-${i}-pane`}
                              role="tabpanel"
                              aria-labelledby={`tab-${i}`}
                              tabIndex={0}
                            >
                              <div className="form-inner">
                                <DropZone
                                  zone={`wizard-form-wrapper-${i}`}
                                  disallow={["SinglePage", "WizardForm"]}
                                />
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportTable: {
        render: ({
          Heading,
          Table,
          Headings,
          ColumnSettings,
          items,
          Calculations,
          Test,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="accordion-item" style={{ opacity: inputOpacity }}>
                <h2 className="fs-14 fw-700 accordion-button">
                  {Heading.title}
                </h2>
                <div className="accordion-body">
                  <div className="table-wrapper">
                    <div className="table-responsive">
                      <table className="table">
                        {Table.FirstRow && (
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FirstColSpan}'px'`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {Headings.Cell1}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.SecondColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell2}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.ThirdColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell3}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FourthColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell4}
                              </th>
                            </tr>
                          </thead>
                        )}

                        <tbody>
                          {items.map((item, i) => {
                            return (
                              <tr key={i}>
                                <td
                                  className={`${ColumnSettings.HighlightCol === "1st"
                                    ? "highlighted"
                                    : ""
                                    }`}
                                >
                                  {item.Cell1isEditable ? (
                                    <input
                                      autoComplete="off"
                                      type="text"
                                      className="form-control first-column"
                                      defaultValue={item.Cell1Data}
                                      onFocus={handleInputFocus}
                                      onBlur={(e) =>
                                        handleChange(item.Cell1uuid, e)
                                      }
                                    />
                                  ) : (
                                    item.Cell1Data
                                  )}
                                </td>

                                <td
                                  className={`${ColumnSettings.HighlightCol === "2nd"
                                    ? "highlighted"
                                    : ""
                                    } text-end`}
                                >
                                  {(() => {
                                    if (
                                      item.Cell2isEditable &&
                                      item.Cell2EditStyle === "percentage"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            autoComplete="off"
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell2Data}
                                            onFocus={handleInputFocus}
                                            onBlur={(e) =>
                                              handleChange(item.Cell2uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            %
                                          </span>
                                        </div>
                                      );
                                    } else if (
                                      !item.Cell2isEditable &&
                                      item.Cell2EditStyle === "percentage"
                                    ) {
                                      return item.Cell2Data + "%";
                                    } else if (
                                      !item.Cell2isEditable &&
                                      item.Cell2EditStyle === "currency"
                                    ) {
                                      return (
                                        <>
                                          {CurrencyFormatter({
                                            amount: parseFloat(item.Cell2Data),
                                          })}
                                        </>
                                      );
                                    } else if (
                                      item.Cell2isEditable &&
                                      item.Cell2EditStyle === "currency"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            autoComplete="off"
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell2Data}
                                            onFocus={handleInputFocus}
                                            onBlur={(e) =>
                                              handleChange(item.Cell2uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            dangerouslySetInnerHTML={{
                                              __html: currencySymbol,
                                            }}
                                          ></span>
                                        </div>
                                      );
                                    } else if (
                                      item.Cell2isEditable &&
                                      item.Cell2EditStyle === "number"
                                    ) {
                                      return (
                                        <input
                                          autoComplete="off"
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onFocus={handleInputFocus}
                                          onBlur={(e) =>
                                            handleChange(item.Cell2uuid, e)
                                          }
                                        />
                                      );
                                    } else {
                                      return item.Cell2Data;
                                    }
                                  })()}
                                </td>
                                <td
                                  className={`${ColumnSettings.HighlightCol === "3rd"
                                    ? "highlighted"
                                    : ""
                                    } text-end`}
                                >
                                  {(() => {
                                    if (
                                      item.Cell3isEditable &&
                                      item.Cell3EditStyle === "percentage"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell3Data}
                                            onFocus={handleInputFocus}
                                            onBlur={(e) =>
                                              handleChange(item.Cell3uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            %
                                          </span>
                                        </div>
                                      );
                                    } else if (
                                      !item.Cell3isEditable &&
                                      item.Cell3EditStyle === "percentage"
                                    ) {
                                      return item.Cell3Data + "%";
                                    } else if (
                                      !item.Cell3isEditable &&
                                      item.Cell3EditStyle === "currency"
                                    ) {
                                      return (
                                        <>
                                          {CurrencyFormatter({
                                            amount: parseFloat(item.Cell3Data),
                                          })}
                                        </>
                                      );
                                    } else if (
                                      item.Cell3isEditable &&
                                      item.Cell3EditStyle === "currency"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell3Data}
                                            onBlur={(e) =>
                                              handleChange(item.Cell3uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            dangerouslySetInnerHTML={{
                                              __html: currencySymbol,
                                            }}
                                          ></span>
                                        </div>
                                      );
                                    } else if (
                                      item.Cell3isEditable &&
                                      item.Cell3EditStyle === "number"
                                    ) {
                                      return (
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                      );
                                    } else {
                                      return item.Cell3Data;
                                    }
                                  })()}
                                </td>
                                <td
                                  className={`${ColumnSettings.HighlightCol === "4th"
                                    ? "highlighted"
                                    : ""
                                    } text-end`}
                                >
                                  {(() => {
                                    if (
                                      item.Cell4isEditable &&
                                      item.Cell4EditStyle === "percentage"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell4Data}
                                            onBlur={(e) =>
                                              handleChange(item.Cell4uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                          >
                                            %
                                          </span>
                                        </div>
                                      );
                                    } else if (
                                      !item.Cell4isEditable &&
                                      item.Cell4EditStyle === "percentage"
                                    ) {
                                      return item.Cell4Data + "%";
                                    } else if (
                                      !item.Cell4isEditable &&
                                      item.Cell4EditStyle === "currency"
                                    ) {
                                      return (
                                        <>
                                          {CurrencyFormatter({
                                            amount: parseFloat(item.Cell4Data),
                                          })}
                                        </>
                                      );
                                    } else if (
                                      item.Cell4isEditable &&
                                      item.Cell4EditStyle === "currency"
                                    ) {
                                      return (
                                        <div className="input-group">
                                          <input
                                            type="text"
                                            className="form-control"
                                            aria-describedby="basic-addon2"
                                            defaultValue={item.Cell4Data}
                                            onBlur={(e) =>
                                              handleChange(item.Cell4uuid, e)
                                            }
                                          />
                                          <span
                                            className="input-group-text"
                                            id="basic-addon2"
                                            dangerouslySetInnerHTML={{
                                              __html: currencySymbol,
                                            }}
                                          ></span>
                                        </div>
                                      );
                                    } else if (
                                      item.Cell4isEditable &&
                                      item.Cell4EditStyle === "number"
                                    ) {
                                      return (
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                      );
                                    } else {
                                      return item.Cell4Data;
                                    }
                                  })()}
                                </td>
                              </tr>
                            );
                            // }
                          })}
                        </tbody>
                        {/* {Table.LastRow && <tfoot>
                                                    <tr>
                                                        <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{items[items.length-1].Cell1}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{items[items.length-1].Cell2}</td>
                                                    </tr>
                                                </tfoot>} */}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportCardsSection: {
        render: ({
          Heading,
          Description,
          Padding,
          logo,
          Lists,
          Settings,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>
                    <div className="report-posts-wrapper">
                      <div
                        className="list-box-1 d-grid gap-4"
                        style={{
                          gridTemplateColumns: `repeat(${Settings.ItemsPerRow}, 1fr)`,
                        }}
                      >
                        {Lists.map((list, i) => (
                          <div
                            className={`list-box-inner ${Settings.IconPosition === "left" ? "d-flex" : ""
                              }`}
                            key={i}
                          >
                            {Settings.ShowIcon ? (
                              <div className="icon-wrap">
                                <img src={list.Image} alt="" />
                              </div>
                            ) : (
                              ""
                            )}

                            <div className={`text-wrap flex-grow-1`}>
                              <h4
                                className={`${Settings.TitleFont} ${Settings.TitleFontWeight} mb-3`}
                                style={{ color: Settings.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.DescriptionFont} ${Settings.DescriptionFontWeight} mb-0`}
                              >
                                {list.Description}
                              </p>
                              {Settings.ShowButton ? (
                                <div className="button-wrap pt-3">
                                  <a
                                    className="link d-inline-flex text-primary fw-700 fs-14 align-items-center"
                                    href={list.ButtonLink}
                                  >
                                    <span>{list.ButtonText}</span>{" "}
                                    <Svg name="button-arrow" />
                                  </a>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadReportThankYou: {
        render: ({ logo, Description, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div className="report-build-wrapper report-thankyou">
                  <div className="logo-wrap">
                    <img src={logo} alt="" />
                  </div>
                  <div className="desclaimer">
                    <p className={Description.Font}>{Description.text}</p>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      // Landing Page components

      TransparentSection: {
        render: ({ Padding, Style }) => {
          return (
            <>
              <div
                className={`landing-page-cpmponent ${Style.CustomClass} component-section ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{
                  backgroundImage: `url("${Style.Background}")`,
                  backgroundColor: `${Style.BackgroundColor}`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`${Style.Width} position-relative`}>
                  <DropZone zone="section" />
                </div>
              </div>
            </>
          );
        },
      },

      GradientSection: {
        render: ({ Padding, Style }) => {
          return (
            <>
              <div
                className={`component-section gradient-bg ${Padding.bottom} ${Padding.top
                  } ${Padding.fullHeight && "full-height"}`}
              >
                {/* <div className='overlay'></div> */}
                <div className={`${Style.Width} position-relative`}>
                  <DropZone zone="section" />
                </div>
              </div>
            </>
          );
        },
      },

      Columns: {
        render: ({
          columns,
          distribution,
          vertical,
          gap,
          Padding,
          Style,
          Border,
        }) => {
          return (
            <div
              className={`d-grid section-column ${vertical}`}
              style={{
                backgroundImage: `url("${Style?.Background}")`,
                backgroundColor: `${Style?.BackgroundColor}`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                borderStyle: Border?.BorderStyle,
                borderColor: Border?.BorderColor,
                borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                borderRadius: `${Border?.BorderRadius}px`,

                gridTemplateColumns:
                  distribution === "manual"
                    ? "repeat(12, 1fr)"
                    : `repeat(${columns.length}, 1fr)`,
                gridColumnGap: `${gap}px`,
              }}
            >
              {columns.map(({ span, backgroundColor }, idx) => (
                <div
                  key={idx}
                  className="w-100"
                  style={{
                    display: "flex",
                    backgroundColor: backgroundColor,
                    flexDirection: "column",
                    gridColumn:
                      span && distribution === "manual"
                        ? `span ${Math.max(Math.min(span, 12), 1)}`
                        : "",
                  }}
                >
                  <DropZone
                    zone={`column-${idx}`}
                  // disallow={["Section"]}
                  />
                </div>
              ))}
            </div>
          );
        },
      },

      Wrapper: {
        render: ({ Padding, Style, Border, customClass, hide, uuid }) => {
          if (hide == true || hide == 'true') {
            return null;
          }
          return (
            <>
              <div
                className={`component-wrapper ${customClass}`}
                style={{
                  backgroundImage: `url("${Style.Background}")`,
                  backgroundColor: `${Style.BackgroundColor}`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,

                  borderStyle: Border.BorderStyle,
                  borderColor: Border.BorderColor,
                  borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                  borderRadius: `${Border.BorderRadius}px`,
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`position-relative`}>
                  <DropZone zone="wrapper" />
                </div>
              </div>
            </>
          );
        },
      },

      Spacing: {
        render: ({ Height }) => {
          return <div style={{ height: `${Height}` }}></div>;
        },
      },

      Heading: {
        render: ({ Text, Padding }) => {
          return (
            <>
              {(() => {
                if (Text.tag === "h1") {
                  return (
                    <h1
                      className={`section-title m-0 size-h1 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h1>
                  );
                } else if (Text.tag === "h2") {
                  return (
                    <h2
                      className={`section-title m-0 size-h2 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h2>
                  );
                } else if (Text.tag === "h3") {
                  return (
                    <h3
                      className={`section-title m-0 size-h3 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h3>
                  );
                } else if (Text.tag === "h4") {
                  return (
                    <h4
                      className={`section-title m-0 size-h4 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h4>
                  );
                } else if (Text.tag === "h5") {
                  return (
                    <h5
                      className={`section-title m-0 size-h5 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h5>
                  );
                } else if (Text.tag === "h6") {
                  return (
                    <h6
                      className={`section-title m-0 size-h6 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h6>
                  );
                }
              })()}
            </>
          );
        },
      },

      Text: {
        render: ({ Text, hint, hintStyle }) => {
          // Parse the text for dynamic spans
          const parsedContent = parseDynamicText(Text.text);

          return (
            <>
              <div
                style={{
                  color: `${Text.Color}`,
                  textAlign: Text.Align,
                }}
                className={`section-text m-0 ${Text.FontWeight} ${Text.FontSize}`}
              >
                {parsedContent}
                {renderRoiFieldHint(hint, hintStyle)}
              </div>
            </>
          );
        },
      },

      Image: {
        render: ({ Image, AspectRatio, fullWidth }) => {
          return (
            <>
              <div className="image-wrapper">
                <img
                  src={Image}
                  alt=""
                  className={`img-fluid object-cover ${fullWidth && `w-100`} `}
                  style={{ aspectRatio: `${AspectRatio}` }}
                />
              </div>
            </>
          );
        },
      },

      RedCards: {
        render: ({ Lists, Settings }) => {
          return (
            <>
              <div className="roi-cards-section card-layout-1">
                <div className="cards-wrapper">
                  <div className="row justify-content-center">
                    {Lists.map((list, i) => (
                      <div className="col-lg-4 col-md-6 mb-3" key={i}>
                        <input
                          autoComplete="off"
                          className="form-check-input d-none"
                          type="radio"
                          name={Settings.Card.UniqueID}
                          id={`${Settings.Card.UniqueID}-${i}`}
                        />
                        <label
                          className="card-outer"
                          htmlFor={`${Settings.Card.UniqueID}-${i}`}
                          style={{
                            borderStyle: Settings.Border.BorderStyle,
                            borderColor: Settings.Border.BorderColor,
                            borderWidth: `${Settings.Border.BorderWidth}px`,
                            borderRadius: `${Settings.Border.BorderRadius}px`,
                            backgroundColor: Settings.Card.BackgroundColor,
                            paddingTop: `${Settings.Card.Padding.top}px`,
                            paddingRight: `${Settings.Card.Padding.right}px`,
                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                            paddingLeft: `${Settings.Card.Padding.left}px`,
                            textAlign: Settings.Text.Align,
                          }}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4
                                className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`}
                                style={{ color: Settings.Text.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`}
                                style={{
                                  color: Settings.Text.DescriptionColor,
                                }}
                              >
                                {list.Description}
                              </p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      WhiteCards: {
        render: ({ Lists, Settings }) => {
          return (
            <>
              <div className="roi-cards-section card-layout-2">
                <div className="cards-wrapper">
                  <div className="row justify-content-center">
                    {Lists.map((list, i) => (
                      <div className="col-lg-4 col-md-6 mb-3" key={i}>
                        <input
                          autoComplete="off"
                          className="form-check-input d-none"
                          type="radio"
                          name={Settings.Card.UniqueID}
                          id={`${Settings.Card.UniqueID}-${i}`}
                        />
                        <label
                          className="card-outer"
                          htmlFor={`${Settings.Card.UniqueID}-${i}`}
                          style={{
                            borderStyle: Settings.Border.BorderStyle,
                            borderColor: Settings.Border.BorderColor,
                            borderWidth: `${Settings.Border.BorderWidth}px`,
                            borderRadius: `${Settings.Border.BorderRadius}px`,
                            backgroundColor: Settings.Card.BackgroundColor,
                            paddingTop: `${Settings.Card.Padding.top}px`,
                            paddingRight: `${Settings.Card.Padding.right}px`,
                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                            paddingLeft: `${Settings.Card.Padding.left}px`,
                            textAlign: Settings.Text.Align,
                          }}
                        >
                          <div className="card-inner">
                            {list.Image ? (
                              <div class="icon-wrapper">
                                <img
                                  src={list.Image}
                                  alt=""
                                  height={Settings.Card.IconSize}
                                  width={Settings.Card.IconSize}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="text-wrapper">
                              <h4
                                className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`}
                                style={{ color: Settings.Text.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`}
                                style={{
                                  color: Settings.Text.DescriptionColor,
                                }}
                              >
                                {list.Description}
                              </p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      PieChart: {
        render: ({ chartOption }) => (
          <>
            <div className="echart-wrapper">
              <ReactEcharts
                style={{
                  height: "200px",
                  width: "100%",
                }}
                option={chartOption}
              />
            </div>
          </>
        ),
      },

      DoubleBarChart: {
        render: ({ Title, SubTitle, SeriesAName, SeriesBName, SeriesAColor, SeriesBColor, AutoScale, Data, hide, NumberFormat, Theme, Height }) => {
          const inputOpacity = hide ? 0.5 : 1;
          const safeData = Array.isArray(Data) ? Data : [];
          const categories = safeData.map((d) => (d && d.Label != null ? d.Label : ""));

          // Resolve numeric from variables if present, else fallback to provided value
          const getSlug = (label) =>
            (label || "")
              .toString()
              .trim()
              .replace(/\s+/g, "_")
              .replace(/[^a-zA-Z0-9_]/g, "")
              .toLowerCase();

          const resolveNumeric = (keys, fallback) => {
            for (const k of keys) {
              const v = roiActionArr_global.current?.[k]?.value;
              if (v !== undefined && v !== null && v !== "" && !isNaN(Number(v))) {
                return Number(v);
              }
            }
            return Number(fallback ?? 0);
          };

          const aData = safeData.map((d, idx) => {
            const labelText = (d && typeof d.Label === "string" && d.Label.trim()) ? d.Label.trim() : `Bar ${idx + 1}`;
            const slug = getSlug(labelText);
            const candidates = [
              d && d.SeriesAValueUuid,
              d && d.AUuid,
              `${slug}_first_bar_value`,
            ].filter(Boolean);
            return resolveNumeric(candidates, d && d.A);
          });

          const bData = safeData.map((d, idx) => {
            const labelText = (d && typeof d.Label === "string" && d.Label.trim()) ? d.Label.trim() : `Bar ${idx + 1}`;
            const slug = getSlug(labelText);
            const candidates = [
              d && d.SeriesBValueUuid,
              d && d.BUuid, // direct UUID if present
              `${slug}_second_bar_value`,
              slug,         // label alias we create for Series B
            ].filter(Boolean);
            return resolveNumeric(candidates, d && d.B);
          });
          const seriesANameSafe = SeriesAName || "Series A";
          const seriesBNameSafe = SeriesBName || "Series B";

          const formatMillions = (val) => {
            const num = Number(val);
            if (!Number.isFinite(num)) return '';
            return NumberFormat === 'usd_whole' ? Math.round(num).toLocaleString('en-US') : `$${num.toFixed(1)}M`;
          };

          const option = {
            backgroundColor: "transparent",
            title: {
              text: Title,
              subtext: SubTitle,
              left: "0",
              textStyle: { color: "#E7F0FF", fontWeight: 700, fontSize: 16 },
              subtextStyle: { color: "rgba(231,240,255,0.7)", fontWeight: 400, fontSize: 12 },
            },
            tooltip: {
              trigger: "axis",
              axisPointer: { type: "shadow" },
              backgroundColor: "rgba(16, 24, 40, 0.9)",
              borderColor: "rgba(255,255,255,0.08)",
              textStyle: { color: "#E7F0FF" },
              formatter: (params) => {
                if (!Array.isArray(params) || params.length === 0) return "";
                const safeParams = params.filter(Boolean);
                if (safeParams.length === 0) return "";
                const lines = [safeParams[0] && safeParams[0].axisValue != null ? safeParams[0].axisValue : ""];
                safeParams.forEach((p) => {
                  const val = Number(p && p.value);
                  const label = isFinite(val) ? formatMillions(val) : (p && p.value != null ? p.value : "");
                  const marker = (p && p.marker) ? p.marker : "";
                  const sName = (p && p.seriesName) ? p.seriesName : "";
                  lines.push(`${marker} ${sName}: ${label}`);
                });
                return lines.join("<br/>");
              },
            },
            legend: {
              top: 8,
              right: 10,
              icon: "rect",
              itemWidth: 10,
              itemHeight: 10,
              textStyle: { color: Theme==='light'?'#526577':'#C9D6EF' },
              data: [seriesANameSafe, seriesBNameSafe],
            },
            grid: { left: "2%", right: "2%", top: 56, bottom: 36, containLabel: true },
            xAxis: [
              {
                type: "category",
                data: categories,
                axisLine: { lineStyle: { color: "rgba(231,240,255,0.18)" } },
                axisTick: { show: false },
                axisLabel: { color: Theme==='light'?'#526577':'#C9D6EF' },
              },
            ],
            yAxis: [
              {
                type: "value",
                min: 0,
                splitNumber: 8,
                axisLine: { show: false },
                axisTick: { show: false },
                axisLabel: { color: Theme === 'light' ? '#333333' : '#C9D6EF', formatter: (val) => NumberFormat === 'usd_whole' ? (Theme === 'light' ? '' : '$') + (Math.abs(Number(val))>=1000?(Number(val)/1000)+'K':Number(val)) : `$${Number(val).toFixed(1)}M` },
                splitLine: { lineStyle: { color: Theme==='light'?'#e8edf2':'rgba(231,240,255,0.10)' } },
              },
            ],
            series: [
              {
                name: seriesANameSafe,
                type: "bar",
                barWidth: 50,
                barGap: "25%",
                itemStyle: {
                  borderRadius: [6, 6, 0, 0],
                  color: SeriesAColor || {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "#FF7A6E" },
                      { offset: 1, color: "#FF4D4D" },
                    ],
                  },
                },
                emphasis: { itemStyle: { shadowBlur: 8, shadowColor: "rgba(255,122,110,0.5)" } },
                label: {
                  show: true,
                  position: "insideTop",
                  formatter: ({ value }) => formatMillions(value),
                  color: "#FFFFFF",
                  fontSize: 14,
                  fontWeight: 700,
                  padding: [0, 0, 6, 0],
                },
                data: aData,
              },
              {
                name: seriesBNameSafe,
                type: "bar",
                barWidth: 50,
                itemStyle: {
                  borderRadius: [6, 6, 0, 0],
                  color: SeriesBColor || {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      { offset: 0, color: "#5BA8FF" },
                      { offset: 1, color: "#2F6BFF" },
                    ],
                  },
                },
                emphasis: { itemStyle: { shadowBlur: 8, shadowColor: "rgba(91,168,255,0.45)" } },
                label: {
                  show: true,
                  position: "insideTop",
                  formatter: ({ value }) => formatMillions(value),
                  color: "#FFFFFF",
                  fontSize: 14,
                  fontWeight: 700,
                  padding: [0, 0, 6, 0],
                },
                data: bData,
              },
            ],
          };

          if (Theme === 'light') {
            option.title = { text: Title || '', left: 10, top: 8, textStyle: { color: '#333333', fontSize: 18 } };
            option.legend.textStyle.color = '#333333';
            option.xAxis[0].axisLabel.color = '#333333';
            option.xAxis[0].axisLine.lineStyle.color = '#dddddd';
            option.yAxis[0].splitLine.show = false;
            option.series.forEach(series => { series.barWidth = 120; });
          }
          if (NumberFormat === 'usd_whole') {
            if(!AutoScale)option.yAxis[0].max = Theme === 'light' ? 300000 : 240000;
            option.yAxis[0].interval = 30000;
            option.legend.orient = Theme === 'light' ? 'horizontal' : 'vertical';
            option.series.forEach(series => { series.itemStyle.borderRadius = [2,2,0,0]; });
          }
          if (window.__ROI_AGENT_QA_ENABLED__ === true) option.animation = false;
          return (
            <>
              <div className="echart-wrapper" style={{ opacity: inputOpacity }}>
                <ReactEcharts style={{ height: `${Number(Height) || 260}px`, width: "100%" }} option={option} />
              </div>
            </>
          );
        },
      },

      eCharts: {
        render: ({ Chart, hide }) => {
          const inputOpacity = hide ? 0.5 : 1;

          const PieChartStyle = {
            height: "330px",
            width: "100%",
          };

          const BarChartStyle = {
            height: "206px",
            width: "100%",
          };

          return (
            <>
              <div className="echart-wrap" style={{ opacity: inputOpacity }}>
                {(() => {
                  if (Chart.chooseChart === "pie") {
                    return (
                      <ReactEcharts
                        style={PieChartStyle}
                        option={pieEChart(Chart.items, Chart.title, Chart.value)}
                      />
                    );
                  } else if (Chart.chooseChart === "bar") {
                    return (
                      <ReactEcharts
                        style={BarChartStyle}
                        option={barEChart(Chart.items, Chart.title, Chart.value)}
                      />
                    );
                  }
                  return null;
                })()}
              </div>
            </>
          );
        },
      },

      ToggleSwitch: {
        render: ({ items, ID, hide, Margin, Style }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative d-flex align-items-center ${Style?.Alignment
                  }`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                <div
                  className={`roi-toggle-switch d-flex align-items-center`}
                  style={{
                    borderStyle: "solid",
                    borderColor: "#B6B7B8",
                    borderWidth: `1px 1px 1px 1px`,
                    borderRadius: `4px`,
                  }}
                >
                  {items.map((item, i) => (
                    <div className="form-check" key={i}>
                      <input
                        autoComplete="off"
                        className="form-check-input"
                        name={ID}
                        type="radio"
                        defaultValue
                        id={`${ID}-${i}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`${ID}-${i}`}
                      >
                        {item.Option}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </>
          );
        },
      },

      Collapsible: {
        render: ({ ID }) => {
          // Calculate opacity based on hide value
          // const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="collapse-header collapsed"
                data-bs-toggle="collapse"
                href={`#${ID}`}
                role="button"
                aria-expanded="false"
                aria-controls={`${ID}`}
              >
                <DropZone zone={`collapse-header`} />
                <div className="drop-icon">
                  <Svg name="collapsible-icon" />
                </div>
              </div>

              <div className="collapse-body collapse" id={`${ID}`}>
                <DropZone zone={`collapse-body`} />
              </div>
            </>
          );
        },
      },

      Collapsible2: {
        render: function FrontendCollapsible({ itemId, headerText }) {
          // Props:
          // - itemId: The unique ID for this collapsible.
          // - headerText: The custom header text from admin, if provided.
          // - zones: Object containing content from DropZones (e.g., zones.content).

          const collapseRef = React.useRef(null);
          const buttonRef = React.useRef(null);

          // Function to determine the initial button text
          const getInitialButtonText = () => {
            if (headerText) {
              // If a specific header text is provided, always use it
              return headerText;
            }
            // Otherwise, default to "Show Details" as it starts collapsed on frontend
            return "Show Details";
          };

          const [currentButtonText, setCurrentButtonText] = React.useState(
            getInitialButtonText()
          );

          React.useEffect(() => {
            const collapsibleElement = collapseRef.current;
            const triggerButton = buttonRef.current;

            if (!collapsibleElement || !triggerButton) {
              return; // Exit if refs are not yet set
            }

            const updateTextBasedOnState = () => {
              if (headerText) {
                // If a specific headerText is provided, always use that
                setCurrentButtonText(headerText);
                return;
              }
              // Check if the collapsible element has the 'show' class (is open)
              if (collapsibleElement.classList.contains("show")) {
                setCurrentButtonText("Hide Details");
              } else {
                setCurrentButtonText("Show Details");
              }
            };

            // Bootstrap event listeners to update text after animations complete
            const handleShown = () => updateTextBasedOnState();
            const handleHidden = () => updateTextBasedOnState();

            collapsibleElement.addEventListener(
              "shown.bs.collapse",
              handleShown
            );
            collapsibleElement.addEventListener(
              "hidden.bs.collapse",
              handleHidden
            );

            // Initial text update in case the component mounts in an unexpected state
            // or if 'show' class was somehow added initially by other means.
            updateTextBasedOnState();

            // Cleanup: remove event listeners when the component unmounts or dependencies change
            return () => {
              collapsibleElement.removeEventListener(
                "shown.bs.collapse",
                handleShown
              );
              collapsibleElement.removeEventListener(
                "hidden.bs.collapse",
                handleHidden
              );
            };
          }, [itemId, headerText]); // Dependencies for the effect

          const collapseId = `collapse-${itemId}`; // Unique ID for the Bootstrap content div
          const headingId = `heading-${itemId}`; // Unique ID for the Bootstrap header

          // Frontend default: start collapsed. Bootstrap JS handles adding/removing 'show'.
          const collapseClasses = ["accordion-collapse", "collapse"];
          const initialAriaExpanded = "false";
          const initialButtonClassName = "accordion-button collapsed";

          return (
            <div className="accordion-item details-accordion">
              <h2 className="accordion-header" id={headingId}>
                <button
                  ref={buttonRef}
                  className={initialButtonClassName}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${collapseId}`}
                  aria-expanded={initialAriaExpanded}
                  aria-controls={collapseId}
                >
                  {currentButtonText}
                </button>
              </h2>
              <div
                ref={collapseRef}
                id={collapseId}
                className={collapseClasses.join(" ")}
                aria-labelledby={headingId}
              // If you implement accordion groups via a 'parentId' prop from admin:
              // data-bs-parent={props.parentId ? `#${props.parentId.replace(/^#/, '')}` : undefined}
              >
                <div className="accordion-body">
                  <DropZone zone="content" />
                </div>
              </div>
            </div>
          );
        },
      },

      IconUploader: {
        render: ({
          iconFile,
          iconFallbackUrl,
          iconWidth,
          iconHeight,
          puck,
        }) => {
          // Helper to prepare src for img tag (handles raw SVG and data URLs)
          const getDisplaySrc = (imgValue) => {
            if (
              typeof imgValue === "string" &&
              imgValue.trim().startsWith("<svg")
            ) {
              return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
                imgValue
              )}`;
            }
            return imgValue; // Assumes it's already a data URL or external URL
          };

          const primarySrc = getDisplaySrc(iconFile);
          const fallbackSrc = getDisplaySrc(iconFallbackUrl); // Fallback could also be raw SVG

          const imgSrc = primarySrc || fallbackSrc;
          const displayWidth = iconWidth || 24;
          const displayHeight = iconHeight || 24;

          return (
            <div>
              {imgSrc ? (
                <img
                  src={imgSrc}
                  alt="Icon"
                  style={{
                    width: `${displayWidth}px`,
                    height: `${displayHeight}px`,
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    verticalAlign: "middle",
                  }}
                />
              ) : (
                puck &&
                puck.isEditing && (
                  <span style={{ fontSize: "10px", color: "#aaa" }}>
                    No Icon
                  </span>
                )
              )}
            </div>
          );
        },
      },

      ResultsPageHeader: {
        render: ({ logo, hide, showDownloadButton, showRecalculateButton, contactUsButtonLink }) => {
          const inputOpacity = hide ? 0.5 : 1;

          const handleRecalculateClick = (event) => {
            // Find the icon element within the clicked button
            // This is a bit more direct DOM traversal
            const button = event.currentTarget;
            const iconDiv = button.querySelector(".icon"); // Assumes .icon is the direct child or descendant

            if (iconDiv) {
              // Check if animation is already running to prevent re-triggering too fast
              if (iconDiv.classList.contains("recalculate-icon-rotate")) {
                return;
              }

              iconDiv.classList.add("recalculate-icon-rotate");

              // Remove the class after animation completes
              setTimeout(() => {
                iconDiv.classList.remove("recalculate-icon-rotate");
              }, 500); // Must match your CSS animation duration (0.5s = 500ms)
            }

          };


          const jumpToReport = async () => {
            setIsLoadingdownload(true);
            try {
              // Prepare data for the first API calls
              let data = JSON.stringify({
                roi_submitted_master_data_id: roiId,
                structure: JSON.stringify(roiActionArr_global.current),
                currency_symbol: JSON.stringify({
                  currencySymbol: currencySymbol,
                  currency: currency,
                }),
                add_date_time: new Date()
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " "),
              });

              // Configuration for the first API call
              let config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${apiUrl}/roi-submit-data/create`,
                headers: {
                  "Content-Type": "application/json",
                },
                data: data,
              };

              // Perform the first API call
              const response = await axios.request(config);

              // Generate UUID and URL for PDF download
              let newuuid = uuidv4();
              let generateUrl = `/roi/${roiId}/report/${newuuid}`;

              //   // Prepare data for PDF download API call
              data = JSON.stringify({
                url: `${frntUrl}${generateUrl}`,
                reportname: "cx_ai_calculator_report_pdf",
              });

              //   // Configuration for PDF download API call
              config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${apiUrl}/roi-pages/reportPageDownload`,
                headers: {
                  "Content-Type": "application/json",
                },
                data: data,
                responseType: "blob",
              };

              // Perform PDF download API call
              const pdfResponse = await axios.request(config);

              // Create a link element, set URL to response, and trigger download
              const url = window.URL.createObjectURL(
                new Blob([pdfResponse.data])
              );
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `cx_ai_calculator_report-${roiId}.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } catch (error) {
              console.error("Error in jumpToReport:", error);
            } finally {
              setIsLoadingdownload(false); // Stop loading when process is complete
            }
          };


          return (
            <div
              className={`roi-header-main`}
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  <a
                    href="#"
                    className="logo"
                    data-bs-toggle="modal"
                    data-bs-target="#logoPrompt"
                  >
                    {logo ? (
                      <img src={logo} alt="" />
                    ) : (
                      <img src={logo_fallback} alt="" />
                    )}
                  </a>
                  <div className="flex-grow-1">
                    {(showDownloadButton || showRecalculateButton) && ( // Use && for cleaner conditional rendering
                      <div className="d-flex currency-language">
                        {showRecalculateButton && (
                          <button
                            title="Recalculate"
                            className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3 px-3"
                            onClick={handleRecalculateClick}
                            data-bs-toggle="modal"
                            data-bs-target="#logoPrompt"
                          >
                            <div className="icon">
                              {" "}
                              {/* This div will get the animation class */}
                              <Svg name="roi-recalculate-icon" />
                            </div>

                          </button>
                        )}

                        {contactUsButtonLink && <>
                          <a target="_blank" href={contactUsButtonLink} className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-3">Contact Us
                          </a>
                        </>}
                        {showDownloadButton && (

                          <button
                            className={`d-inline-flex align-items-center btn roi-btn-primary gap-3`}
                            onClick={jumpToReport}
                            disabled={isLoadingdownload} // Disable button while loading
                          >
                            {isLoadingdownload ? (
                              <>
                                <span
                                  className="spinner-border spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                              </>
                            ) : (
                              <>
                                Download Report
                                <div className="icon">
                                  <Svg name="roi-download-icon" />
                                </div>
                              </>
                            )}

                          </button>

                        )}

                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        },
      },
      ResultsPageHeader2: {
        render: ({ logo1, logo2, logo3, absolutePosition, whiteHeader, showDownloadButton, showRecalculateButton, contactUsButtonLink, knowMoreButtonLink }) => {

          const handleRecalculateClick = (event) => {
            // Find the icon element within the clicked button
            // This is a bit more direct DOM traversal
            const button = event.currentTarget;
            const iconDiv = button.querySelector(".icon"); // Assumes .icon is the direct child or descendant

            if (iconDiv) {
              // Check if animation is already running to prevent re-triggering too fast
              if (iconDiv.classList.contains("recalculate-icon-rotate")) {
                return;
              }

              iconDiv.classList.add("recalculate-icon-rotate");

              // Remove the class after animation completes
              setTimeout(() => {
                iconDiv.classList.remove("recalculate-icon-rotate");
              }, 500); // Must match your CSS animation duration (0.5s = 500ms)
            }

          };


          const jumpToReport = async () => {
            setIsLoadingdownload(true);
            try {
              // Prepare data for the first API calls
              let data = JSON.stringify({
                roi_submitted_master_data_id: roiId,
                structure: JSON.stringify(roiActionArr_global.current),
                currency_symbol: JSON.stringify({
                  currencySymbol: currencySymbol,
                  currency: currency,
                }),
                add_date_time: new Date()
                  .toISOString()
                  .slice(0, 19)
                  .replace("T", " "),
              });

              // Configuration for the first API call
              let config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${apiUrl}/roi-submit-data/create`,
                headers: {
                  "Content-Type": "application/json",
                },
                data: data,
              };

              // Perform the first API call
              const response = await axios.request(config);

              // Generate UUID and URL for PDF download
              let newuuid = uuidv4();
              let generateUrl = `/roi/${roiId}/report/${newuuid}`;

              //   // Prepare data for PDF download API call
              data = JSON.stringify({
                url: `${frntUrl}${generateUrl}`,
                reportname: "cx_ai_calculator_report_pdf",
              });

              //   // Configuration for PDF download API call
              config = {
                method: "post",
                maxBodyLength: Infinity,
                url: `${apiUrl}/roi-pages/reportPageDownload`,
                headers: {
                  "Content-Type": "application/json",
                },
                data: data,
                responseType: "blob",
              };

              // Perform PDF download API call
              const pdfResponse = await axios.request(config);

              // Create a link element, set URL to response, and trigger download
              const url = window.URL.createObjectURL(
                new Blob([pdfResponse.data])
              );
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `cx_ai_calculator_report-${roiId}.pdf`);
              document.body.appendChild(link);
              link.click();
              document.body.removeChild(link);
            } catch (error) {
              console.error("Error in jumpToReport:", error);
            } finally {
              setIsLoadingdownload(false); // Stop loading when process is complete
            }
          };


          return (
            <>
              <div className={`tco-header-main ${absolutePosition && 'absolute-position'} ${whiteHeader && 'header-white'}`}>
                <div className="tco-container">
                  <div className="header-wrapper-top">
                    <Link to="" className="logo">
                      <img src={logo1} alt="" />
                    </Link>
                    <Link to="" className="logo">
                      <img src={logo2} alt="" />
                    </Link>
                  </div>
                  {logo3 &&
                    <div className="header-wrapper-bottom d-flex justify-content-between align-items-center">
                      <Link to="" className="logo">
                        <img src={logo3} alt="" />
                      </Link>
                      <div className="flex-grow-1 ">
                        {(showDownloadButton || knowMoreButtonLink || contactUsButtonLink || showRecalculateButton) && ( // Use && for cleaner conditional rendering
                          <div className="d-flex currency-language align-items-center justify-content-end">
                            {showRecalculateButton && (
                              <button
                                title="Recalculate"
                                className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-2"
                                onClick={handleRecalculateClick}
                                data-bs-toggle="modal"
                                data-bs-target="#logoPrompt"
                              >
                                <div className="icon">
                                  {" "}
                                  {/* This div will get the animation class */}
                                  <Svg name="roi-recalculate-icon" />
                                </div>

                              </button>
                            )}


                            {showDownloadButton && (

                              <button
                                className={`d-inline-flex align-items-center btn roi-btn-primary roi-btn-primary-gradient gap-2`}
                                onClick={jumpToReport}
                                disabled={isLoadingdownload} // Disable button while loading
                              >
                                {isLoadingdownload ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                  </>
                                ) : (
                                  <>
                                    <Svg name="roi-download-icon-2" />
                                    Download Report
                                  </>
                                )}

                              </button>

                            )}
                            {knowMoreButtonLink && <>
                              <a target="_blank" href={knowMoreButtonLink} className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-2">
                                <div className="icon">
                                  <Svg name="roi-know-more-icon" />
                                </div>
                                Know more
                              </a>
                            </>}
                            {contactUsButtonLink && <>
                              <a target="_blank" href={contactUsButtonLink} className="d-inline-flex align-items-center btn roi-btn-outline-primary gap-2">
                                <Svg name="roi-schedule-icon" />
                                Schedule a Consultation
                              </a>
                            </>}

                          </div>
                        )}
                      </div>
                    </div>
                  }
                </div>
              </div>

            </>
          );
        },
      },
      Separator: {

        render: ({ color, height, margin }) => {
          return (
            <div className="separator" style={{ backgroundColor: color, height: `${height}px`, margin: `${margin?.top}px ${margin?.right}px ${margin?.bottom}px ${margin?.left}px` }}>

            </div>
          )
        },
      },
    },
  };

  //currency change
  const currencyChange = async (e) => {
    let currency_selected = e.target.value;
    let current_currency = "USD";
    let current_symbol = "$";
    let exchange_rate = 1;
    let calculated_arr_global = [];
    let updatedRoiActionArr = JSON.parse(JSON.stringify(roiActionArr_global.current));

    const response = await fetch(`${apiUrl}/roi-currency/list`);
    const result = await response.json();
    const res = result.data;

    Object.keys(res).map((key) => {
      if (res[key].currency_name == currency_selected) {
        current_currency = res[key].currency_name;
        exchange_rate = res[key].exchange_rate;
        current_symbol = res[key].symbol;
      }
    });
    // let currency_rate = currencyRates[currency_selected];
    let changedCurrency__ = changedCurrency ? changedCurrency : defaultCurrency;
    if (
      (changedCurrency__ == "USD" && changedCurrency__ != current_currency) ||
      (defaultCurrency == "USD" &&
        changedCurrency__ == "" &&
        current_currency != "USD")
    ) {
      await Object.keys(roiActionArr_global.current).map((key) => {
        if (
          roiActionArr_global.current[key].value != 0 &&
          key != "" &&
          typeof roiActionArr_global.current[key].value == "number" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(updatedRoiActionArr[key].value * exchange_rate),
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(roiActionArr_global.current[key].value * exchange_rate).toFixed(
              2
            ),
          });
        } else if (
          roiActionArr_global.current[key].value != 0 &&
          typeof roiActionArr_global.current[key].value == "string" &&
          key != "" &&
          !isNaN(roiActionArr_global.current[key].value) &&
          roiActionArr_global.current[key].value !== "" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(
                parseFloat(updatedRoiActionArr[key].value) * exchange_rate
              ),
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(
              parseFloat(roiActionArr_global.current[key].value) * exchange_rate
            ).toFixed(2),
          });
        }
      });
    }

    if (
      changedCurrency__ != "USD" &&
      changedCurrency__ != current_currency &&
      changedCurrency__ != ""
    ) {
      await Object.keys(roiActionArr_global.current).map((key) => {
        if (
          roiActionArr_global.current[key].value != 0 &&
          key != "" &&
          typeof roiActionArr_global.current[key].value == "number" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value:
                (updatedRoiActionArr[key].value / exchangeRate) * exchange_rate,
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(
              parseFloat(roiActionArr_global.current[key].value / exchangeRate) * exchange_rate
            ).toFixed(2),
          });
        } else if (
          roiActionArr_global.current[key].value != 0 &&
          typeof roiActionArr_global.current[key].value == "string" &&
          key != "" &&
          !isNaN(roiActionArr_global.current[key].value) &&
          roiActionArr_global.current[key].value !== "" &&
          roiActionArr_global.current[key].currency == "1"
        ) {
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(
                (parseFloat(updatedRoiActionArr[key].value) / exchangeRate) *
                exchange_rate
              ),
            },
          };
          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;
          calculated_arr_global.push({
            variable: key,
            value: parseFloat(
              (parseFloat(roiActionArr_global.current[key].value) / exchangeRate) *
              exchange_rate
            ).toFixed(2),
          });
        }
      });
    }
    setChangedCurrency(current_currency);
    setCurrencySymbol(current_symbol);
    setExchangeRate(exchange_rate);

    //now create global array and pass it to update all uuid
    await updateValueForRenderAllPages(calculated_arr_global);
  };

  //redirect to home page
  const homeRedirect = () => {
    window.location.reload();
  };

  const [handleModalOpen, setHandleModalOpen] = useState(false);
  const changeModal = () => {
    setHandleModal(false); // Set to false to show the modal (adds "show d-block" class)
    setHandleModalOpen(true);
  };

  // Recursive function to get values by ID
  function getFormValuesById(container) {
    const result = {};

    function traverse(node) {
      if (node instanceof HTMLInputElement) {
        if (node.id) {
          if (node.type === 'checkbox') {
            result[node.id] = node.checked;
          } else if (node.type === 'radio') {
            if (node.checked) {
              result[node.id] = node.value;
            }
          } else {
            result[node.id] = node.value;
          }
        }
      } else if (node instanceof HTMLTextAreaElement) {
        if (node.id) {
          result[node.id] = node.value;
        }
      } else if (node instanceof HTMLSelectElement) {
        if (node.id) {
          if (node.multiple) {
            const selected = Array.from(node.selectedOptions).map(opt => opt.value);
            result[node.id] = selected;
          } else {
            result[node.id] = node.value;
          }
        }
      } else {
        Array.from(node.children).forEach(child => traverse(child));
      }
    }

    traverse(container);
    return result;
  }


  //for button or link
  const onButtonClick =
    async (uuid, place) => {
      //extracting form values from the page
      //condition added because handleChange is not working on button click
      const formValues = getFormValuesById(document.body);
      let form_assign_arr = {};

      //updating the roiActionArr with the form values
      //this is done because handleChange is not working on button click
      // Loop through form values and update roiActionArr
      let roiActionArr__ = JSON.parse(JSON.stringify(roiActionArr_global.current));
      Object.keys(formValues).forEach(async (elementId) => {
        if (
          elementId !== "" &&
          elementId !== undefined &&
          elementId !== null &&
          formValues[elementId] !== "" &&
          formValues[elementId] !== undefined &&
          formValues[elementId] !== null
        ) {
          // Only update if value has changed
          if (roiActionArr__[elementId] && roiActionArr__[elementId].value !== formValues[elementId]) {
            roiActionArr__ = {
              ...roiActionArr__,
              [elementId]: {
                ...roiActionArr__[elementId],
                value: formValues[elementId],
              },
            };
            //updating the calculated_arr_global with the new value
            form_assign_arr[elementId] = {
              'uuid': elementId,
              'value': formValues[elementId]
            };

          }

        }
      });
      //for updating button is clicked
      roiActionArr__ = {
        ...roiActionArr__,
        [uuid]: {
          ...roiActionArr__[uuid],
          value: 1,
        },
      };

      // Update the state with the new object
      roiActionArr_global.current = roiActionArr__;

      if (roiActionArr_global.current[uuid].actions === "JumpToPage") {
        const targetPageId =
          roiActionArr_global.current[uuid].action_id ||
          roiActionArr_global.current[uuid].link ||
          "";
        if (!targetPageId) {
          console.warn("JumpToPage: missing target page UUID on button", uuid);
          return;
        }
        jumpToPage(targetPageId, form_assign_arr);
      } else if (roiActionArr_global.current[uuid].actions === "JumpToUrl") {
        const actionId = roiActionArr_global.current[uuid].action_id || "";
        let link = roiActionArr_global.current[uuid].link;
        if (
          (!link || link === "#") &&
          actionId &&
          /^[0-9a-f-]{36}$/i.test(actionId)
        ) {
          jumpToPage(actionId, form_assign_arr);
          return;
        }
        if (link && link !== "#") {
          window.open(link, "_blank");
        }
      } else if (roiActionArr_global.current[uuid].actions === "OpenPopup") {
        //condition for jump to page
        openPopup(roiActionArr_global.current[uuid].action_id, form_assign_arr);
      } else if (roiActionArr_global.current[uuid].actions === "JumpToMethod") {
       // alert(`JumpToMethod called: `);
        const methodName =
          roiActionArr_global.current[uuid].action_id ||
          roiActionArr_global.current[uuid].link;
        const handler =
          customButtonMethods?.[methodName] ||
          (typeof window !== "undefined" ? window[methodName] : null);

        // if (methodName) {
        //   alert(`JumpToMethod called: ${methodName}`);
        // }

        if (typeof handler === "function") {
          try {
            await handler({
              uuid,
              action: roiActionArr_global.current[uuid],
              formValues: form_assign_arr,
              roiActionArr: roiActionArr_global.current,
            });
          } catch (err) {
            console.error(`JumpToMethod handler "${methodName}" failed`, err);
          }
        } else {
          console.warn(`JumpToMethod handler "${methodName}" not found or not a function`);
        }
      } else if (roiActionArr_global.current[uuid].actions === "JumpToReport") {
        // For JumpToReport, first run all logic and validations (like JumpToPage).
        // Only if there are no validation errors (checkRequired === true),
        // proceed to generate and download the report.
        const ok = await jumpToPage(currentPageId.current, form_assign_arr);
        if (ok) {
          await jumpToReport();
        }
      }
    };

  const jumpToReport = async () => {
    setIsLoadingdownload(true);
    //alert("jumpToReport called");

    let roiMasterId = null;

    // Step 1: Save ROI data (required for report generation)
    try {
      let data = JSON.stringify({
        roi_submitted_master_data_id: roiId,
        structure: JSON.stringify(roiActionArr_global.current),
        currency_symbol: JSON.stringify({
          currencySymbol: currencySymbol,
          currency: currency,
        }),
        add_date_time: new Date()
          .toISOString()
          .slice(0, 19)
          .replace("T", " "),
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiUrl}/roi-submit-data/create`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };

      const response = await axios.request(config);
      roiMasterId = response?.data?.id || null;
    } catch (saveError) {
      console.error("Failed to save ROI data:", saveError);
    }

    // Step 2: Generate and download PDF FIRST
    try {
      let newuuid = uuidv4();
      let generateUrl = `/roi/${roiId}/report/${newuuid}`;

      let data = JSON.stringify({
        url: `${frntUrl}${generateUrl}`,
        reportname: "cx_ai_calculator_report_pdf",
      });

      let config = {
        method: "post",
        maxBodyLength: Infinity,
        url: `${apiUrl}/roi-pages/reportPageDownload`,
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
        responseType: "blob",
      };

      const pdfResponse = await axios.request(config);

      // Trigger PDF download
      const url = window.URL.createObjectURL(new Blob([pdfResponse.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `cx_ai_calculator_report-${roiId}.pdf`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      console.log("PDF downloaded successfully");
      
      // Hide loader immediately after PDF download completes
      setIsLoadingdownload(false);
      
      // Show success message
      toast.success("Report downloaded successfully!", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    } catch (pdfError) {
      console.error("Failed to download PDF:", pdfError);
      // Hide loader even if PDF download failed
      setIsLoadingdownload(false);
      
      // Show error message
      toast.error("Failed to download report. Please try again.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }

    // Step 3: HubSpot update (runs in background after loader is hidden)
    try {
      const userId = localStorage.getItem("userid");
      if (userId) {
        await axios.patch(`${apiUrl}/hubspot/visit/update`, {
          contactId: userId,
          key: "report_download",
          value: "true",
        });
        console.log("HubSpot visit updated: report_download = true");

        await axios.patch(`${apiUrl}/hubspot/visit/update`, {
          contactId: userId,
          key: "completion_status",
          value: "completed",
        });
        console.log("HubSpot visit updated: completion_status = completed");
      } else {
        console.warn("No userid found in localStorage, skipping HubSpot update");
      }
    } catch (hubspotErr) {
      console.error("Failed to update HubSpot visit:", hubspotErr);
    }

    // Step 4: Marketo sync lead (runs even if PDF download or HubSpot failed)
    if (marketoEnabled) {
      try {
        const email = localStorage.getItem("user_email") || "";
        const userdata = localStorage.getItem("userdata");
        let parsedUser = {};
        try {
          parsedUser = userdata ? JSON.parse(userdata) : {};
        } catch (_) {
          parsedUser = {};
        }
        const marketoPayload = {
          first_name: parsedUser.firstname || parsedUser.first_name || "",
          last_name: parsedUser.lastname || parsedUser.last_name || "",
          business_email: email,
          select_industry: parsedUser.industry || "",
          organisation: parsedUser.organisation || parsedUser.company || "",
          designation: parsedUser.designation || "",
          phone_number: parsedUser.phone || "",
          select_country: parsedUser.country || "",
          select_state: parsedUser.state || "",
          utm_campaign: parsedUser.utm_campaign || "",
          utm_medium: parsedUser.utm_medium || "",
          utm_source: parsedUser.utm_source || "",
          lead_id: parsedUser.lead_id || parsedUser.id_number || "",
          roiId,
          roiMasterId: roiMasterId,
        };
        await pushMarketoLead(marketoPayload);
        console.log("Marketo lead synced successfully");
      } catch (marketoErr) {
        console.error("Failed to sync Marketo lead:", marketoErr);
      }
    }
  };

  const jumpToPage =
    async (id, assign_arr) => {
      try {
        // Close any open modals when navigating to a new page
        setHandleModalOpen(false);
        setHandleModal(true);
        
        console.log('[ROI] jumpToPage targetId:', id, 'from currentPageId:', currentPageId.current);
        let checkRequired = true;
        //logic to check if any field is in required check on full page on any button click
        const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
        console.log('[ROI] elements on current page:', elements_by_page_id_current.length);
        console.log('[ROI] available pageIds:', Object.keys(roipages.current || {}));
        const elements = Object.keys(roiActionArr_global.current);
        console.log('[ROI] elements:', elements);
        let error_messages = {};
        // Clear existing errors for all fields on current page when Next button is clicked
        const clearErrorMessages = {};
        for (let index = 0; index < elements.length; index++) {
          const element = elements[index];
          if (roiActionArr_global.current[element].roi_page_id == currentPageId.current) {
            clearErrorMessages[element] = {
              'uuid': element,
              'errorMessage': ""
            };
          }
        }

        // IMPORTANT: Process business logic first to get updated values
        // Then process conditional errors based on the updated values
        let process_arr = await processLogic();

        // Merge cleared error messages first
        error_messages = mergeUpdatesByUUID(error_messages, clearErrorMessages);

        let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
        if (Object.keys(error_messages_conditional).length > 0) {
          for (const key of Object.keys(error_messages_conditional)) {
            if (error_messages_conditional[key].errorMessage == "") {
              delete error_messages_conditional[key];
            }
          }
          if (Object.keys(error_messages_conditional).length > 0) {
            error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
            checkRequired = false;
          }

        }


        for (let index = 0; index < elements.length; index++) {
          const element = elements[index];
          if (
            roiActionArr_global.current[element].roi_page_id != undefined &&
            roiActionArr_global.current[element].required == true &&
            roiActionArr_global.current[element].value == "" &&
            roiActionArr_global.current[element].type == "InputTextField" &&
             roiActionArr_global.current[element].roi_page_id == currentPageId.current
          ) {
            console.log('[ROI] element:', roiActionArr_global.current[element]);
            let errorMessage = "Please enter a valid value";
            checkRequired = false;
            error_messages[element] = {
              // pageId: currentPageId.current,
              'uuid': element,
              'errorMessage': errorMessage
            };

            // Also update the global state with the error message
            roiActionArr_global.current[element] = {
              ...roiActionArr_global.current[element],
              errorMessage: errorMessage
            };
          }
          if (
            roiActionArr_global.current[element].roi_page_id != undefined &&
            roiActionArr_global.current[element].required == true &&
            roiActionArr_global.current[element].value == 0 &&
            roiActionArr_global.current[element].type == "Checkbox Option" &&
            roiActionArr_global.current[element].roi_page_id == currentPageId.current
          ) {
            let errorMessage = "Please select above checkbox";
            checkRequired = false;
            error_messages[roiActionArr_global.current[element].checkbox_id] = {
              // pageId: currentPageId.current,
              'uuid': roiActionArr_global.current[element].checkbox_id,
              'errorMessage': errorMessage
            };

            // Also update the global state with the error message
            roiActionArr_global.current[element] = {
              ...roiActionArr_global.current[element],
              errorMessage: errorMessage
            };
          }
          if (
            roiActionArr_global.current[element].roi_page_id != undefined &&
            roiActionArr_global.current[element].required == true &&
            roiActionArr_global.current[element].value == 0 &&
            roiActionArr_global.current[element].type == "Radio" &&
            roiActionArr_global.current[element].roi_page_id == currentPageId.current
          ) {
            // console.log("element", element);
            let errorMessage = "Please select at least one option";
            checkRequired = false;
            error_messages[element] = {
              'uuid': element,
              'errorMessage': errorMessage
            };

            // Also update the global state with the error message
            roiActionArr_global.current[element] = {
              ...roiActionArr_global.current[element],
              errorMessage: errorMessage
            };
          }

          if (elements.length - 1 == index && !checkRequired) {
            renderChanges(assign_arr, error_messages, process_arr);
          }
          if (elements.length - 1 == index && checkRequired) {
            // Gather selected form data for the current page before jumping
            try {
              const currPage = currentPageId.current;
              const selectedData = {};
              Object.keys(roiActionArr_global.current || {}).forEach((key) => {
                const item = roiActionArr_global.current[key];
                if (!item) return;
                if (item.roi_page_id === currPage) {
                  const val = item.value;
                  const hasValue = !(val === undefined || val === null || val === "");
                  if (item.type === "Range") {
                    console.log('[ROI] Range field selected:', { uuid: key, value: val });
                  }
                  if (hasValue) {
                    selectedData[key] = {
                      type: item.type || "",
                      value: val,
                      text: item.text || undefined,
                    };
                  }
                }
              });
              console.log('[ROI] Selected form roiActionArr_global:', roiActionArr_global);
              console.log('[ROI] Selected form data on current page:', selectedData);
            } catch (e) {
              console.warn('[ROI] Failed to collect selected form data:', e);
            }

            currentPageId.current = id;
            console.log('[ROI] jumpToPage set currentPageId to:', currentPageId.current);
            renderChanges(assign_arr, error_messages, process_arr);
            if (typeof window !== 'undefined') {
              window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }
          }

        }

        return checkRequired;

      } catch (error) {
        console.error("Error with GET request:", error);
        return false;
      }
    };

  const openPopup = async (id) => {
    try {
      //setRenderModalData(JSON.parse(roipages[id]));

      setCurrentPopupPageId(id);
      setPopupStatus(true);
    } catch (error) {
      console.error("Error with GET request:", error);
    }
  };

  const refreshParentPage = async () => {
    setCurrentPopupPageId("");
    setPopupStatus(false);
  };


  const evaluateConditionError = (condition) => {
    let value = condition["value"] ?? "";
    const operator = condition["operator"] ?? "";
    const value_type = condition["value_type"] ?? "";
    if (value_type == "dynamic") {
      value = roiActionArr_global.current[value]?.value;
    }
    const variable = condition["variable"] ?? "";

    let return__ = false;
    if (roiActionArr_global.current[variable]?.value != undefined) {
      switch (operator) {
        case "==":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) == value);
          }
          break;
        case "!=":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) != value);
          }
          break;
        case ">":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) > value);
          }
          break;
        case "<":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) < value);
          }
          break;
        case ">=":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) >= value);
          }
          break;
        case "<=":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(parseFloat(roiActionArr_global.current[variable]?.value) <= value);
          }
          break;
        case "is empty":
          return__ = isEmpty(roiActionArr_global.current[variable].value);
          break;
        case "is not empty":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = !isEmpty(roiActionArr_global.current[variable]?.value);
          }
          break;
        case "is":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(roiActionArr_global.current[variable]?.value === value);
          }
          break;
        case "is not":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = eval(roiActionArr_global.current[variable]?.value !== value);
          }
          break;
        case "contains":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = roiActionArr_global.current[variable]?.value.includes(value);
          }
          break;
        case "does not contain":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = !roiActionArr_global.current[variable]?.value.includes(value);
          }
          break;
        case "starts with":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = roiActionArr_global.current[variable]?.value.startsWith(value);
          }
          break;
        case "does not start with":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = !roiActionArr_global.current[variable]?.value.startsWith(value);
          }
          break;
        case "ends with":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = roiActionArr_global.current[variable]?.value.endsWith(value);
          }
          break;
        case "does not end with":
          if (roiActionArr_global.current[variable]?.value != undefined &&
            roiActionArr_global.current[variable]?.value != null &&
            roiActionArr_global.current[variable]?.value != ""
          ) {
            return__ = !roiActionArr_global.current[variable]?.value.endsWith(value);
          }
          break;
        default:
          return__ = false;
      }
    }
    return return__;
  };

  const evaluateCondition = (condition, rule, state = roiActionArr_global.current) => {
    // Validate input condition
    if (!condition || typeof condition !== 'object') {
      console.warn('evaluateCondition: Invalid condition object:', condition);
      return false;
    }

    let value = condition["value"] ?? "";
    const operator = condition["operator"] ?? "";
    const value_type = condition["value_type"] ?? "";
    const variable_data_type = condition["variable_data_type"] ?? "text";

    if (value_type == "dynamic") {
      value = state[value]?.value;
    }
    const variable = condition["variable"] ?? "";

    let return__ = false;
    if (state[variable]?.value != undefined) {
      // Get the variable value and convert based on data type
      let variableValue = state[variable]?.value;
      let compareValue = value;

      // Convert values based on variable_data_type
      if (variable_data_type === "number") {
        variableValue = parseFloat(variableValue) || 0;
        compareValue = parseFloat(compareValue) || 0;
      }

      // console.log(`Evaluating condition: ${variable}(${variableValue}) ${operator} ${compareValue} [${variable_data_type}]`);

      switch (operator) {
        case "==":
          if (variable_data_type === "number") {
            return__ = variableValue === compareValue;
          } else {
            return__ = variableValue == compareValue;
          }
          break;
        case "!=":
          if (variable_data_type === "number") {
            return__ = variableValue !== compareValue;
          } else {
            return__ = variableValue != compareValue;
          }
          break;
        case ">":
          if (variable_data_type === "number") {
            return__ = variableValue > compareValue;
          } else {
            return__ = variableValue > compareValue;
          }
          break;
        case "<":
          if (variable_data_type === "number") {
            return__ = variableValue < compareValue;
          } else {
            return__ = variableValue < compareValue;
          }
          break;
        case ">=":
          if (variable_data_type === "number") {
            return__ = variableValue >= compareValue;
          } else {
            return__ = variableValue >= compareValue;
          }
          break;
        case "<=":
          if (variable_data_type === "number") {
            return__ = variableValue <= compareValue;
          } else {
            return__ = variableValue <= compareValue;
          }
          break;
        case "is empty":
          return__ = isEmpty(variableValue);
          break;
        case "is not empty":
          return__ = !isEmpty(variableValue);
          break;
        case "is":
          return__ = variableValue === compareValue;
          break;
        case "is not":
          return__ = variableValue !== compareValue;
          break;
        case "contains":
          return__ = String(variableValue).includes(String(compareValue));
          break;
        case "does not contain":
          return__ = !String(variableValue).includes(String(compareValue));
          break;
        case "starts with":
          return__ = String(variableValue).startsWith(String(compareValue));
          break;
        case "does not start with":
          return__ = !String(variableValue).startsWith(String(compareValue));
          break;
        case "ends with":
          return__ = String(variableValue).endsWith(String(compareValue));
          break;
        case "does not end with":
          return__ = !String(variableValue).endsWith(String(compareValue));
          break;
        case "is checked":
          return__ =
            String(variableValue) === "1" ||
            variableValue === 1 ||
            variableValue === true;
          break;
        case "is not checked":
          return__ =
            String(variableValue) !== "1" &&
            variableValue !== 1 &&
            variableValue !== true;
          break;
        default:
          return__ = false;
      }

      // console.log(`Condition result: ${return__}`);
    }
    return return__;
  };

  const isEmpty = (value) => {
    return (
      value === null || // check for null
      value === undefined || // check for undefined
      value === "" || // check for empty string
      (Array.isArray(value) && value.length === 0) || // check for empty array
      (typeof value === "object" &&
        value !== null &&
        Object.keys(value).length === 0) // check for empty object
    );
  };

  //function to return error messages for conditional logics getting true for show_error action
  // This function handles both showing and clearing error messages based on conditional logic
  // 
  // EXECUTION ORDER: This function MUST be called AFTER processLogic() to ensure
  // it evaluates conditions based on the most up-to-date values from business logic.
  // 
  // IMPORTANT: Page re-rendering is considered by:
  // 1. Using for...of loops instead of async forEach to ensure proper execution order
  // 2. Preserving error states during re-renders via renderChanges function
  // 3. Synchronizing error states between global state and error_messages collection
  // 4. Only clearing errors when necessary to prevent unnecessary state updates
  const processConditionalError = async (page_elements) => {
    let error_messages = {};
    let logics = allCondtionalLogicData.current;

    // Safety check: ensure page_elements is defined and is an array
    if (!page_elements || !Array.isArray(page_elements)) {
      console.warn('processConditionalError: page_elements is undefined or not an array:', page_elements);
      return error_messages;
    }

    // Use for...of loops instead of forEach with async to ensure proper execution order
    for (const element of Object.keys(logics)) {
      for (const element1 of Object.keys(logics[element])) {
        const { when, when_and_or_operator, then } = logics[element][element1];

        let conditionResult = when_and_or_operator === "AND" ? true : false;

        for (const condition of when) {
          const result = evaluateConditionError(condition);
          if (when_and_or_operator === "AND") {
            conditionResult = conditionResult && result;
          } else {
            conditionResult = conditionResult || result;
          }
        }

        if (conditionResult) {
          for (const action of then) {
            const {
              action: type,
              value,
              variable,
              variable_data_type,
              operator: action_type,
              value_type,
              value_variable_selected_option
            } = action;
            if (page_elements.includes(variable)) {
              switch (type) {
                case "show_error":
                  let val_error = roiActionArr_global.current[value_variable_selected_option['value']]?.value;
                  let value__ = value.replace("#value#", val_error);

                  // Show error message when condition is true
                  roiActionArr_global.current[variable] = {
                    ...roiActionArr_global.current[variable],
                    errorMessage: value__,
                  };

                  error_messages[variable] = {
                    'uuid': variable,
                    'errorMessage': value__,
                  };

                  break;

                default:

              }
            }
          }
        }

        if (!conditionResult) {
          for (const action of then) {
            const {
              action: type,
              value,
              variable,
              variable_data_type,
              operator: action_type,
              value_type,
              value_variable_selected_option
            } = action;
            if (page_elements.includes(variable)) {
              switch (type) {
                case "show_error":
                  // Clear error message when condition is false
                  // Only clear if the element currently has an error message to prevent unnecessary updates
                  if (roiActionArr_global.current[variable]?.errorMessage) {
                    roiActionArr_global.current[variable] = {
                      ...roiActionArr_global.current[variable],
                      errorMessage: "",
                    };

                    error_messages[variable] = {
                      'uuid': variable,
                      'errorMessage': "",
                    };
                  }
                  break;

                default:

              }
            }
          }
        }
      }
    }

    // Ensure error states are properly synchronized between global state and error_messages
    // This prevents loss of error states during re-renders
    Object.keys(error_messages).forEach(uuid => {
      if (error_messages[uuid].errorMessage && !roiActionArr_global.current[uuid]?.errorMessage) {
        // If error_messages has an error but global state doesn't, sync it
        roiActionArr_global.current[uuid] = {
          ...roiActionArr_global.current[uuid],
          errorMessage: error_messages[uuid].errorMessage,
        };
      } else if (!error_messages[uuid].errorMessage && roiActionArr_global.current[uuid]?.errorMessage) {
        // If global state has an error but error_messages doesn't, sync it
        error_messages[uuid].errorMessage = roiActionArr_global.current[uuid].errorMessage;
      }
    });

    return error_messages;
  };

  function applyThenActions(thenArr, roiActionArr__, jumpToPage, rule) {
    let calculated_arr = {};
    let updatedMap = { ...roiActionArr__ };
    // console.log("updatedMap", rule, updatedMap);
    for (const action of Object.keys(thenArr)) {
      const {
        action: type,
        value,
        variable,
        variable_data_type,
        operator: action_type,
        value_type,
        value_variable_selected_option,
      } = thenArr[action];

      const currentVal = updatedMap[variable]?.value;
      const currency = updatedMap[variable]?.currency;
      const hidden = updatedMap[variable]?.hide;

      // Log warning if variable doesn't exist in the map
      if (!updatedMap[variable]) {
        console.warn(`Warning: Variable ${variable} not found in roiActionArr for action type ${type}`);
        continue; // Skip this action if the variable doesn't exist
      }

      // ----------------- CALCULATE ACTION -----------------
      if (type === "calculate") {
        if(value_type==='expression') {
          if(action_type!=='assign') throw Error('Expression calculations must assign');
          const resultStr=String(evaluateExpression(value,updatedMap));
          updatedMap={...updatedMap,[variable]:{...updatedMap[variable],value:resultStr}};
          calculated_arr[variable]={value:resultStr};
          continue;
        }
        // Start from the target variable type
        let isNumber =
          variable_data_type === "number" || variable_data_type === "currency";

        // Look at the raw operand value (before casting) so we can special-case
        // "assign" when the operand is a non‑numeric string.
        const operandRaw =
          value_type === "static"
            ? value
            : updatedMap?.[value]?.value;

        // If this is an ASSIGN and the operand is a plain string that cannot be parsed
        // as a number, treat this calculation as a string assignment instead of numeric.
        // This ensures things like labels / text (e.g. "Sagagr") are copied as‑is,
        // without becoming NaN or breaking other numeric calculations.
        if (
          action_type === "assign" &&
          typeof operandRaw === "string" &&
          operandRaw !== "" &&
          isNaN(parseFloat(operandRaw))
        ) {
          isNumber = false;
        }

        let base = isNumber ? parseFloat(currentVal || "0") : currentVal || "";
        let operand =
          value_type === "static"
            ? isNumber
              ? (isNaN(parseFloat(value)) ? value : parseFloat(value))
              : value
            : isNumber
              ? parseFloat(updatedMap?.[value]?.value || "0")
              : updatedMap?.[value]?.value || "";

        try {
          const sourceDesc = value_type === "static" ? `static(${value})` : `dynamic(${value} -> ${updatedMap?.[value]?.value})`;
          console.log(
            `[ROI] CALC before: var=${variable} type=${variable_data_type} op=${action_type} base=${base} operand=${operand} src=${sourceDesc}`
          );
          if (isNumber) {
            if (isNaN(base)) console.warn(`[ROI] base is NaN for var=${variable}. currentVal=`, currentVal);
            if (isNaN(operand)) console.warn(`[ROI] operand is NaN for var=${variable}. raw=${value_type === "static" ? value : updatedMap?.[value]?.value}`);
          }
        } catch (_) { }

        let result = base;

        switch (action_type) {
          case "assign":
            result = operand;
            break;
          case "add":
            result = base + operand;
            break;
          case "subtract":
            result = base - operand;
            break;
          case "multiply":
            result = base * operand;
            break;
          case "divide":
            if (operand === 0) throw new Error(`Division by zero in ${variable}`);
            result = base / operand;
            break;
          default:
            continue;
        }

        const resultStr = isNumber
          ? String(acceptDecimalsRef.current ? result : Math.round(result))
          : result;

        try {
          console.log(`[ROI] CALC after: var=${variable} result=${resultStr}`);
          if (isNumber && (result === Infinity || result === -Infinity)) {
            console.warn(`[ROI] result is Infinity for var=${variable}. Check divide by zero.`);
          }
        } catch (_) { }

        // console.log(`Calculate result: ${variable} = ${resultStr} [${variable_data_type}]`);

        const allowUpdate =
          updatedMap[variable] &&
          String(resultStr) !== String(currentVal ?? "");
        // console.log("allowUpdate", allowUpdate, rule);

        if (allowUpdate && updatedMap[variable]) {
          updatedMap = {
            ...updatedMap,
            [variable]: {
              ...updatedMap[variable],
              value: resultStr,
            },
          };
          calculated_arr[variable] = {
            ...calculated_arr[variable],
            value: resultStr
          };

          // console.log(`Updated ${variable} from ${currentVal} to ${resultStr}`);

          // Check if this is updating a span UUID
          if (variable === "fa69d63f-f107-492a-90de-f3368e3f3f36") {
            // console.log("*** SPAN UUID UPDATED! This should trigger dynamic span re-render ***");
          }
        }
      }

      // ----------------- SHOW BLOCKS -----------------
      if (type === "show_blocks") {
        if (hidden !== "false" && updatedMap[variable]) {
          updatedMap = {
            ...updatedMap,
            [variable]: {
              ...updatedMap[variable],
              hide: "false",
            },
          };
          calculated_arr[variable] = {
            ...calculated_arr[variable],
            hide: "false"
          };
        }
      }

      // ----------------- HIDE BLOCKS -----------------
      if (type === "hide_blocks") {
        if (hidden !== "true" && updatedMap[variable]) {
          updatedMap = {
            ...updatedMap,
            [variable]: {
              ...updatedMap[variable],
              hide: "true",
            },
          };
          calculated_arr[variable] = {
            ...calculated_arr[variable],
            hide: "true"
          };
        }
      }

      // ----------------- JUMP TO PAGE -----------------
      if (type === "jump_to_page" && typeof jumpToPage === "function") {
        jumpToPage(value); // value = target page ID
      }

      // (Skip "show_error", "disable_item", etc. by request)
    }

    return {
      updatedRoiActionArr: updatedMap,
      calculated_arr: calculated_arr,
    };
  }


  const processLogic = async (jumpToPage) => {
    let logics = allCondtionalLogicData.current;
    // console.log("=== PROCESSING CONDITIONAL LOGIC ===");
    // console.log("Available logic rules:", Object.keys(logics));
    // console.log("Full conditional logic data:", logics);
    let roiActionArr__ = JSON.parse(JSON.stringify(roiActionArr_global.current));
    if (window.__ROI_AGENT_QA_ENABLED__ === true) window.__ROI_AGENT_QA_INPUT__ = JSON.parse(JSON.stringify(roiActionArr__));

    // Each imperative rule runs once. Re-running add/multiply corrupts results.
    const orderedRuleKeys = orderLogicRules(Object.keys(logics).filter((key) => logics[key]?.[0]).map((key) => ({ key, logic: logics[key][0] }))).map((rule) => rule.key);
    let hasChanges = true;
    let calculated_arr_global = {};
    let count = 0;
    while (hasChanges) {
      hasChanges = false;

      for (const rule of orderedRuleKeys) {
        try {
          // console.log(`\n--- Processing Rule: ${rule} ---`);

          // Validate rule structure
          if (!logics[rule] || !Array.isArray(logics[rule]) || logics[rule].length === 0) {
            console.warn(`Rule ${rule}: Invalid rule structure:`, logics[rule]);
            continue;
          }

          const { when, when_and_or_operator, then } = logics[rule][0];
          // console.log("When conditions:", when);
          // console.log("Then actions:", then);

          // Validate that conditions exist and are properly structured
          if (!when || typeof when !== 'object') {
            console.warn(`Rule ${rule}: Invalid 'when' conditions structure:`, when);
            continue;
          }

          let conditionResult = when_and_or_operator === "AND" ? true : false;

          for (const condition of Object.keys(when)) {
            // console.log(`\nEvaluating condition ${condition}:`, when[condition]);
            const result = evaluateCondition(when[condition], rule, roiActionArr__);
            // console.log(`Condition ${condition} result: ${result}`);

            if (when_and_or_operator === "AND") {
              conditionResult = conditionResult && result;
            } else {
              conditionResult = conditionResult || result;
            }
          }

          // console.log(`Final condition result for rule ${rule}: ${conditionResult}`);

          if (conditionResult) {
            // console.log(`Rule ${rule} conditions met - executing actions`);
            try {
              // Validate that 'then' actions exist and are properly structured
              if (!then || typeof then !== 'object') {
                console.warn(`Rule ${rule}: Invalid 'then' actions structure:`, then);
                continue;
              }

              const { updatedRoiActionArr, calculated_arr: localChanges } = applyThenActions(then, roiActionArr__, jumpToPage, rule);
              // console.log("Local changes from actions:", localChanges);

              for (const key of Object.keys(localChanges)) {
                // Safety check: ensure both objects exist and have the expected structure
                if (roiActionArr__[key] && localChanges[key] &&
                  localChanges[key].value !== undefined &&
                  roiActionArr__[key].value !== undefined &&
                  localChanges[key].value == roiActionArr__[key].value) {
                  delete localChanges[key];
                }
              }

              if (Object.keys(localChanges).length > 0) {
                // console.log(`Applying changes for rule ${rule}:`, localChanges);
                roiActionArr__ = updatedRoiActionArr;
                calculated_arr_global = { ...calculated_arr_global, ...localChanges };
              } else {
                // console.log(`No changes to apply for rule ${rule}`);
              }
            } catch (error) {
              console.error(`Error processing actions for rule ${rule}:`, error);
              // Continue processing other rules instead of crashing
            }
          } else {
            // console.log(`Rule ${rule} conditions not met - skipping actions`);
          }
        } catch (error) {
          console.error(`Error processing rule ${rule}:`, error);
          // Continue processing other rules instead of crashing
        }
      }
      count++;
      // console.log(`\n--- Logic iteration ${count} complete ---`);
      if (count > 80) {
        hasChanges = false;
      }
    }

    // console.log("=== CONDITIONAL LOGIC PROCESSING COMPLETE ===");
    // console.log("Final calculated changes:", calculated_arr_global);
    // console.log("Total rules processed:", count);

    // Update the global array with calculated values
    roiActionArr_global.current = roiActionArr__;
    if (window.__ROI_AGENT_QA_ENABLED__ === true) window.__ROI_AGENT_QA_STATE__ = JSON.parse(JSON.stringify(roiActionArr__));

    // Check if any span values were updated
    if (Object.keys(calculated_arr_global).length > 0) {
      // console.log("Conditional logic updated values - re-render will be triggered by renderChanges");
    }

    return calculated_arr_global;
  };


  function debounce(func, delay) {
    let timer;
    return function (...args) {
      const context = this; // Capture context if needed (useful for non-arrow functions)
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }


  //need to change
  const updateValueByUuid =
    async (pageUuid, elementUuid, newValue) => {
      // Function to traverse and update the page data
      let level = 0;
      const traverseAndUpdate = async (data) => {
        if (Array.isArray(data)) {
          const results = await Promise.all(
            data.map((item) => traverseAndUpdate(item))
          );
          return results;
        } else if (data !== null && typeof data === "object") {
          const newObj = {};
          for (const key of Object.keys(data)) {
            if (data.hasOwnProperty("Cell1Data")) {
              // Check if the object has the key 'Cell1Data' for table data
              const value = data[key];
              let check_digit = 0;
              if (value == elementUuid) {
                const regex = /(\d+)/;
                const digit = key.match(regex);
                newObj["Cell" + digit[0] + "Data"] = newValue;
                newObj["Cell" + digit[0] + "uuid"] = value;
                check_digit = digit[0];
              } else if (value != elementUuid) {
                if (check_digit != 0 && key == "Cell" + check_digit + "Data") {
                } else {
                  newObj[key] = value;
                }
              }
            } else {

              const value = data[key];
              if (key === "uuid" && value === elementUuid) {
                newObj[key] = value;
                newObj["value"] = newValue;
                newObj["errorMessage"] = "";
                if (data.hasOwnProperty("errorMessage")) {
                  roiActionArr_global.current[elementUuid]["errorMessage"] = "";
                }
              } else if ((key !== "errorMessage" && key !== "value" && data["uuid"] == elementUuid) || data["uuid"] != elementUuid) {
                level++;
                if (typeof value === "object") {
                  newObj[key] = await traverseAndUpdate(value);
                } else {
                  newObj[key] = value;
                }
              } else if (key === "value" && newObj["value"] === undefined) {
                newObj["value"] = data[key];
              }
            }
          }
          return newObj;
        } else {
          return data;
        }
      };

      // Only update the specific page
      if (roipages.current.hasOwnProperty(pageUuid)) {
        let pagedata = JSON.parse(JSON.stringify(roipages.current));
        const updatedPage = await traverseAndUpdate(
          JSON.parse(pagedata[pageUuid])
        );
        roipages.current = {
          ...roipages.current,
          [pageUuid]: JSON.stringify(updatedPage), // Update only the specific page
        }
        renderChanges(1);
      }
    };

  //need to change
  const updateValueForRenderAllPages =

    async (calculated_arr_global) => {

      if (calculated_arr_global.length > 0) {
        // Function to traverse and update the page data
        let level = 0;
        const traverseAndUpdate = async (
          data,
          calculated_arr_global,
          pageUuid
        ) => {
          if (Array.isArray(data)) {
            const results = await Promise.all(
              data.map((item) =>
                traverseAndUpdate(item, calculated_arr_global, pageUuid)
              )
            );
            return results;
          } else if (data !== null && typeof data === "object") {

            const newObj = {};
            for (const key of Object.keys(data)) {

              if (data.hasOwnProperty("Cell1Data")) {
                // Check if the object has the key 'Cell1Data' for table data
                const value = data[key];
                let check__ = false;
                let check_digit = 0;
                // await Object.keys(calculated_arr_global).forEach(
                //   async (element) => {
                //     if (value == calculated_arr_global[element].variable) {
                //       const regex = /(\d+)/;
                //       const digit = key.match(regex);
                //       newObj["Cell" + digit[0] + "Data"] =
                //         calculated_arr_global[element].value;
                //       newObj["Cell" + digit[0] + "uuid"] = value;
                //       check_digit = digit[0];
                //       check__ = true;
                //     }
                //   }
                // );

                for (const element of Object.keys(calculated_arr_global)) {
                  if (value == calculated_arr_global[element].variable) {
                    const regex = /(\d+)/;
                    const digit = key.match(regex);
                    newObj["Cell" + digit[0] + "Data"] =
                      calculated_arr_global[element].value;
                    newObj["Cell" + digit[0] + "uuid"] = value;
                    check_digit = digit[0];
                    check__ = true;
                  }
                }

                if (check__ == false) {
                  // if (value != element.variable) {
                  if (check_digit != 0 && key == "Cell" + check_digit + "Data") {
                  } else {
                    newObj[key] = value;
                  }
                  // }
                }
              } else if (data.hasOwnProperty("Value1")) {
                // Check if the object has the key 'Cell1Data' for table data
                const value = data[key];
                let check__ = false;
                let check_digit = 0;
                // await Object.keys(calculated_arr_global).forEach(
                //   async (element) => {
                //     if (value == calculated_arr_global[element].variable) {
                //       const regex = /(\d+)/;
                //       const digit = key.match(regex);
                //       newObj["Value" + digit[0]] =
                //         calculated_arr_global[element].value;
                //       newObj["Value" + digit[0] + "uuid"] = value;
                //       check_digit = digit[0];
                //       check__ = true;
                //     }
                //   }
                // );

                for (const element of Object.keys(calculated_arr_global)) {
                  if (value == calculated_arr_global[element].variable) {
                    const regex = /(\d+)/;
                    const digit = key.match(regex);
                    newObj["Value" + digit[0]] =
                      calculated_arr_global[element].value;
                    newObj["Value" + digit[0] + "uuid"] = value;
                    check_digit = digit[0];
                    check__ = true;
                  }
                }

                if (check__ == false) {
                  // if (value != element.variable) {
                  if (check_digit != 0 && key == "Value" + check_digit) {
                  } else {
                    newObj[key] = value;
                  }
                  // }
                }
              } else {

                const value = data[key];
                let check__ = false;
                // await Object.keys(calculated_arr_global).forEach(
                //   async (element) => {
                //     if (
                //       key === "uuid" &&
                //       value === calculated_arr_global[element].variable &&
                //       data.hasOwnProperty("value")
                //     ) {
                //       newObj[key] = value; // keep uuid the same
                //       newObj["value"] = calculated_arr_global[element].value; // update the value
                //       check__ = true;
                //     }
                //   }
                // );

                for (const element of Object.keys(calculated_arr_global)) {
                  if (
                    key === "uuid" &&
                    value === calculated_arr_global[element].variable
                  ) {

                    if (data.hasOwnProperty("value")) {
                      newObj[key] = value; // keep uuid the same
                      newObj["value"] = calculated_arr_global[element].value; // update the value
                    }

                    // Fix: Check if hide property exists in calculated_arr_global, regardless of its value
                    if (data.hasOwnProperty('hide') && calculated_arr_global[element].hasOwnProperty('hide')) {
                      newObj[key] = value; // keep uuid the same
                      newObj["hide"] = calculated_arr_global[element]["hide"];
                    }
                    if (data.hasOwnProperty('errorMessage') && calculated_arr_global[element].hasOwnProperty('errorMessage')) {
                      newObj[key] = value; // keep uuid the same
                      newObj["errorMessage"] = calculated_arr_global[element]["errorMessage"];
                    }
                    check__ = true;
                  }
                }
                if (check__ == false) {
                  if (key !== "value" && key !== "hide" && key !== "errorMessage") { // Prevent overwriting hide property
                    if (typeof value === "object") {
                      newObj[key] = await traverseAndUpdate(
                        value,
                        calculated_arr_global,
                        pageUuid
                      );
                    } else {
                      newObj[key] = value;
                    }
                  } else if (key === "value" && newObj["value"] === undefined) {

                    newObj["value"] = data[key];

                  } else if (key === "hide" && !newObj.hasOwnProperty("hide")) {
                    // Only set hide from original data if it wasn't already set from calculated_arr_global
                    newObj["hide"] = data[key];
                  } else if (key === "errorMessage" && !newObj.hasOwnProperty("errorMessage")) {
                    // Only set errorMessage from original data if it wasn't already set from calculated_arr_global
                    newObj["errorMessage"] = data[key];
                  }
                }


              }
            }


            return newObj;
          } else {
            return data;
          }
        };

        // Only update the specific page
        let roipages__ = JSON.parse(JSON.stringify(roipages.current));
        // Object.keys(roipages__).forEach(async (pageUuid, index) => {
        //   let pagedata = JSON.parse(JSON.stringify(roipages__));

        //   let updatedPage = await traverseAndUpdate(
        //     JSON.parse(pagedata[pageUuid]),
        //     calculated_arr_global,
        //     pageUuid
        //   );

        //   roipages__[pageUuid] = JSON.stringify(updatedPage);
        //   if (index == Object.keys(roipages__).length - 1) {
        //     setRoipages(roipages__);

        //   }
        // });

        const pageUuids = Object.keys(roipages__);
        for (const pageUuid of pageUuids) {
          let pagedata = JSON.parse(JSON.stringify(roipages__));
          let updatedPage = await traverseAndUpdate(
            JSON.parse(pagedata[pageUuid]),
            calculated_arr_global,
            pageUuid
          );
          roipages__[pageUuid] = JSON.stringify(updatedPage);
        }
        roipages.current = roipages__;
        renderChanges(1);
      }

    };

  // Helper function to check if a field is likely numeric
  const isFieldNumeric = (uuid) => {
    const field = roiActionArr_global.current[uuid];
    if (!field) return false;

    // Check if the field has a numeric type indicator
    if (field.type === "number" || field.variable_data_type === "number") {
      return true;
    }

    // Check if current value is numeric
    if (field.value && !isNaN(parseFloat(field.value)) && isFinite(field.value)) {
      return true;
    }

    return false;
  };

  // Helper function to prevent negative values in numeric fields
  const preventNegativeInput = (uuid, key) => {
    if (key === '-' && isFieldNumeric(uuid)) {
      return false; // Prevent minus key
    }
    return true; // Allow other keys
  };

  // Helper function to prevent scroll and arrow key changes in numeric fields
  const preventScrollAndArrowKeys = (e) => {
    // Prevent arrow keys from changing the value
    if (e.type === 'keydown') {
      if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
        e.preventDefault();
        return false;
      }
    }

    return true;
  };

  // Helper function specifically for preventing mouse wheel scroll
  const preventWheelScroll = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    return false;
  };

  // Enhanced wheel event handler with passive: false
  const handleWheelEvent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  // More aggressive wheel prevention
  const handleWheelPrevention = (e) => {
    e.preventDefault();
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    return false;
  };

  //for inputs type text
  const handleChange =
    async (uuid, e, required = false) => {
      console.log('handleChange called with uuid:', uuid, 'value:', e.target.value);
      console.log('Current roiActionArr_global.current:', roiActionArr_global.current);

      const maxDigitsErrorMessage = "Value cannot exceed 10 digits";

      // Check for negative values in numeric inputs
      // Only apply this validation if the field appears to be numeric
      // Use the helper function for consistency
      const isLikelyNumeric = () => {
        // First check using the helper function
        if (isFieldNumeric(uuid)) {
          return true;
        }

        // Additional check: if the new value without minus would be numeric
        const newValueWithoutMinus = e.target.value.replace('-', '');
        if (newValueWithoutMinus && !isNaN(parseFloat(newValueWithoutMinus)) && isFinite(newValueWithoutMinus)) {
          return true;
        }

        return false;
      };

      if (e.target.value.startsWith('-') && isLikelyNumeric()) {
        // Prevent negative values for numeric fields - set error message and return early
        let errorMessage = "Negative values are not allowed for this field";
        let error_messages = {};
        error_messages[uuid] = {
          'uuid': uuid,
          'errorMessage': errorMessage
        };

        // Update global state with error
        const updatedRoiActionArr = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            value: e.target.value, // Keep the negative value for display but show error
            errorMessage: errorMessage
          },
        };
        roiActionArr_global.current = updatedRoiActionArr;

        // Debug: Print current state
        console.log('roiActionArr_global.current:', roiActionArr_global.current);
        console.log('Current input value:', e.target.value);
        console.log('Is negative value?', e.target.value.startsWith('-'));

        let assign_arr = {}
        assign_arr[uuid] = {
          'uuid': uuid,
          'value': e.target.value
        };

        // Render changes with error message
        renderChanges(assign_arr, error_messages, {});
        return; // Exit early to prevent further processing
      }

      // Enforce maximum of 10 digits for numeric fields
      if (isLikelyNumeric()) {
        const digitsOnly = e.target.value.replace(/\D/g, "");
        if (digitsOnly.length > 10) {
          const previousValue = roiActionArr_global.current[uuid]?.value ?? "";
          const updatedRoiActionArr = {
            ...roiActionArr_global.current,
            [uuid]: {
              ...roiActionArr_global.current[uuid],
              errorMessage: maxDigitsErrorMessage,
              value: previousValue,
            },
          };
          roiActionArr_global.current = updatedRoiActionArr;

          let assign_arr = {};
          assign_arr[uuid] = {
            uuid: uuid,
            value: previousValue,
          };

          let error_messages = {};
          error_messages[uuid] = {
            uuid: uuid,
            errorMessage: maxDigitsErrorMessage,
          };

          renderChanges(assign_arr, error_messages, {});
          return;
        } else if (roiActionArr_global.current[uuid]?.errorMessage === maxDigitsErrorMessage) {
          const updatedRoiActionArr = {
            ...roiActionArr_global.current,
            [uuid]: {
              ...roiActionArr_global.current[uuid],
              errorMessage: "",
            },
          };
          roiActionArr_global.current = updatedRoiActionArr;
        }
      }

      // Clear negative value error if it was previously set and user has removed the minus sign
      if (roiActionArr_global.current[uuid]?.errorMessage === "Negative values are not allowed for this field" &&
        !e.target.value.startsWith('-')) {
        // Clear the error message since user has removed the negative sign
        const updatedRoiActionArr = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            errorMessage: ""
          },
        };
        roiActionArr_global.current = updatedRoiActionArr;
      }

      if (e.target.value == "" && required == true) {
        // toast.error('Please enter a valid value');
        let errorMessage = "Please enter a valid value";
        let error_messages = {};
        error_messages[uuid] = {
          // pageId: currentPageId.current,
          'uuid': uuid,
          'errorMessage': errorMessage
        };


        const updatedRoiActionArr = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            value: "",
          },
        };
        // setRoiActionArr(updatedRoiActionArr);
        roiActionArr_global.current = updatedRoiActionArr;

        let assign_arr = {}
        assign_arr[uuid] = {
          'uuid': uuid,
          'value': ""
        };

        let process_arr = await processLogic();


        renderChanges(assign_arr, error_messages, process_arr);
      } else {
        if (
          uuid !== "" &&
          uuid !== undefined &&
          uuid !== null &&
          e !== "" &&
          e !== undefined &&
          e !== null
        ) {

          if (roiActionArr_global.current[uuid].value == e.target.value) {
            return;
          }

          const updatedRoiActionArr = {
            ...roiActionArr_global.current,
            [uuid]: {
              ...roiActionArr_global.current[uuid],
              value: e.target.value,
              errorMessage: "", // Clear any existing error message
            },
          };

          // setRoiActionArr(updatedRoiActionArr);
          roiActionArr_global.current = updatedRoiActionArr;

          let assign_arr = {};
          assign_arr[uuid] = {
            'uuid': uuid,
            'value': e.target.value
          };

          // console.log("=== TRIGGERING CONDITIONAL LOGIC AFTER INPUT CHANGE ===");
          // console.log("Input UUID:", uuid);
          // console.log("New value:", e.target.value);

          // IMPORTANT: Process business logic first to get updated values
          // Then process conditional errors based on the updated values
          let process_arr = await processLogic();

          const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
          let error_messages = {};

          error_messages[uuid] = {
            'uuid': uuid,
            'errorMessage': ""
          };

          let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
          if (Object.keys(error_messages_conditional).length > 0) {
            error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
          }

          if (popupStatus == false) {
            renderChanges(assign_arr, error_messages, process_arr);
          }
          if (popupStatus == true) {
            renderChanges(assign_arr, error_messages, process_arr);
          }
        }
      }
    }

  //for checkbox
  const onCheckBoxClick =
    async (uuid) => {
      let value = roiActionArr_global.current[uuid].value;
      if (value == "1") {
        const updatedRoiActionArr = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            value: "0",
          },
        };
        value = "0";
        // setRoiActionArr(updatedRoiActionArr);
        roiActionArr_global.current = updatedRoiActionArr;
        await updateValueByUuid(currentPageId.current, uuid, value);
      } else {
        const updatedRoiActionArr = {
          ...roiActionArr_global.current,
          [uuid]: {
            ...roiActionArr_global.current[uuid],
            value: "1",
          },
        };
        value = "1";
        // setRoiActionArr(updatedRoiActionArr);
        roiActionArr_global.current = updatedRoiActionArr;
        await updateValueByUuid(currentPageId.current, uuid, value);
      }

      const checkboxFieldId = roiActionArr_global.current[uuid]?.fieldId;
      if (checkboxFieldId) {
        const aliasKey = `${checkboxFieldId}-0`;
        roiActionArr_global.current = {
          ...roiActionArr_global.current,
          [aliasKey]: {
            ...(roiActionArr_global.current[aliasKey] || {}),
            value,
            type: "Checkbox Option",
            fieldId: checkboxFieldId,
            logicOptionUuid: uuid,
          },
        };
      }

      // Clear error for the parent checkbox group if it exists
      let error_messages = {};
      error_messages[uuid] = {
        'uuid': uuid,
        'errorMessage': ""
      };

      // Find the parent checkbox group by looking for elements with checkbox_id matching current uuid
      const elements = Object.keys(roiActionArr_global.current);
      for (let index = 0; index < elements.length; index++) {
        const element = elements[index];
        if (roiActionArr_global.current[element].checkbox_id === uuid &&
          roiActionArr_global.current[element].roi_page_id === currentPageId.current) {
          error_messages[roiActionArr_global.current[element].checkbox_id] = {
            'uuid': roiActionArr_global.current[element].checkbox_id,
            'errorMessage': ""
          };
          break;
        }
      }

      // IMPORTANT: Process business logic first to get updated values
      // Then process conditional errors based on the updated values
      let process_arr = await processLogic();

      const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
      let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
      if (Object.keys(error_messages_conditional).length > 0) {
        error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
      }

      // Render changes with cleared error messages
      let assign_arr = {};
      assign_arr[uuid] = {
        'uuid': uuid,
        'value': value
      };

      renderChanges(assign_arr, error_messages, process_arr);
    };


  //for radio
  const onRadioClick =
    async (uuid, value) => {
      // Always update the selected value for this radio group
      const updatedRoiActionArr = {
        ...roiActionArr_global.current,
        [uuid]: {
          ...roiActionArr_global.current[uuid],
          value: value,
        },
      };

      let assign_arr = {};
      assign_arr[uuid] = {
        'uuid': uuid,
        'value': value
      };

      let error_messages = {};
      error_messages[uuid] = {
        'uuid': uuid,
        'errorMessage': ""
      };

      // Also clear error for the parent radio group if it exists
      // Find the parent radio group by looking for elements with type "Radio" and same roi_page_id
      const elements = Object.keys(roiActionArr_global.current);
      for (let index = 0; index < elements.length; index++) {
        const element = elements[index];
        if (roiActionArr_global.current[element].type === "Radio" &&
          roiActionArr_global.current[element].roi_page_id === currentPageId.current) {
          error_messages[element] = {
            'uuid': element,
            'errorMessage': ""
          };
          break; // Only one radio group per page
        }
      }

      roiActionArr_global.current = updatedRoiActionArr;

      // IMPORTANT: Process business logic first to get updated values
      // Then process conditional errors based on the updated values
      let process_arr = await processLogic();

      const elements_by_page_id_current = elements_by_page_id.current[currentPageId.current] || [];
      let error_messages_conditional = await processConditionalError(elements_by_page_id_current);
      if (Object.keys(error_messages_conditional).length > 0) {
        error_messages = mergeUpdatesByUUID(error_messages, error_messages_conditional);
      }

      renderChanges(assign_arr, error_messages, process_arr);
    };

  // Handle input focus to clear default '0' values and store focus for tab index
  const handleInputFocus = (e) => {
    const input = e.target;
    // Only clear if the value is exactly '0' (default value)
    if (input.value === '0') {
      input.value = '';
    }
    // Store the focused input ID for tab index management
    setFocusedInputId(input.id);
  };

  // Handle input blur and restore focus after rerender
  const handleInputBlur = async (uuid, e, required = false) => {
    // Defer state update to next tick so browser can move focus naturally
    const event = { target: { value: e.target.value } };
    setTimeout(() => {
      handleChange(uuid, event, required);
    }, 0);
  };

  const handleDropdownChange =
    async (uuid, e) => {
      const changedArr = {
        ...changedDropdown,
        [uuid]: e.target.value,
      };
      setChangedDropdown(changedArr);

      const updatedRoiActionArr = {
        ...roiActionArr_global.current,
        [uuid]: {
          ...roiActionArr_global.current[uuid],
          value: e.target.value,
        },
      };
      // setRoiActionArr(updatedRoiActionArr);
      roiActionArr_global.current = updatedRoiActionArr;
      await updateValueByUuid(currentPageId.current, uuid, e.target.value);
    };

  const updateByUuidSmart = (data, uuid, updates) => {
    // console.log("data", data, "uuid", uuid, "updates", updates);
    if (Array.isArray(data)) {
      return data.map((item) => updateByUuidSmart(item, uuid, updates));
    } else if (data && typeof data === "object") {
      if (data?.props?.uuid === uuid) {
        return {
          ...data,
          props: {
            ...data.props,
            ...updates,
          },
        };
      } else if (data.uuid === uuid) {
        return {
          ...data,
          ...updates,
        };
      }

      const newObj = {};
      for (const key in data) {
        newObj[key] = updateByUuidSmart(data[key], uuid, updates);
      }
      return newObj;
    }
    return data;
  }

  function applyUpdatesToAllPages(pages, updateArray) {
    const updatedPages = { ...pages };
    // console.log("pages", pages, "updateArray", updateArray);
    for (const uuid of Object.keys(updateArray)) {
      const updates = updateArray[uuid];
      // console.log("updates", updates);
      for (const pageId in updatedPages) {
        // console.log("pageId", pageId);
        const pageDataString = updatedPages[pageId];
        if (!pageDataString || pageDataString === "undefined" || typeof pageDataString !== 'string') {
          console.warn('Invalid page data in applyUpdatesToAllPages:', pageId, 'Data:', pageDataString);
          continue;
        }

        let pageData;
        try {
          pageData = JSON.parse(pageDataString);
        } catch (error) {
          console.error('Error parsing page data in applyUpdatesToAllPages:', error, 'PageId:', pageId, 'Data:', pageDataString);
          continue;
        }

        const updatedPage = updateByUuidSmart(pageData, uuid, updates);

        if (updatedPage !== pageData) {
          updatedPages[pageId] = JSON.stringify(updatedPage);
        }
      }
    }

    return updatedPages;
  }

  const initialRender = () => {
    if (currentPageId.current !== '' && currentPageId.current !== undefined && currentPageId.current !== null) {
      const pageDataString = roipages.current[currentPageId.current];
      if (pageDataString && pageDataString !== "undefined" && typeof pageDataString === 'string') {
        try {
          setRenderData(normalizePuckStructure(JSON.parse(pageDataString)));
        } catch (error) {
          console.error('Error parsing page data in initialRender:', error, 'Data:', pageDataString);
          // Keep renderData as null instead of setting to empty object
          console.warn('Keeping renderData as null due to parsing error');
        }
      } else {
        console.warn('Invalid page data in initialRender:', currentPageId.current, 'Data:', pageDataString);
        // Keep renderData as null instead of setting to empty object
        console.warn('Keeping renderData as null due to invalid page data');
      }
    }
  }

  // Function to render changes and trigger page updates
  // IMPORTANT: This function handles page re-rendering by preserving error states
  // to prevent loss of conditional error messages during React re-renders
  // 
  // Enhanced Features:
  // 1. Error message syncing from roiActionArr_global for consistency
  // 2. Bidirectional synchronization between global and local error states
  // 3. Priority-based error message resolution to prevent conflicts
  // 4. Preservation of existing error states during re-renders
  const renderChanges = (updates = {}, error_messages = {}, process_arr = {}) => {
    // console.log("updates", updates, "logicUpdates", error_messages, "process_arr", process_arr);

    // Enhanced error message syncing from roiActionArr_global
    // This ensures all error states are properly synchronized before rendering
    const enhancedErrorMessages = { ...error_messages };

    // Sync error messages from roiActionArr_global to ensure consistency
    Object.keys(roiActionArr_global.current).forEach(uuid => {
      const globalError = roiActionArr_global.current[uuid]?.errorMessage;
      const localError = enhancedErrorMessages[uuid]?.errorMessage;

      // If global state has an error message but local doesn't, sync it
      if (globalError && !localError) {
        enhancedErrorMessages[uuid] = {
          ...enhancedErrorMessages[uuid],
          uuid: uuid,
          errorMessage: globalError
        };
      }
      // If local has an error message but global doesn't, sync global state
      else if (localError && !globalError) {
        roiActionArr_global.current[uuid] = {
          ...roiActionArr_global.current[uuid],
          errorMessage: localError
        };
      }
      // If both have different error messages, prioritize the most recent one
      else if (globalError && localError && globalError !== localError) {
        // Keep the non-empty error message, or the one that's not "Please enter a valid value"
        const priorityError = globalError !== "Please enter a valid value" ? globalError : localError;
        enhancedErrorMessages[uuid] = {
          ...enhancedErrorMessages[uuid],
          uuid: uuid,
          errorMessage: priorityError
        };
        roiActionArr_global.current[uuid] = {
          ...roiActionArr_global.current[uuid],
          errorMessage: priorityError
        };
      }
    });

    // Preserve existing error states from global state before merging updates
    // This prevents loss of error states during re-renders
    const preservedErrorStates = {};
    Object.keys(roiActionArr_global.current).forEach(uuid => {
      if (roiActionArr_global.current[uuid]?.errorMessage) {
        preservedErrorStates[uuid] = {
          errorMessage: roiActionArr_global.current[uuid].errorMessage
        };
      }
    });

    // Merge updates with enhanced error messages and preserved error states
    const mergedUpdates = mergeUpdatesByUUID(updates, process_arr, enhancedErrorMessages, preservedErrorStates);
    // console.log("mergedUpdates", mergedUpdates);
    const updatedPages = applyUpdatesToAllPages(roipages.current, mergedUpdates);
    roipages.current = updatedPages;
    // console.log("updatedPages", currentPageId.current);
    const currentPageData = updatedPages[currentPageId.current];
    const prevScroll = (typeof window !== 'undefined')
      ? { x: window.scrollX, y: window.scrollY }
      : { x: 0, y: 0 };
    if (currentPageData && currentPageData !== "undefined" && typeof currentPageData === 'string') {
      try {
        setRenderData(normalizePuckStructure(JSON.parse(currentPageData)));
      } catch (error) {
        console.error('Error parsing page data:', error, 'Data:', currentPageData);
        // Keep current renderData instead of setting to empty object
        console.warn('Keeping current renderData due to parsing error');
      }
    } else {
      console.warn('Invalid page data for current page:', currentPageId.current, 'Data:', currentPageData);
      // Keep current renderData instead of setting to empty object
      console.warn('Keeping current renderData due to invalid page data');
    }

    if (typeof window !== 'undefined') {
      window.requestAnimationFrame(() => {
        window.scrollTo(prevScroll.x, prevScroll.y);
      });
    }
  };

  function mergeUpdatesByUUID(...updateObjects) {
    const merged = {};

    for (const updateObj of updateObjects) {
      for (const uuid in updateObj) {
        if (!merged[uuid]) merged[uuid] = {};
        merged[uuid] = {
          ...merged[uuid],
          ...updateObj[uuid], // merge inner keys like value, errorMessage, etc.
        };
      }
    }

    return merged;
  }

  useEffect(() => {

    if (
      currentPopupPageId !== "" &&
      roipages.current[currentPopupPageId] !== undefined &&
      popupStatus == true
    ) {
      setRenderModalData(JSON.parse(roipages.current[currentPopupPageId]));
    }

  }, [roipages.current, currentPageId, currentPopupPageId]);

  // Restore focus after rerendering to maintain tab index functionality
  useEffect(() => {
    if (focusedInputId && renderData) {
      // Small delay to ensure DOM is fully rendered
      setTimeout(() => {
        const element = document.getElementById(focusedInputId);
        if (element) {
          element.focus();
        }
      }, 50);
    }
  }, [renderData, focusedInputId]);

  useEffect(() => {
    if (!renderData) {
      return;
    }

    const currentRenderedPage = currentPageId.current;
    if (lastRenderedPageRef.current === currentRenderedPage) {
      return;
    }

    lastRenderedPageRef.current = currentRenderedPage;

    // Close any open modals when page changes
    setHandleModalOpen(false);
    setHandleModal(true);

    if (typeof window !== 'undefined') {
      window.requestAnimationFrame(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
      });
    }
  }, [renderData, currentPageId]);

  // Prevent wheel scroll on number inputs
  useEffect(() => {
    const handleWheelOnNumberInputs = (e) => {
      if (e.target.type === 'number') {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        return false;
      }
    };

    // Add multiple event listeners to catch all wheel events
    document.addEventListener('wheel', handleWheelOnNumberInputs, { passive: false, capture: true });
    document.addEventListener('mousewheel', handleWheelOnNumberInputs, { passive: false, capture: true });
    document.addEventListener('DOMMouseScroll', handleWheelOnNumberInputs, { passive: false, capture: true });

    return () => {
      document.removeEventListener('wheel', handleWheelOnNumberInputs, { capture: true });
      document.removeEventListener('mousewheel', handleWheelOnNumberInputs, { capture: true });
      document.removeEventListener('DOMMouseScroll', handleWheelOnNumberInputs, { capture: true });
    };
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/roi/getRoiDetail/${roiId}`);
        const data = await response.json();
        const res = data?.data;
        if (!res) {
          throw new Error(data?.msg || data?.responseText || "ROI not found");
        }

        acceptDecimalsRef.current = res.accept_decimals === true || res.accept_decimals === 1 || res.accept_decimals === "1";
        setAcceptDecimals(acceptDecimalsRef.current);
        setIsIdPresent(res.is_active);
        setLanguage(res.default_language);
        setDefaultCurrency(JSON.parse(res.primary_currency)[0]);

        // setChangedCurrency(JSON.parse(res.primary_currency)[0])
        setCurrency(JSON.parse(res.additional_currency));
        // getting first strucuture api call

        const response1 = await fetch(`${apiUrl}/roi-currency/list`);
        const result1 = await response1.json();
        const res1 = result1?.data;
        if (!res1 || typeof res1 !== "object") {
          throw new Error(
            result1?.responseText || "Failed to load currency list"
          );
        }

        Object.keys(res1).map((key) => {
          if (res1[key].currency_name == JSON.parse(res.primary_currency)[0]) {
            setCurrencySymbol(res1[key].symbol);
            setLocale("en-US");
            setExchangeRate(res1[key].exchange_rate);
          }
        });

        try {
          const responseStructure = await fetch(
            `${apiUrl}/roi-pages/detail/${roiId}`
          );
          const dataStructure = await responseStructure.json();
          // setCurrentPageId(dataStructure.result?.[0]?.roi_page_id);
          currentPageId.current = dataStructure.result?.[0]?.roi_page_id;

          const parsedRenderData = normalizePuckStructure(
            JSON.parse(dataStructure.result?.[0]?.structure)
          );
          let roi_content = {};
          let roi_global_arr = {};
          let data = dataStructure.result;
          for (let i = 0; i < data.length; i++) {
            const pageStructure = normalizePuckStructure(JSON.parse(data[i].structure));
            roi_content[data[i].roi_page_id] = JSON.stringify(pageStructure);
            const data__ = puckContentItems(pageStructure.content);
            data__.forEach((item) => {
              if (
                item?.type == "InputTextField" ||
                item?.type == "InputNumberField" ||
                item?.type == "Button" ||
                item?.type == "Range" ||
                item?.type == "Wrapper "
              ) {
                Object.keys(item?.props || {}).forEach((element2) => {
                  if (item?.props?.uuid != undefined) {
                    roi_global_arr[item?.props?.uuid] = {};
                    roi_global_arr[item?.props?.uuid]["count"] = 0;
                    roi_global_arr[item?.props?.uuid]["actions"] = item?.props?.buttonAction ?? "";
                    roi_global_arr[item?.props?.uuid]["action_id"] =
                      item?.props?.buttonValue || item?.props?.PageList || "";
                    roi_global_arr[item?.props?.uuid]["link"] = item?.props?.buttonLink ?? "";
                    roi_global_arr[item?.props?.uuid]["value"] = item?.props?.value ?? "";
                    roi_global_arr[item?.props?.uuid]["default_value"] = item?.props?.default_value ?? "";
                    roi_global_arr[item?.props?.uuid]["hide"] = item?.props?.hide ?? "false";
                    roi_global_arr[item?.props?.uuid]["errorMessage"] = item?.props?.errorMessage ?? "";
                    roi_global_arr[item?.props?.uuid]["roi_page_id"] = data[i].roi_page_id;
                  }
                });
              } else {
                Object.keys(item?.props || {}).forEach((element2) => {
                  if (item?.props[element2]?.uuid != undefined) {
                    if (
                      element2 !== "image" &&
                      element2 !== "logo" &&
                      element2 !== "items" &&
                      element2 !== "id" &&
                      element2 !== "Padding" &&
                      element2 !== "Style"
                    ) {
                      roi_global_arr[item?.props[element2].uuid] = {};
                      roi_global_arr[item?.props[element2].uuid]["count"] = 0;
                      roi_global_arr[item?.props[element2].uuid]["actions"] = item?.props[element2].buttonAction ?? "";
                      roi_global_arr[item?.props[element2].uuid]["action_id"] =
                        item?.props[element2].buttonValue || item?.props[element2].PageList || "";
                      roi_global_arr[item?.props[element2].uuid]["link"] = item?.props[element2].buttonLink ?? "";
                      roi_global_arr[item?.props[element2].uuid]["value"] = item?.props?.[element2]?.value ?? "";
                      roi_global_arr[item?.props[element2].uuid]["default_value"] = item?.props[element2].default_value ?? "";
                      roi_global_arr[item?.props[element2].uuid]["hide"] = item?.props[element2].hide ?? "false";
                      roi_global_arr[item?.props[element2].uuid]["errorMessage"] = item?.props[element2].errorMessage ?? "";
                      roi_global_arr[item?.props[element2].uuid]["roi_page_id"] = data[i].roi_page_id;
                    }
                  }
                });
              }
            });

            registerNestedPuckFields(pageStructure, roi_global_arr, data[i].roi_page_id);

            const data_zones__ = pageStructure.zones || {};
            Object.keys(data_zones__).forEach((element) => {
              const zoneVal = data_zones__[element];
              const zoneItems = Array.isArray(zoneVal)
                ? zoneVal
                : zoneVal && typeof zoneVal === "object"
                  ? Object.values(zoneVal)
                  : [];
              zoneItems.forEach((data_element__) => {
                  if (data_element__?.props.uuid != undefined) {
                    if (
                      data_element__?.type === "InputTextField" ||
                      data_element__?.type === "InputNumberField" ||
                      data_element__?.type === "Dropdown" ||
                      data_element__?.type === "Button" ||
                      data_element__?.type === "Range" ||
                      data_element__?.type === "Wrapper"
                    ) {
                      roi_global_arr[data_element__?.props.uuid] = {};
                      roi_global_arr[data_element__?.props.uuid]["currency"] = data_element__?.props.prefix == "currency" || data_element__?.props.prefix == "Currency" || data_element__?.props.Prefix == "Currency" || data_element__?.props.Prefix == "currency" ? "1" : "0";
                      roi_global_arr[data_element__?.props.uuid]["count"] = 0;
                      roi_global_arr[data_element__?.props.uuid]["required"] = data_element__?.props.required ?? false;
                      roi_global_arr[data_element__?.props.uuid]["type"] = data_element__?.type ?? "";
                      roi_global_arr[data_element__?.props.uuid]["actions"] = data_element__?.props.buttonAction ?? "";
                      roi_global_arr[data_element__?.props.uuid]["action_id"] =
                        puckButtonTargetId(data_element__?.props);
                      roi_global_arr[data_element__?.props.uuid]["link"] = data_element__?.props.buttonLink ?? "";
                      roi_global_arr[data_element__?.props.uuid]["value"] = data_element__?.props?.value ?? "";
                      roi_global_arr[data_element__?.props.uuid]["default_value"] = data_element__?.props.default_value ?? "";
                      roi_global_arr[data_element__?.props.uuid]["roi_page_id"] = data[i].roi_page_id;
                      roi_global_arr[data_element__?.props.uuid]["hide"] = data_element__?.props.hide ?? "false";
                      roi_global_arr[data_element__?.props.uuid]["errorMessage"] = data_element__?.props.errorMessage ?? "";
                    }

                    if (data_element__?.type === "Checkbox") {
                      roi_global_arr[data_element__?.props?.uuid] = {};
                      roi_global_arr[data_element__?.props?.uuid]["count"] = 0;
                      roi_global_arr[data_element__?.props?.uuid]["required"] = data_element__?.props?.required ?? false;
                      roi_global_arr[data_element__?.props?.uuid]["type"] = "Checkbox";
                      roi_global_arr[data_element__?.props?.uuid]["actions"] = data_element__?.props?.buttonAction ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["action_id"] =
                        puckButtonTargetId(data_element__?.props);
                      roi_global_arr[data_element__?.props?.uuid]["link"] = data_element__?.props?.buttonLink ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["value"] = data_element__?.props?.value ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["default_value"] = data_element__?.props?.default_value ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["hide"] = data_element__?.props?.hide ?? "false";
                      roi_global_arr[data_element__?.props?.uuid]["errorMessage"] = data_element__?.props?.errorMessage ?? "";
                      roi_global_arr[data_element__?.props?.uuid]["roi_page_id"] = data[i].roi_page_id;

                      Object.keys(data_element__?.props?.items).forEach(
                        (element, index) => {
                          if (
                            data_element__?.props?.items[element]?.uuid != undefined
                          ) {
                            roi_global_arr[data_element__?.props?.items[element]?.uuid] = {};
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["currency"] =
                              data_element__?.props?.items[element]?.prefix ==
                                "currency" ||
                                data_element__?.props?.items[element]?.prefix ==
                                "Currency" ||
                                data_element__?.props?.items[element]?.Prefix ==
                                "currency" ||
                                data_element__?.props?.items[element]?.Prefix ==
                                "Currency"
                                ? "1"
                                : "0";
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["count"] = 0;
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["required"] = data_element__?.props?.required ?? false;
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["type"] = "Checkbox Option";
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["actions"] = data_element__?.props?.items[element]?.buttonAction ?? "";
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["action_id"] =
                              puckButtonTargetId(data_element__?.props?.items[element]);
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["link"] = data_element__?.props?.items[element]?.buttonLink ?? "";
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["value"] = data_element__?.props?.items[element]?.value ?? "";
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["default_value"] = data_element__?.props?.items[element]?.default_value ?? "";
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["hide"] = data_element__?.props?.items[element]?.hide ?? "false";
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["errorMessage"] = data_element__?.props?.items[element]?.errorMessage ?? "";
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["roi_page_id"] = data[i].roi_page_id;
                            roi_global_arr[data_element__?.props?.items[element]?.uuid]["checkbox_id"] = data_element__?.props?.uuid;
                            const checkboxFieldId = data_element__?.props?.ID;
                            if (checkboxFieldId) {
                              roi_global_arr[data_element__?.props?.items[element]?.uuid]["fieldId"] =
                                checkboxFieldId;
                            }
                          }
                        }
                      );
                      const checkboxFieldId = data_element__?.props?.ID;
                      const checkboxItems = data_element__?.props?.items;
                      if (checkboxFieldId && checkboxItems) {
                        const firstItem =
                          Array.isArray(checkboxItems)
                            ? checkboxItems[0]
                            : checkboxItems[Object.keys(checkboxItems)[0]];
                        const firstUuid = firstItem?.uuid;
                        if (firstUuid && roi_global_arr[firstUuid]) {
                          roi_global_arr[`${checkboxFieldId}-0`] = {
                            ...roi_global_arr[firstUuid],
                            type: "Checkbox Option",
                            fieldId: checkboxFieldId,
                            logicOptionUuid: firstUuid,
                          };
                        }
                      }
                    }

                    if (data_element__?.type === "Radio") {
                      // Object.keys(data_element__?.props?.items).forEach(
                      //(element, index) => {
                      if (data_element__?.props?.uuid != undefined) {
                        roi_global_arr[data_element__?.props?.uuid] = {};
                        roi_global_arr[data_element__?.props?.uuid]["currency"] =
                          data_element__?.props?.prefix ==
                            "currency" ||
                            data_element__?.props?.prefix ==
                            "Currency" ||
                            data_element__?.props?.Prefix ==
                            "currency" ||
                            data_element__?.props?.Prefix ==
                            "Currency"
                            ? "1"
                            : "0";
                        roi_global_arr[data_element__?.props?.uuid]["count"] = 0;
                        roi_global_arr[data_element__?.props?.uuid]["required"] = data_element__?.props?.required ?? false;
                        roi_global_arr[data_element__?.props?.uuid]["actions"] = data_element__?.props?.buttonAction ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["action_id"] =
                        puckButtonTargetId(data_element__?.props);
                        roi_global_arr[data_element__?.props?.uuid]["link"] = data_element__?.props?.buttonLink ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["value"] =
                          resolveRadioGroupValue(data_element__?.props) || "";
                        roi_global_arr[data_element__?.props?.uuid]["default_value"] =
                          data_element__?.props?.default_value ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["type"] = "Radio";
                        roi_global_arr[data_element__?.props?.uuid]["hide"] = data_element__?.props?.hide ?? "false";
                        roi_global_arr[data_element__?.props?.uuid]["errorMessage"] = data_element__?.props?.errorMessage ?? "";
                        roi_global_arr[data_element__?.props?.uuid]["roi_page_id"] = data[i].roi_page_id;
                      }
                      //}
                      //);
                    }

                    // Auto variables for DoubleBarChart (Label string and Series B numeric)
                    if (data_element__?.type === 'DoubleBarChart') {
                      console.log('data_element__?.type', data_element__?.type);
                      const rows = data_element__?.props?.Data || [];
                      const chartId = data_element__?.props?.id || 'DoubleBarChart';
                      rows.forEach((row, idx) => {
                        const fallbackLabel = row && typeof row.Label === 'string' && row.Label.trim() !== ''
                          ? row.Label.trim()
                          : `Bar ${idx + 1}`;
                        const labelKey = (row && row.LabelUuid) ? row.LabelUuid : `${chartId}-row-${idx}-label`;
                        const bKey = (row && row.BUuid) ? row.BUuid : `${chartId}-row-${idx}-b`;
                        const labelSlug = fallbackLabel
                          .toString()
                          .trim()
                          .replace(/\s+/g, '_')
                          .replace(/[^a-zA-Z0-9_]/g, '')
                          .toLowerCase();

                        // Human-readable variable names that avoid duplicates across charts
                        const categoryKeyNamed = `${chartId}-${labelSlug}-category`;
                        const firstKeyNamed = `${chartId}-${labelSlug}-first_bar_value`;
                        const secondKeyNamed = `${chartId}-${labelSlug}-second_bar_value`;
                        // Label variable (string)
                        if (labelKey) {
                          roi_global_arr[row.LabelUuid] = {};
                          roi_global_arr[row.LabelUuid]["currency"] = '0';
                          roi_global_arr[row.LabelUuid]["count"] = 0;
                          roi_global_arr[row.LabelUuid]["required"] = false;
                          roi_global_arr[row.LabelUuid]["type"] = 'DoubleBarChart-Label';
                          roi_global_arr[row.LabelUuid]["actions"] = '';
                          roi_global_arr[row.LabelUuid]["action_id"] = '';
                          roi_global_arr[row.LabelUuid]["link"] = '';
                          roi_global_arr[labelKey] = roi_global_arr[row.LabelUuid];
                          roi_global_arr[labelKey]["value"] = fallbackLabel;
                          roi_global_arr[row.LabelUuid]["default_value"] = '';
                          roi_global_arr[row.LabelUuid]["roi_page_id"] = data[i].roi_page_id;
                          roi_global_arr[labelKey]["text"] = fallbackLabel;
                          roi_global_arr[labelKey]["name"] = fallbackLabel;
                          roi_global_arr[row.LabelUuid]['variable_data_type'] = 'string';

                          // Also create a descriptive category variable name
                          roi_global_arr[categoryKeyNamed] = {
                            currency: '0',
                            count: 0,
                            required: false,
                            type: 'DoubleBarChart-Label',
                            actions: '',
                            action_id: '',
                            link: '',
                            value: fallbackLabel,
                            default_value: '',
                            roi_page_id: data[i].roi_page_id,
                            text: `${fallbackLabel} Category`,
                            variable_data_type: 'string',
                          };
                        }

                        // Series B value (number)
                        if (bKey) {
                          const numericB = parseFloat(row?.B ?? 0) || 0;
                          roi_global_arr[row.BUuid] = {};
                          roi_global_arr[row.BUuid]["currency"] = '0';
                          roi_global_arr[row.BUuid]["count"] = 0;
                          roi_global_arr[row.BUuid]["required"] = false;
                          roi_global_arr[row.BUuid]["type"] = 'DoubleBarChart-B';
                          roi_global_arr[row.BUuid]["actions"] = '';
                          roi_global_arr[row.BUuid]["action_id"] = '';
                          roi_global_arr[row.BUuid]["link"] = '';
                          roi_global_arr[bKey] = roi_global_arr[row.BUuid];
                          roi_global_arr[bKey]["value"] = numericB;
                          roi_global_arr[row.BUuid]["default_value"] = '';
                          roi_global_arr[row.BUuid]["roi_page_id"] = data[i].roi_page_id;
                          roi_global_arr[bKey]["text"] = `${(data_element__?.props?.SeriesBName) || 'Series B'} - ${fallbackLabel}`;
                          roi_global_arr[row.BUuid]['variable_data_type'] = 'number';

                          // Alias variable with label name storing numeric value
                          if (labelSlug) {
                            roi_global_arr[labelSlug] = {
                              currency: '0',
                              count: 0,
                              required: false,
                              type: 'DoubleBarChart-B',
                              actions: '',
                              action_id: '',
                              link: '',
                              value: numericB,
                              default_value: '',
                              roi_page_id: data[i].roi_page_id,
                              text: fallbackLabel,
                              name: fallbackLabel,
                              variable_data_type: 'number',
                            };
                          }

                          // Named second bar variable
                          roi_global_arr[secondKeyNamed] = {
                            currency: '0',
                            count: 0,
                            required: false,
                            type: 'DoubleBarChart-B',
                            actions: '',
                            action_id: '',
                            link: '',
                            value: numericB,
                            default_value: '',
                            roi_page_id: data[i].roi_page_id,
                            text: `${fallbackLabel} Second bar Value`,
                            name: `${fallbackLabel} Second bar Value`,
                            variable_data_type: 'number',
                          };
                        }

                        // First bar value (Series A)
                        const numericA = parseFloat(row?.A ?? 0) || 0;
                        roi_global_arr[firstKeyNamed] = {
                          currency: '0',
                          count: 0,
                          required: false,
                          type: 'DoubleBarChart-A',
                          actions: '',
                          action_id: '',
                          link: '',
                          value: numericA,
                          default_value: '',
                          roi_page_id: data[i].roi_page_id,
                          text: `${fallbackLabel} First bar Value`,
                          name: `${fallbackLabel} First bar Value`,
                          variable_data_type: 'number',
                        }
                      });
                    }
                  }
                  if (
                    data_element__?.props?.uuid == undefined &&
                    data_element__?.props?.items != undefined
                  ) {
                    Object.keys(data_element__?.props?.items).forEach(
                      (element, index) => {
                        if (
                          data_element__?.props?.items[element]?.uuid !=
                          undefined
                        ) {
                          //this will also work in case of button in card section

                          roi_global_arr[data_element__?.props?.items[element]?.uuid] = {};
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["currency"] = data_element__?.props?.items[element]?.prefix == "currency" || data_element__?.props?.items[element]?.prefix == "Currency" ? "1" : "0";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["count"] = 0;
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["actions"] = data_element__?.props?.items[element]?.buttonAction ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["action_id"] =
                            puckButtonTargetId(data_element__?.props?.items[element]);
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["link"] = data_element__?.props?.items[element]?.buttonLink ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["value"] = data_element__?.props?.items[element]?.value ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["default_value"] = data_element__?.props?.items[element]?.default_value ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["hide"] = data_element__?.props?.items[element]?.hide ?? "false";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["errorMessage"] = data_element__?.props?.items[element]?.errorMessage ?? "";
                          roi_global_arr[data_element__?.props?.items[element]?.uuid]["roi_page_id"] = data[i].roi_page_id;
                        }

                        if (
                          data_element__?.props?.items[element]?.uuid ==
                          undefined &&
                          (data_element__?.type === "DownloadReportTable" ||
                            data_element__?.type === "ReportTable")
                        ) {
                          Object.keys(
                            data_element__?.props?.items[element]
                          ).forEach((element_, index_) => {
                            let cols_count =
                              data_element__?.props?.Table.Columns;
                            for (let i = 1; i <= cols_count; i++) {
                              if (
                                data_element__?.props?.items[element]?.["Cell" + i + "uuid"] != undefined
                              ) {
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]] = {};
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]]["currency"] = data_element__?.props?.items[element]?.["Cell" + i + "EditStyle"] == "Currency" || data_element__?.props?.items[element]?.["Cell" + i + "EditStyle"] == "currency" ? "1" : "0";
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]]["count"] = 0;
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]]["actions"] = data_element__?.props?.items[element]?.["Cell" + i + "Action"] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]]["action_id"] = data_element__?.props?.items[element]?.["Cell" + i + "ActionId"] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]]["link"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]]["value"] = data_element__?.props?.items[element]?.["Cell" + i + "Data"] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]]["default_value"] = data_element__?.props?.items[element]?.["Cell" + i + "Data"] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]]["hide"] = data_element__?.props?.items[element]?.["Cell" + i + "Hide"] ?? "false";
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]]["errorMessage"] = data_element__?.props?.items[element]?.["Cell" + i + "Error"] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Cell" + i + "uuid"]]["roi_page_id"] = data[i].roi_page_id;
                              }
                            }
                          });
                        }

                        if (
                          data_element__?.props?.items[element]?.Value1 !=
                          undefined &&
                          data_element__?.type === "CardSection"
                        ) {
                          Object.keys(
                            data_element__?.props?.items[element]
                          ).forEach((element_, index_) => {
                            for (let i = 1; i <= 4; i++) {
                              if (
                                data_element__?.props?.items[element]?.["Value" + i + "uuid"] != undefined
                              ) {
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]] = {};
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["currency"] = "1";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["count"] = 0;
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["actions"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["action_id"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["link"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["value"] = data_element__?.props?.items[element]?.["Value" + i] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["default_value"] = "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["hide"] = data_element__?.props?.items[element]?.["Value" + i + "Hide"] ?? "false";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["errorMessage"] = data_element__?.props?.items[element]?.["Value" + i + "Error"] ?? "";
                                roi_global_arr[data_element__?.props?.items[element]?.["Value" + i + "uuid"]]["roi_page_id"] = data[i].roi_page_id;
                              }
                            }
                          });
                        }
                      }
                    );
                  }

                  if (
                    data_element__?.props?.uuid == undefined &&
                    data_element__?.props?.items == undefined
                  ) {
                    if (data_element__?.type === "ResultCard") {
                      Object.keys(data_element__?.props).forEach(
                        (element, index) => {
                          if (
                            data_element__?.props?.[element]?.uuid != undefined
                          ) {
                            roi_global_arr[data_element__?.props?.[element]?.uuid] = {};
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["currency"] = "1";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["count"] = 0;
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["actions"] = data_element__?.props?.[element]?.buttonAction ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["action_id"] =
                              puckButtonTargetId(data_element__?.props?.[element]);
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["link"] = data_element__?.props?.[element]?.buttonLink ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["value"] = data_element__?.props?.[element]?.value ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["default_value"] = data_element__?.props?.[element]?.default_value ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["hide"] = data_element__?.props?.[element]?.hide ?? "false";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["errorMessage"] = data_element__?.props?.[element]?.errorMessage ?? "";
                            roi_global_arr[data_element__?.props?.[element]?.uuid]["roi_page_id"] = data[i].roi_page_id;
                          }
                        }
                      );
                    }
                  }

                  if (data_element__?.type === "ChartCard" || data_element__?.type === "eCharts") {
                    let props = data_element__?.props;
                    Object.keys(props).forEach((element, index) => {
                      if (
                        props[element]?.uuid != undefined &&
                        (props[element]?.chooseChart == "pie" ||
                          props[element]?.chooseChart == "bar")
                      ) {
                        for (
                          let i = 0;
                          i < props[element]?.items?.length;
                          i++
                        ) {
                          roi_global_arr[props[element]?.items[i].uuid] = {};
                          roi_global_arr[props[element]?.items[i].uuid]["currency"] = "1";
                          roi_global_arr[props[element]?.items[i].uuid]["count"] = 0;
                          roi_global_arr[props[element]?.items[i].uuid]["actions"] = props[element]?.items[i].buttonAction ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["action_id"] =
                            puckButtonTargetId(props[element]?.items[i]);
                          roi_global_arr[props[element]?.items[i].uuid]["link"] = props[element]?.items[i].buttonLink ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["value"] = props[element]?.items[i].Data ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["default_value"] = props[element]?.items[i].default_value ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["hide"] = props[element]?.items[i].hide ?? "false";
                          roi_global_arr[props[element]?.items[i].uuid]["errorMessage"] = props[element]?.items[i].errorMessage ?? "";
                          roi_global_arr[props[element]?.items[i].uuid]["roi_page_id"] = data[i].roi_page_id;
                        }
                      }
                    });
                  }
              });
            });
          }
          // console.log("=== DEBUG: roi_content (pages) ===");
          // console.log("Available page IDs:", Object.keys(roi_content));
          // console.log("Looking for page 5264b830-8237-11f0-ae7e-ed4b67a3e229:", roi_content["5264b830-8237-11f0-ae7e-ed4b67a3e229"]);
          roipages.current = roi_content;


          const responseCustomVariables = await fetch(
            `${apiUrl}/roi-custom-variables/list/${roiId}`
          );
          const dataCustomVariables = await responseCustomVariables.json();
          if (dataCustomVariables.result == "success") {
            let customVariablesArray = dataCustomVariables.data;
            for (let i = 0; i < customVariablesArray.length; i++) {
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id] =
                {};
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["currency"] = customVariablesArray[i].roi_custom_variable_type == "currency" ? "1" : "0";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["count"] = 0;
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["actions"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["action_id"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["link"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["value"] = customVariablesArray[i].roi_custom_variable_value;
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["default_value"] = "";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["hide"] = "false";
              roi_global_arr[customVariablesArray[i].roi_custom_variable_id]["errorMessage"] = "";
            }
          }

          // setRoiActionArr(roi_global_arr);
          // console.log("=== DEBUG: roi_global_arr before setting to roiActionArr_global ===");
          // console.log("Looking for UUID 5264b830-8237-11f0-ae7e-ed4b67a3e229:", roi_global_arr["5264b830-8237-11f0-ae7e-ed4b67a3e229"]);
          // console.log("All UUIDs in roi_global_arr:", Object.keys(roi_global_arr));
          registerDisplaySpanVariables(roi_global_arr, roi_content);
          roiActionArr_global.current = roi_global_arr;


          Object.keys(roi_global_arr).forEach((element, index) => {
            if (elements_by_page_id.current[roi_global_arr[element]["roi_page_id"]] === undefined) {
              elements_by_page_id.current[roi_global_arr[element]["roi_page_id"]] = [];
            }
            elements_by_page_id.current[roi_global_arr[element]["roi_page_id"]].push(element);
          });

          initialRender();
          setRenderData(parsedRenderData);
        } catch (error) {
          console.error(error);
        }

        // getting all condtional logic api call
        try {
          const conditionalLogics_response = await fetch(
            `${apiUrl}/roi-calculated-fields/list/${roiId}`
          );
          const json_conditionalLogics_response =
            await conditionalLogics_response.json();

          if (json_conditionalLogics_response.result == "success") {
            let data = json_conditionalLogics_response.data;

            const roiCalculationLogic = {};
            let count = 0;
            Object.keys(data).forEach((element, index) => {
              if (
                data[element].roi_calculation_logic != undefined &&
                data[element].roi_calculation_logic != null
              ) {
                const data__ = JSON.parse(data[element].roi_calculation_logic);

                if (data__.when && !Array.isArray(data__.when) && typeof data__.when === "object") {
                  data__.when = Object.keys(data__.when)
                    .sort((a, b) => Number(a) - Number(b))
                    .map((k) => data__.when[k]);
                }
                if (data__.then && !Array.isArray(data__.then) && typeof data__.then === "object") {
                  data__.then = Object.keys(data__.then)
                    .sort((a, b) => Number(a) - Number(b))
                    .map((k) => data__.then[k]);
                }

                if (data__["when"].length == 1) {
                  data__["when_and_or_operator"] = "";
                }

                if (
                  (data__["when"].length > 1 &&
                    data__["when_and_or_operator"] == undefined) ||
                  data__["when_and_or_operator"] == null
                ) {
                  data__["when_and_or_operator"] = "AND";
                }

                if (roiCalculationLogic[data[element].roi_calculated_field_id] === undefined) {
                  roiCalculationLogic[data[element].roi_calculated_field_id] = [];
                }

                data__["logic_name"] = data[element].roi_logic_name;

                roiCalculationLogic[data[element].roi_calculated_field_id].push(
                  data__
                );
                // count++;
                // }
              }
            });
            // setAllConditionalLogicData(roiCalculationLogic);
            allCondtionalLogicData.current = roiCalculationLogic;
          }
        } catch (error) {
          console.error(error);
        }

        try {
          const initialCalc = await processLogic();
          renderChanges({}, {}, initialCalc || {});
        } catch (logicErr) {
          console.error("Initial ROI calculation pass failed:", logicErr);
        }

        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setIsLoading(false);
      }
    };
    fetchData();
  }, [apiUrl, roiId]);

  // Debounce function with useCallback
  // const debouncedOnChange = useMemo(
  //   () => debounce(handleChange, 1000),
  //   [handleChange]
  // );


  if (isLoading) {
    return <div>Loading...</div>;
  }

  const renderDataBlock = () => {
    return (
      <>
        <div data-roi-render-ready="true" style={{ display: "contents" }}><Render config={config} data={renderData} /></div>

        <div
          className="modal fade logo-prompt"
          id="logoPrompt"
          tabIndex={-1}
          aria-labelledby="logoPromptLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-body">
                <div className="heading">
                  <h3>Return to home page?</h3>
                  <p>You will have to complete the steps again.</p>
                </div>

                <div className="modal-buttons d-flex justify-content-end">
                  <button
                    type="button"
                    className="btn btn-bordered color-cancel"
                    data-bs-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary ms-3"
                    onClick={homeRedirect}
                  >
                    Confirm
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const renderModalDataBlock = () => {
    return <Render config={config} data={renderModalData} />;
  };

  // Helper function to parse HTML and replace dynamic spans
  const parseDynamicText = (htmlString) => {
    if (!htmlString || typeof htmlString !== 'string') {
      return htmlString;
    }

    try {
      // console.log('Parsing dynamic text:', htmlString);

      // Create a temporary DOM element to parse the HTML
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = htmlString;

      // Function to recursively process nodes and replace dynamic spans
      // Note: Multiple spans can use the same UUID to show the same value
      // React keys are made unique by appending random values
      const processNode = (node) => {
        if (node.nodeType === Node.ELEMENT_NODE) {
          if (node.tagName.toLowerCase() === 'span' && node.getAttribute('uuid')) {
            const uuid = node.getAttribute('uuid');
            const style = node.getAttribute('style') || '';
            const className = node.getAttribute('class') || '';

            // Debug: Print the entire roiActionArr_global.current object
            // console.log('=== DEBUG: roiActionArr_global.current ===');
            // console.log('Full object:', roiActionArr_global.current);
            // console.log('Current UUID being processed:', uuid);
            // console.log('Value for this UUID:', roiActionArr_global.current[uuid]);
            // console.log('Value property:', roiActionArr_global.current[uuid]?.value);
            // console.log('==========================================');

            // Parse styles safely
            const parsedStyles = parseInlineStyles(style);

            // Ensure we have a valid style object
            const finalStyles = parsedStyles && typeof parsedStyles === 'object' ? parsedStyles : {};

            // Create a dynamic span component
            // Generate unique key for React while keeping the same UUID for value lookup
            const uniqueKey = `${uuid}-${Math.random()}`;
            const stored = roiActionArr_global.current[uuid]?.value;
            const scale = Number(node.getAttribute('data-display-scale'));
            const decimals = Number(node.getAttribute('data-display-decimals'));
            const hasDisplayFormat = node.hasAttribute('data-display-scale') && node.hasAttribute('data-display-decimals') && Number.isFinite(scale) && Number.isInteger(decimals) && decimals >= 0 && decimals <= 12;
            const display = hasDisplayFormat
              ? (stored != null && stored !== '' && Number.isFinite(Number(stored)) ? (node.getAttribute('data-display-prefix')||'') + (node.getAttribute('data-display-grouping') === 'true' ? (Number(stored) * scale).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : (Number(stored) * scale).toFixed(decimals)) + (node.getAttribute('data-display-suffix')||'') : String(stored ?? '—'))
              : formatNumericValue(stored) || '0';

            return (
              <span
                key={uniqueKey}
                style={finalStyles}
                className={`dynamic-inline-span ${className || ''}`}
              >
                {display}
              </span>
            );
          } else {
            // Process child nodes recursively
            const children = Array.from(node.childNodes).map((child, childIndex) =>
              processNode(child)
            );

            // Create a new element with the same tag and attributes
            const attributes = Array.from(node.attributes).reduce((attrs, attr) => {
              if (attr.name !== 'uuid') { // Don't pass uuid attribute
                if (attr.name === 'style') {
                  // Parse style attribute for all elements
                  const parsedStyles = parseInlineStyles(attr.value);
                  // console.log('Parsed styles for', node.tagName, ':', parsedStyles);
                  if (parsedStyles && typeof parsedStyles === 'object') {
                    attrs.style = parsedStyles;
                  }
                } else if (attr.name === 'class') {
                  // Convert class to className for React
                  attrs.className = attr.value;
                } else {
                  attrs[attr.name] = attr.value;
                }
              }
              return attrs;
            }, {});

            // console.log('Creating element with attributes:', attributes);

            const newElement = React.createElement(
              node.tagName.toLowerCase(),
              {
                key: `node-${Math.random()}`, // Use unique key instead of undefined index
                ...attributes
              },
              ...children
            );

            return newElement;
          }
        } else if (node.nodeType === Node.TEXT_NODE) {
          return node.textContent;
        }

        return null;
      };

      // Process all child nodes
      const processedChildren = Array.from(tempDiv.childNodes).map((child, index) =>
        processNode(child)
      );

      return processedChildren;
    } catch (error) {
      console.error('Error parsing dynamic text:', error);
      return htmlString; // Fallback to original text if parsing fails
    }
  };

  // Helper function to parse inline styles
  const parseInlineStyles = (styleString) => {
    if (!styleString || typeof styleString !== 'string') return {};

    try {
      // console.log('Parsing style string:', styleString);
      const styles = {};
      const stylePairs = styleString.split(';').filter(pair => pair.trim());

      stylePairs.forEach(pair => {
        const colonIndex = pair.indexOf(':');
        if (colonIndex > 0) {
          const property = pair.substring(0, colonIndex).trim();
          const value = pair.substring(colonIndex + 1).trim();

          if (property && value) {
            // Convert CSS property names to camelCase
            const camelProperty = property.replace(/-([a-z])/g, (g) => g[1].toUpperCase());
            // Only add valid CSS properties
            if (camelProperty && value) {
              styles[camelProperty] = value;
              // console.log('Added style:', camelProperty, '=', value);
            }
          }
        }
      });

      // console.log('Final parsed styles:', styles);
      return styles;
    } catch (error) {
      console.error('Error parsing inline styles:', error);
      return {}; // Return empty object on error
    }
  };

  return (
    <>
      <ToastContainer />

      {/* Full Screen Loader for Report Download */}
      {isLoadingdownload && (
        <div
          className="fullscreen-loader"
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0, 0, 0, 0.7)",
            zIndex: 99999,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "20px",
          }}
        >
          <div
            className="spinner-border text-light"
            role="status"
            style={{
              width: "60px",
              height: "60px",
              borderWidth: "5px",
            }}
          >
            <span className="visually-hidden">Loading...</span>
          </div>
          <p
            style={{
              color: "#fff",
              fontSize: "18px",
              fontWeight: "500",
              margin: 0,
            }}
          >
            Report is being generated and will take a few moments to download.
          </p>
        </div>
      )}

      {/* Token Missing / Sign In Popup */}
      <div
        className="token-missing-wrap went-wrong-wrap"
        id="token-missing-wrap"
        style={{
          display: "none",
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 9999,
          justifyContent: "center",
          alignItems: "center",
        }}
        onClick={(e) => {
          // Close popup when clicking backdrop
          if (e.target.id === "token-missing-wrap") {
            e.target.style.display = "none";
          }
        }}
      >
        <div
          className="action-popup"
          style={{
            backgroundColor: "#fff",
            borderRadius: "12px",
            padding: "40px 50px",
            textAlign: "center",
            maxWidth: "500px",
            width: "90%",
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
          }}
        >
          <div
            className="icon-container"
            style={{
              width: "80px",
              height: "80px",
              borderRadius: "50%",
              backgroundColor: "#3B8FC2",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              margin: "0 auto 20px",
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="43"
              height="43"
              viewBox="0 0 43 43"
              fill="none"
            >
              <path
                d="M29.5625 18.8125V12.0937C29.5625 9.95544 28.7131 7.90471 27.201 6.3927C25.689 4.88069 23.6383 4.03125 21.5 4.03125C19.3617 4.03125 17.311 4.88069 15.799 6.3927C14.2869 7.90471 13.4375 9.95544 13.4375 12.0937V18.8125M12.0937 38.9687H30.9062C31.9754 38.9687 33.0008 38.544 33.7568 37.788C34.5128 37.032 34.9375 36.0067 34.9375 34.9375V22.8437C34.9375 21.7746 34.5128 20.7492 33.7568 19.9932C33.0008 19.2372 31.9754 18.8125 30.9062 18.8125H12.0937C11.0246 18.8125 9.99923 19.2372 9.24323 19.9932C8.48722 20.7492 8.0625 21.7746 8.0625 22.8437V34.9375C8.0625 36.0067 8.48722 37.032 9.24323 37.788C9.99923 38.544 11.0246 38.9687 12.0937 38.9687Z"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h3
            style={{
              color: "#3B8FC2",
              fontSize: "28px",
              fontWeight: "600",
              marginBottom: "15px",
            }}
          >
            One Step Away
          </h3>
          <p
            style={{
              color: "#666",
              fontSize: "16px",
              lineHeight: "1.6",
              marginBottom: "25px",
            }}
          >
            Sign up or login to access assessments, calculators, demos, trials,
            and your personalised concierge — all fine-tuned to your
            transformation goals.
          </p>
          <div className="buttons-action">
            <div
              id="action-no-sign-up"
              className="action-button no-btn"
              style={{
                backgroundColor: "#3B8FC2",
                color: "#fff",
                padding: "15px 40px",
                borderRadius: "8px",
                fontSize: "16px",
                fontWeight: "600",
                cursor: "pointer",
                display: "inline-block",
              }}
              onClick={() => {
                // Redirect to sign-in page or open sign-in modal
                // You can customize this URL
                //alert(process.env.REACT_APP_TATA_LOGIN_URL);
                window.location.href = process.env.REACT_APP_TATA_LOGIN_URL;
              }}
            >
              Sign In & Explore
            </div>
          </div>
        </div>
      </div>

      {renderData !== null && allCondtionalLogicData.current !== null ? (
        renderDataBlock()
      ) : (
        <div>Loading...</div>
      )}

      <div
        className="modal fade modal-report"
        id="reportModal"
        tabIndex={-1}
        aria-labelledby="reportModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-fullscreen">
          <div className="modal-content">
            {renderModalData !== null && allCondtionalLogicData.current !== null ? (
              renderModalDataBlock()
            ) : (
              <div>Loading...</div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ROIPage;
